// Source:
// Towns with long/lat => https://developers.google.com/public-data/docs/canonical/towns_csv
// Towns images => https://github.com/djaiss/mapsicon
// Town area => https://github.com/samayo/town-json/blob/master/src/town-by-surface-area.json

const townCodesWithImage = [
  "46001",
  "46002",
  "03002",
  "03003",
  "46004",
  "46042",
  "46043",
  "03004",
  "12002",
  "46005",
  "46006",
  "46007",
  "46008",
  "46009",
  "46010",
  "03005",
  "46011",
  "12003",
  "46012",
  "46013",
  "46014",
  "12004",
  "03006",
  "46016",
  "46015",
  "03007",
  "03008",
  "12005",
  "03009",
  "46018",
  "46020",
  "12006",
  "46019",
  "46021",
  "46022",
  "03010",
  "46024",
  "46025",
  "46026",
  "46027",
  "03011",
  "46023",
  "12007",
  "46028",
  "46029",
  "46030",
  "12008",
  "46031",
  "03012",
  "03013",
  "03014",
  "46032",
  "12009",
  "12010",
  "12011",
  "46033",
  "46034",
  "03015",
  "03016",
  "46035",
  "46036",
  "03017",
  "46037",
  "12901",
  "03018",
  "12012",
  "46017",
  "46038",
  "46039",
  "46040",
  "12013",
  "46041",
  "12014",
  "12015",
  "12016",
  "03019",
  "46003",
  "12001",
  "03001",
  "12017",
  "46044",
  "12018",
  "03020",
  "03021",
  "12020",
  "46046",
  "46045",
  "12022",
  "46047",
  "46048",
  "46049",
  "12024",
  "12025",
  "46050",
  "46051",
  "03022",
  "12026",
  "46052",
  "03023",
  "46053",
  "03024",
  "46054",
  "03025",
  "03026",
  "03027",
  "46055",
  "03028",
  "46056",
  "12027",
  "12028",
  "46057",
  "46904",
  "03030",
  "03031",
  "46060",
  "46059",
  "46058",
  "03032",
  "03033",
  "46061",
  "46062",
  "03029",
  "03034",
  "03035",
  "03036",
  "03037",
  "03038",
  "03039",
  "03040",
  "46063",
  "46064",
  "46065",
  "46066",
  "03041",
  "46067",
  "46068",
  "46069",
  "03042",
  "12029",
  "46070",
  "12021",
  "03043",
  "46071",
  "03044",
  "46072",
  "46073",
  "03045",
  "46074",
  "12032",
  "12031",
  "46075",
  "46076",
  "46077",
  "46078",
  "03046",
  "12033",
  "12034",
  "46079",
  "03048",
  "03049",
  "03047",
  "03050",
  "03051",
  "46080",
  "46081",
  "46082",
  "12036",
  "03052",
  "46083",
  "46084",
  "46085",
  "46086",
  "46087",
  "46088",
  "46089",
  "03053",
  "12037",
  "03054",
  "03075",
  "12038",
  "12039",
  "12040",
  "46090",
  "46091",
  "46092",
  "12041",
  "46093",
  "46094",
  "12042",
  "03055",
  "46095",
  "12043",
  "46096",
  "12044",
  "46107",
  "46106",
  "46108",
  "46109",
  "12053",
  "46111",
  "12055",
  "12056",
  "46112",
  "12045",
  "12046",
  "03056",
  "46097",
  "03057",
  "46098",
  "12048",
  "46099",
  "12049",
  "46100",
  "12050",
  "03058",
  "03059",
  "12051",
  "46105",
  "46113",
  "03061",
  "03062",
  "03063",
  "03064",
  "46114",
  "46115",
  "03065",
  "03066",
  "46116",
  "46117",
  "46118",
  "46119",
  "12057",
  "12058",
  "46120",
  "46121",
  "03067",
  "03068",
  "12059",
  "46122",
  "46123",
  "12060",
  "03069",
  "46126",
  "03077",
  "46127",
  "46128",
  "46124",
  "12061",
  "03070",
  "46125",
  "12063",
  "46129",
  "12064",
  "03072",
  "12065",
  "46131",
  "03071",
  "46902",
  "46130",
  "12067",
  "46132",
  "46133",
  "46134",
  "46135",
  "46136",
  "03073",
  "46137",
  "03074",
  "46138",
  "46139",
  "46140",
  "03076",
  "12068",
  "12069",
  "46141",
  "03078",
  "03079",
  "03080",
  "46142",
  "12070",
  "46144",
  "03082",
  "12071",
  "03083",
  "46154",
  "46155",
  "03085",
  "46147",
  "46151",
  "46152",
  "46153",
  "46156",
  "46157",
  "12074",
  "12072",
  "46150",
  "03084",
  "46148",
  "46149",
  "12073",
  "46158",
  "46159",
  "46160",
  "46161",
  "46162",
  "46163",
  "46164",
  "46165",
  "12075",
  "12076",
  "46166",
  "46167",
  "03086",
  "46168",
  "46169",
  "46170",
  "46171",
  "12077",
  "03088",
  "03089",
  "12078",
  "12079",
  "46173",
  "46174",
  "03903",
  "46175",
  "46176",
  "46172",
  "12080",
  "03091",
  "03092",
  "46177",
  "03090",
  "46178",
  "12081",
  "46179",
  "03093",
  "46180",
  "03094",
  "12082",
  "46181",
  "46183",
  "46182",
  "12083",
  "12084",
  "03095",
  "03096",
  "46184",
  "03097",
  "03099",
  "12085",
  "03098",
  "46185",
  "46186",
  "12087",
  "46187",
  "46188",
  "46189",
  "03100",
  "46190",
  "12088",
  "46191",
  "03101",
  "03102",
  "03103",
  "12089",
  "03104",
  "46192",
  "46193",
  "46194",
  "03902",
  "46195",
  "12090",
  "46196",
  "03105",
  "03106",
  "12093",
  "46199",
  "46202",
  "46200",
  "46203",
  "12094",
  "03901",
  "46197",
  "03107",
  "12091",
  "46198",
  "46205",
  "12092",
  "46201",
  "46204",
  "46101",
  "46102",
  "46103",
  "46104",
  "03060",
  "46206",
  "03109",
  "46207",
  "46208",
  "46209",
  "03110",
  "46210",
  "46212",
  "46211",
  "03111",
  "03112",
  "46213",
  "46214",
  "12095",
  "46215",
  "46216",
  "03113",
  "03114",
  "12096",
  "46217",
  "46218",
  "46219",
  "12097",
  "03115",
  "46220",
  "46221",
  "03116",
  "12098",
  "46903",
  "03118",
  "03904",
  "03120",
  "12101",
  "03122",
  "03117",
  "03119",
  "12902",
  "46222",
  "12099",
  "12100",
  "12102",
  "03121",
  "03123",
  "46223",
  "46224",
  "12104",
  "03124",
  "46225",
  "46226",
  "03125",
  "46227",
  "46228",
  "12103",
  "12105",
  "46229",
  "46230",
  "46231",
  "46232",
  "46233",
  "12106",
  "46234",
  "12107",
  "46235",
  "12108",
  "46236",
  "12109",
  "03127",
  "46237",
  "46238",
  "12110",
  "46239",
  "46240",
  "03128",
  "03129",
  "12111",
  "46241",
  "12112",
  "12113",
  "03130",
  "12114",
  "03131",
  "12115",
  "12116",
  "12119",
  "12120",
  "46242",
  "12117",
  "12118",
  "46243",
  "03132",
  "46244",
  "46245",
  "03133",
  "46246",
  "12121",
  "46247",
  "46248",
  "12122",
  "46249",
  "46250",
  "12124",
  "03134",
  "03135",
  "12126",
  "12125",
  "03136",
  "03137",
  "46251",
  "46252",
  "12123",
  "46253",
  "12127",
  "46254",
  "03138",
  "12135",
  "12128",
  "12129",
  "46255",
  "46256",
  "12132",
  "12134",
  "12136",
  "12130",
  "03139",
  "12131",
  "46257",
  "12133",
  "46258",
  "46259",
  "03140",
  "12137",
  "46260",
  "12138",
  "12139",
  "12140",
  "03081",
  "46145",
  "46143",
  "46146",
  "12052",
  "46110",
  "46261",
  "46262",
  "46263",
  "12141",
  "12142"
];

export interface Town {
  code: string;
  latitude: number;
  longitude: number;
  name: string;
  comarca: number;
  gentilici: string;
  poblacio_2025: number;
  poblacio_2024: number;
  poblacio_2023: number;
  poblacio_2022: number;
  poblacio_2021: number;
  poblacio_2008: number;
  poblacio_1996: number;
}

export const towns: Town[] = [

  {
    "code": "46001",
    "latitude": 40.062441181969100,
    "longitude": -1.286328344822920,
    "name": "Ademuz",
    "comarca": 25,
    "gentilici": "ademusser, ademussera",
    "poblacio_2025": 1015,
    "poblacio_2024": 1004,
    "poblacio_2023": 1004,
    "poblacio_2022": 1000,
    "poblacio_2021": 1027,
    "poblacio_2008": 1269,
    "poblacio_1996": 1197
  },
  {
    "code": "46002",
    "latitude": 38.919155229407900,
    "longitude": -0.224931498644446,
    "name": "Ador",
    "comarca": 28,
    "gentilici": "adorer, adorera",
    "poblacio_2025": 1755,
    "poblacio_2024": 1729,
    "poblacio_2023": 1699,
    "poblacio_2022": 1706,
    "poblacio_2021": 1772,
    "poblacio_2008": 1513,
    "poblacio_1996": 1117
  },
  {
    "code": "03002",
    "latitude": 38.438911605138800,
    "longitude": -0.639435457853273,
    "name": "Agost",
    "comarca": 1,
    "gentilici": "agoster, agostera",
    "poblacio_2025": 5225,
    "poblacio_2024": 5107,
    "poblacio_2023": 5067,
    "poblacio_2022": 4948,
    "poblacio_2021": 4906,
    "poblacio_2008": 4813,
    "poblacio_1996": 4017
  },
  {
    "code": "03003",
    "latitude": 38.778445385059200,
    "longitude": -0.516500594785537,
    "name": "Agres",
    "comarca": 14,
    "gentilici": "agresà, agresana",
    "poblacio_2025": 623,
    "poblacio_2024": 610,
    "poblacio_2023": 619,
    "poblacio_2022": 589,
    "poblacio_2021": 580,
    "poblacio_2008": 627,
    "poblacio_1996": 656
  },
  {
    "code": "46004",
    "latitude": 38.821877672238100,
    "longitude": -0.549437697740677,
    "name": "Agullent",
    "comarca": 31,
    "gentilici": "agullentí, agullentina",
    "poblacio_2025": 2438,
    "poblacio_2024": 2416,
    "poblacio_2023": 2400,
    "poblacio_2022": 2361,
    "poblacio_2021": 2369,
    "poblacio_2008": 2418,
    "poblacio_1996": 2205
  },
  {
    "code": "46042",
    "latitude": 38.879061622865900,
    "longitude": -0.588775189638943,
    "name": "Aielo de Malferit",
    "comarca": 31,
    "gentilici": "aieloner, aielonera",
    "poblacio_2025": 4624,
    "poblacio_2024": 4599,
    "poblacio_2023": 4601,
    "poblacio_2022": 4589,
    "poblacio_2021": 4592,
    "poblacio_2008": 4637,
    "poblacio_1996": 3924
  },
  {
    "code": "46043",
    "latitude": 38.881579638214100,
    "longitude": -0.344661169677420,
    "name": "Aielo de Rugat",
    "comarca": 31,
    "gentilici": "aielí, aielina",
    "poblacio_2025": 160,
    "poblacio_2024": 160,
    "poblacio_2023": 163,
    "poblacio_2022": 166,
    "poblacio_2021": 160,
    "poblacio_2008": 188,
    "poblacio_1996": 196
  },
  {
    "code": "03004",
    "latitude": 38.500537966699900,
    "longitude": -0.364071156022175,
    "name": "Aigües",
    "comarca": 1,
    "gentilici": "aigüer, aigüera",
    "poblacio_2025": 1199,
    "poblacio_2024": 1189,
    "poblacio_2023": 1146,
    "poblacio_2022": 1085,
    "poblacio_2021": 1049,
    "poblacio_2008": 1047,
    "poblacio_1996": 544
  },
  {
    "code": "12002",
    "latitude": 39.900101661530900,
    "longitude": -0.341007505410970,
    "name": "Aín",
    "comarca": 22,
    "gentilici": "aïnenc, aïnenca",
    "poblacio_2025": 133,
    "poblacio_2024": 131,
    "poblacio_2023": 130,
    "poblacio_2022": 136,
    "poblacio_2021": 135,
    "poblacio_2008": 145,
    "poblacio_1996": 130
  },
  {
    "code": "46005",
    "latitude": 39.455717295619600,
    "longitude": -0.459167820048025,
    "name": "Alaquàs",
    "comarca": 18,
    "gentilici": "alaquaser, alaquasera",
    "poblacio_2025": 30166,
    "poblacio_2024": 30022,
    "poblacio_2023": 29825,
    "poblacio_2022": 29537,
    "poblacio_2021": 29649,
    "poblacio_2008": 30297,
    "poblacio_1996": 25514
  },
  {
    "code": "46006",
    "latitude": 38.840243374127700,
    "longitude": -0.518891240919727,
    "name": "Albaida",
    "comarca": 31,
    "gentilici": "albaidí, albaidina",
    "poblacio_2025": 6322,
    "poblacio_2024": 6235,
    "poblacio_2023": 6102,
    "poblacio_2022": 5989,
    "poblacio_2021": 5975,
    "poblacio_2008": 6420,
    "poblacio_1996": 5793
  },
  {
    "code": "46007",
    "latitude": 39.396472948869500,
    "longitude": -0.412420356418698,
    "name": "Albal",
    "comarca": 18,
    "gentilici": "albalenc, albalenca",
    "poblacio_2025": 17365,
    "poblacio_2024": 17038,
    "poblacio_2023": 17024,
    "poblacio_2022": 16845,
    "poblacio_2021": 16646,
    "poblacio_2008": 15084,
    "poblacio_1996": 10523
  },
  {
    "code": "46008",
    "latitude": 39.201524369650900,
    "longitude": -0.386543306328855,
    "name": "Albalat de la Ribera",
    "comarca": 27,
    "gentilici": "albalatenc, albalatenca",
    "poblacio_2025": 3523,
    "poblacio_2024": 3446,
    "poblacio_2023": 3411,
    "poblacio_2022": 3444,
    "poblacio_2021": 3368,
    "poblacio_2008": 3541,
    "poblacio_1996": 3473
  },
  {
    "code": "46009",
    "latitude": 39.543174411979900,
    "longitude": -0.346498686695648,
    "name": "Albalat dels Sorells",
    "comarca": 17,
    "gentilici": "albalatà, albalatana",
    "poblacio_2025": 4368,
    "poblacio_2024": 4249,
    "poblacio_2023": 4158,
    "poblacio_2022": 4084,
    "poblacio_2021": 4110,
    "poblacio_2008": 3758,
    "poblacio_1996": 3530
  },
  {
    "code": "46010",
    "latitude": 39.702501262337400,
    "longitude": -0.336879462118005,
    "name": "Albalat dels Tarongers",
    "comarca": 11,
    "gentilici": "albalatenc, albalatenca",
    "poblacio_2025": 1574,
    "poblacio_2024": 1516,
    "poblacio_2023": 1428,
    "poblacio_2022": 1368,
    "poblacio_2021": 1324,
    "poblacio_2008": 1121,
    "poblacio_1996": 651
  },
  {
    "code": "03005",
    "latitude": 38.180412390637800,
    "longitude": -0.867663120245657,
    "name": "Albatera",
    "comarca": 9,
    "gentilici": "albaterà, albaterana",
    "poblacio_2025": 13566,
    "poblacio_2024": 13296,
    "poblacio_2023": 13092,
    "poblacio_2022": 12864,
    "poblacio_2021": 12714,
    "poblacio_2008": 11656,
    "poblacio_1996": 8417
  },
  {
    "code": "46011",
    "latitude": 39.116275631862700,
    "longitude": -0.520815084624927,
    "name": "Alberic",
    "comarca": 26,
    "gentilici": "alberiquer, alberiquera \/ alberiqueny, alberiquenya",
    "poblacio_2025": 11099,
    "poblacio_2024": 10945,
    "poblacio_2023": 10815,
    "poblacio_2022": 10710,
    "poblacio_2021": 10571,
    "poblacio_2008": 10932,
    "poblacio_1996": 9100
  },
  {
    "code": "12003",
    "latitude": 40.356822985250000,
    "longitude": 0.024279651883856,
    "name": "Albocàsser",
    "comarca": 4,
    "gentilici": "albocassí, albocassina \/ bocassí, bocassina",
    "poblacio_2025": 1370,
    "poblacio_2024": 1338,
    "poblacio_2023": 1302,
    "poblacio_2022": 1264,
    "poblacio_2021": 1253,
    "poblacio_2008": 1446,
    "poblacio_1996": 1399
  },
  {
    "code": "46012",
    "latitude": 39.392894867795700,
    "longitude": -0.773963004182377,
    "name": "Alborache",
    "comarca": 16,
    "gentilici": "alborager, alboragera",
    "poblacio_2025": 1568,
    "poblacio_2024": 1471,
    "poblacio_2023": 1389,
    "poblacio_2022": 1328,
    "poblacio_2021": 1283,
    "poblacio_2008": 1107,
    "poblacio_1996": 875
  },
  {
    "code": "46013",
    "latitude": 39.498108315318100,
    "longitude": -0.350464225680472,
    "name": "Alboraia",
    "comarca": 17,
    "gentilici": "alboraier, alboraiera",
    "poblacio_2025": 26273,
    "poblacio_2024": 26259,
    "poblacio_2023": 25792,
    "poblacio_2022": 25149,
    "poblacio_2021": 24904,
    "poblacio_2008": 22174,
    "poblacio_1996": 13127
  },
  {
    "code": "46014",
    "latitude": 39.544543036294600,
    "longitude": -0.323757115472710,
    "name": "Albuixec",
    "comarca": 17,
    "gentilici": "albuixequer, albuixequera",
    "poblacio_2025": 4482,
    "poblacio_2024": 4419,
    "poblacio_2023": 4343,
    "poblacio_2022": 4201,
    "poblacio_2021": 4189,
    "poblacio_2008": 3793,
    "poblacio_1996": 3088
  },
  {
    "code": "12004",
    "latitude": 40.305103492211800,
    "longitude": 0.225110679700844,
    "name": "Alcalà de Xivert",
    "comarca": 8,
    "gentilici": "xivertí, xivertina",
    "poblacio_2025": 7349,
    "poblacio_2024": 7176,
    "poblacio_2023": 7160,
    "poblacio_2022": 6831,
    "poblacio_2021": 6691,
    "poblacio_2008": 7884,
    "poblacio_1996": 4915
  },
  {
    "code": "03006",
    "latitude": 38.749122666199500,
    "longitude": -0.040787415853762,
    "name": "Alcalalí",
    "comarca": 19,
    "gentilici": "alcalalí, alcalalina",
    "poblacio_2025": 1428,
    "poblacio_2024": 1406,
    "poblacio_2023": 1397,
    "poblacio_2022": 1349,
    "poblacio_2021": 1336,
    "poblacio_2008": 1500,
    "poblacio_1996": 842
  },
  {
    "code": "46016",
    "latitude": 39.068891022399800,
    "longitude": -0.561640781431960,
    "name": "Alcàntera de Xúquer",
    "comarca": 26,
    "gentilici": "alcanterí, alcanterina",
    "poblacio_2025": 1468,
    "poblacio_2024": 1425,
    "poblacio_2023": 1414,
    "poblacio_2022": 1427,
    "poblacio_2021": 1402,
    "poblacio_2008": 1446,
    "poblacio_1996": 1492
  },
  {
    "code": "46015",
    "latitude": 39.368211102681400,
    "longitude": -0.444135712758866,
    "name": "Alcàsser",
    "comarca": 18,
    "gentilici": "alcasser, alcassera",
    "poblacio_2025": 10772,
    "poblacio_2024": 10676,
    "poblacio_2023": 10575,
    "poblacio_2022": 10396,
    "poblacio_2021": 10266,
    "poblacio_2008": 8925,
    "poblacio_1996": 7335
  },
  {
    "code": "03007",
    "latitude": 38.794914669364800,
    "longitude": -0.402637547883813,
    "name": "Alcosser",
    "comarca": 14,
    "gentilici": "alcosserí, alcosserina",
    "poblacio_2025": 263,
    "poblacio_2024": 259,
    "poblacio_2023": 259,
    "poblacio_2022": 254,
    "poblacio_2021": 243,
    "poblacio_2008": 234,
    "poblacio_1996": 122
  },
  {
    "code": "03008",
    "latitude": 38.675409744485900,
    "longitude": -0.331797485674256,
    "name": "Alcoleja",
    "comarca": 14,
    "gentilici": "alcolejà, alcolejana",
    "poblacio_2025": 184,
    "poblacio_2024": 186,
    "poblacio_2023": 188,
    "poblacio_2022": 196,
    "poblacio_2021": 181,
    "poblacio_2008": 211,
    "poblacio_1996": 294
  },
  {
    "code": "12005",
    "latitude": 40.071601967735200,
    "longitude": -0.214374753156895,
    "name": "l'Alcora",
    "comarca": 2,
    "gentilici": "alcorí, alcorina",
    "poblacio_2025": 10664,
    "poblacio_2024": 10581,
    "poblacio_2023": 10526,
    "poblacio_2022": 10468,
    "poblacio_2021": 10428,
    "poblacio_2008": 11068,
    "poblacio_1996": 8662
  },
  {
    "code": "03009",
    "latitude": 38.702642858010800,
    "longitude": -0.478192266547460,
    "name": "Alcoi",
    "comarca": 3,
    "gentilici": "alcoià, alcoiana",
    "poblacio_2025": 61468,
    "poblacio_2024": 60372,
    "poblacio_2023": 59493,
    "poblacio_2022": 58960,
    "poblacio_2021": 59128,
    "poblacio_2008": 61698,
    "poblacio_1996": 60921
  },
  {
    "code": "46018",
    "latitude": 39.797581876160100,
    "longitude": -0.702817739045150,
    "name": "Alcublas",
    "comarca": 29,
    "gentilici": "alcublà, alcublana",
    "poblacio_2025": 710,
    "poblacio_2024": 683,
    "poblacio_2023": 635,
    "poblacio_2022": 607,
    "poblacio_2021": 610,
    "poblacio_2008": 842,
    "poblacio_1996": 837
  },
  {
    "code": "46020",
    "latitude": 38.972177037562900,
    "longitude": -0.590909255428424,
    "name": "l'Alcúdia de Crespins",
    "comarca": 15,
    "gentilici": "alcudià, alcudiana",
    "poblacio_2025": 5548,
    "poblacio_2024": 5438,
    "poblacio_2023": 5361,
    "poblacio_2022": 5224,
    "poblacio_2021": 5144,
    "poblacio_2008": 5206,
    "poblacio_1996": 4185
  },
  {
    "code": "12006",
    "latitude": 39.915757,
    "longitude": -0.354587938,
    "name": "Alcudia de Veo",
    "comarca": 22,
    "gentilici": "alcudià, alcudiana",
    "poblacio_2025": 200,
    "poblacio_2024": 213,
    "poblacio_2023": 203,
    "poblacio_2022": 195,
    "poblacio_2021": 196,
    "poblacio_2008": 212,
    "poblacio_1996": 181
  },
  {
    "code": "46019",
    "latitude": 39.196104860366700,
    "longitude": -0.505124986196271,
    "name": "l'Alcúdia",
    "comarca": 26,
    "gentilici": "alcudià, alcudiana",
    "poblacio_2025": 12587,
    "poblacio_2024": 12402,
    "poblacio_2023": 12197,
    "poblacio_2022": 12176,
    "poblacio_2021": 12193,
    "poblacio_2008": 11331,
    "poblacio_1996": 10511
  },
  {
    "code": "46021",
    "latitude": 39.464930514038200,
    "longitude": -0.462921304248341,
    "name": "Aldaia",
    "comarca": 18,
    "gentilici": "aldaier, aldaiera",
    "poblacio_2025": 34630,
    "poblacio_2024": 34035,
    "poblacio_2023": 33376,
    "poblacio_2022": 32656,
    "poblacio_2021": 32313,
    "poblacio_2008": 29173,
    "poblacio_1996": 23425
  },
  {
    "code": "46022",
    "latitude": 39.422574578429000,
    "longitude": -0.387285735351789,
    "name": "Alfafar",
    "comarca": 18,
    "gentilici": "alfafarenc, alfafarenca",
    "poblacio_2025": 22270,
    "poblacio_2024": 22131,
    "poblacio_2023": 21879,
    "poblacio_2022": 21480,
    "poblacio_2021": 21415,
    "poblacio_2008": 20655,
    "poblacio_1996": 20302
  },
  {
    "code": "03010",
    "latitude": 38.774122152283600,
    "longitude": -0.554472401720922,
    "name": "Alfafara",
    "comarca": 14,
    "gentilici": "alfafarenc, alfafarenca",
    "poblacio_2025": 419,
    "poblacio_2024": 413,
    "poblacio_2023": 419,
    "poblacio_2022": 417,
    "poblacio_2021": 408,
    "poblacio_2008": 422,
    "poblacio_1996": 391
  },
  {
    "code": "46024",
    "latitude": 39.763166313405600,
    "longitude": -0.355598509144683,
    "name": "Alfara de la Baronia",
    "comarca": 11,
    "gentilici": "alfarenc, alfarenca",
    "poblacio_2025": 624,
    "poblacio_2024": 614,
    "poblacio_2023": 611,
    "poblacio_2022": 606,
    "poblacio_2021": 590,
    "poblacio_2008": 518,
    "poblacio_1996": 509
  },
  {
    "code": "46025",
    "latitude": 39.544350623392200,
    "longitude": -0.384987284001214,
    "name": "Alfara del Patriarca",
    "comarca": 17,
    "gentilici": "alfarer, alfarera",
    "poblacio_2025": 3740,
    "poblacio_2024": 3623,
    "poblacio_2023": 3455,
    "poblacio_2022": 3315,
    "poblacio_2021": 3301,
    "poblacio_2008": 2985,
    "poblacio_1996": 2733
  },
  {
    "code": "46026",
    "latitude": 39.276651638548000,
    "longitude": -0.561327235023055,
    "name": "Alfarb",
    "comarca": 26,
    "gentilici": "alfarbí, alfarbina",
    "poblacio_2025": 1763,
    "poblacio_2024": 1676,
    "poblacio_2023": 1618,
    "poblacio_2022": 1596,
    "poblacio_2021": 1564,
    "poblacio_2008": 1441,
    "poblacio_1996": 1336
  },
  {
    "code": "46027",
    "latitude": 38.904863306889900,
    "longitude": -0.496255405497182,
    "name": "Alfarrasí",
    "comarca": 31,
    "gentilici": "alfarrasiner, alfarrasinera",
    "poblacio_2025": 1173,
    "poblacio_2024": 1175,
    "poblacio_2023": 1183,
    "poblacio_2022": 1217,
    "poblacio_2021": 1206,
    "poblacio_2008": 1313,
    "poblacio_1996": 1231
  },
  {
    "code": "03011",
    "latitude": 38.579080545960700,
    "longitude": -0.099827865289872,
    "name": "l'Alfàs del Pi",
    "comarca": 20,
    "gentilici": "alfassí, alfassina",
    "poblacio_2025": 21080,
    "poblacio_2024": 20160,
    "poblacio_2023": 20518,
    "poblacio_2022": 20668,
    "poblacio_2021": 20495,
    "poblacio_2008": 20939,
    "poblacio_1996": 12547
  },
  {
    "code": "46023",
    "latitude": 38.928693535280300,
    "longitude": -0.251648650541399,
    "name": "Alfauir",
    "comarca": 28,
    "gentilici": "alfauirenc, alfauirenca",
    "poblacio_2025": 515,
    "poblacio_2024": 489,
    "poblacio_2023": 477,
    "poblacio_2022": 479,
    "poblacio_2021": 467,
    "poblacio_2008": 444,
    "poblacio_1996": 343
  },
  {
    "code": "12007",
    "latitude": 39.836515967996400,
    "longitude": -0.269648984248980,
    "name": "Alfondeguilla",
    "comarca": 22,
    "gentilici": "alfondeguiller, alfondeguillera \/ fondeguiller, fondeguillera",
    "poblacio_2025": 881,
    "poblacio_2024": 870,
    "poblacio_2023": 873,
    "poblacio_2022": 877,
    "poblacio_2021": 870,
    "poblacio_2008": 886,
    "poblacio_1996": 922
  },
  {
    "code": "46028",
    "latitude": 39.781279180499500,
    "longitude": -0.367444888596254,
    "name": "Algar de Palància",
    "comarca": 11,
    "gentilici": "algarenc, algarenca \/ algareny, algarenya",
    "poblacio_2025": 565,
    "poblacio_2024": 542,
    "poblacio_2023": 527,
    "poblacio_2022": 498,
    "poblacio_2021": 499,
    "poblacio_2008": 583,
    "poblacio_1996": 413
  },
  {
    "code": "46029",
    "latitude": 39.190231608799400,
    "longitude": -0.435016219540267,
    "name": "Algemesí",
    "comarca": 26,
    "gentilici": "algemesinenc, algemesinenca",
    "poblacio_2025": 28306,
    "poblacio_2024": 27968,
    "poblacio_2023": 27438,
    "poblacio_2022": 27305,
    "poblacio_2021": 27305,
    "poblacio_2008": 27770,
    "poblacio_1996": 25029
  },
  {
    "code": "46030",
    "latitude": 39.752437612561800,
    "longitude": -0.363604215473977,
    "name": "Algímia d'Alfara",
    "comarca": 11,
    "gentilici": "algimià, algimiana",
    "poblacio_2025": 1115,
    "poblacio_2024": 1104,
    "poblacio_2023": 1109,
    "poblacio_2022": 1106,
    "poblacio_2021": 1079,
    "poblacio_2008": 1078,
    "poblacio_1996": 829
  },
  {
    "code": "12008",
    "latitude": 39.915331363229000,
    "longitude": -0.441223246097767,
    "name": "Algimia de Almonacid",
    "comarca": 6,
    "gentilici": "algimià, algimiana",
    "poblacio_2025": 254,
    "poblacio_2024": 258,
    "poblacio_2023": 249,
    "poblacio_2022": 247,
    "poblacio_2021": 240,
    "poblacio_2008": 321,
    "poblacio_1996": 313
  },
  {
    "code": "46031",
    "latitude": 39.263076118299500,
    "longitude": -0.469150692388261,
    "name": "Alginet",
    "comarca": 26,
    "gentilici": "alginetí, alginetina",
    "poblacio_2025": 14844,
    "poblacio_2024": 14652,
    "poblacio_2023": 14442,
    "poblacio_2022": 14219,
    "poblacio_2021": 13942,
    "poblacio_2008": 13057,
    "poblacio_1996": 11632
  },
  {
    "code": "03012",
    "latitude": 38.085247378858500,
    "longitude": -0.797335469940539,
    "name": "Algorfa",
    "comarca": 9,
    "gentilici": "algorfí, algorfina",
    "poblacio_2025": 3788,
    "poblacio_2024": 3684,
    "poblacio_2023": 3635,
    "poblacio_2022": 3513,
    "poblacio_2021": 3396,
    "poblacio_2008": 4125,
    "poblacio_1996": 1140
  },
  {
    "code": "03013",
    "latitude": 38.338780893720600,
    "longitude": -1.004741065524120,
    "name": "l'Alguenya",
    "comarca": 33,
    "gentilici": "alguenyer, alguenyera",
    "poblacio_2025": 1328,
    "poblacio_2024": 1342,
    "poblacio_2023": 1395,
    "poblacio_2022": 1351,
    "poblacio_2021": 1334,
    "poblacio_2008": 1561,
    "poblacio_1996": 1425
  },
  {
    "code": "03014",
    "latitude": 38.351036981958300,
    "longitude": -0.494067863096929,
    "name": "Alacant",
    "comarca": 1,
    "gentilici": "alacantí, alacantina",
    "poblacio_2025": 366221,
    "poblacio_2024": 358720,
    "poblacio_2023": 349282,
    "poblacio_2022": 338577,
    "poblacio_2021": 337304,
    "poblacio_2008": 331750,
    "poblacio_1996": 274577
  },
  {
    "code": "46032",
    "latitude": 39.512737401352300,
    "longitude": -0.355935149295216,
    "name": "Almàssera",
    "comarca": 17,
    "gentilici": "almasserí, almasserina",
    "poblacio_2025": 7887,
    "poblacio_2024": 7672,
    "poblacio_2023": 7504,
    "poblacio_2022": 7482,
    "poblacio_2021": 7433,
    "poblacio_2008": 6955,
    "poblacio_1996": 5545
  },
  {
    "code": "12009",
    "latitude": 39.946231959220900,
    "longitude": -0.065190277518232,
    "name": "Almassora",
    "comarca": 21,
    "gentilici": "almassorí, almassorina",
    "poblacio_2025": 29159,
    "poblacio_2024": 28497,
    "poblacio_2023": 27989,
    "poblacio_2022": 27383,
    "poblacio_2021": 26878,
    "poblacio_2008": 23891,
    "poblacio_1996": 16306
  },
  {
    "code": "12010",
    "latitude": 39.871983682483400,
    "longitude": -0.409977899169831,
    "name": "Almedíjar",
    "comarca": 6,
    "gentilici": "almedixà, almedixana",
    "poblacio_2025": 288,
    "poblacio_2024": 288,
    "poblacio_2023": 280,
    "poblacio_2022": 269,
    "poblacio_2021": 254,
    "poblacio_2008": 256,
    "poblacio_1996": 300
  },
  {
    "code": "12011",
    "latitude": 39.753500376918400,
    "longitude": -0.223032156534670,
    "name": "Almenara",
    "comarca": 22,
    "gentilici": "almenarenc, almenarenca",
    "poblacio_2025": 6813,
    "poblacio_2024": 6710,
    "poblacio_2023": 6591,
    "poblacio_2022": 6388,
    "poblacio_2021": 6254,
    "poblacio_2008": 5705,
    "poblacio_1996": 5018
  },
  {
    "code": "46033",
    "latitude": 38.914986070682500,
    "longitude": -0.285713704157469,
    "name": "Almiserà",
    "comarca": 28,
    "gentilici": "almiseratí, almiseratina",
    "poblacio_2025": 278,
    "poblacio_2024": 285,
    "poblacio_2023": 279,
    "poblacio_2022": 260,
    "poblacio_2021": 264,
    "poblacio_2008": 294,
    "poblacio_1996": 255
  },
  {
    "code": "46034",
    "latitude": 38.943563846829700,
    "longitude": -0.181286338641789,
    "name": "Almoines",
    "comarca": 28,
    "gentilici": "almoiner, almoinera",
    "poblacio_2025": 2664,
    "poblacio_2024": 2643,
    "poblacio_2023": 2519,
    "poblacio_2022": 2473,
    "poblacio_2021": 2528,
    "poblacio_2008": 2339,
    "poblacio_1996": 1759
  },
  {
    "code": "03015",
    "latitude": 38.109689303779200,
    "longitude": -0.789835950019830,
    "name": "Almoradí",
    "comarca": 9,
    "gentilici": "almoradienc, almoradienca",
    "poblacio_2025": 22965,
    "poblacio_2024": 22464,
    "poblacio_2023": 21874,
    "poblacio_2022": 21401,
    "poblacio_2021": 21404,
    "poblacio_2008": 18536,
    "poblacio_1996": 13479
  },
  {
    "code": "03016",
    "latitude": 38.760364063552000,
    "longitude": -0.354180678814073,
    "name": "Almudaina",
    "comarca": 14,
    "gentilici": "almudainer, almudainera",
    "poblacio_2025": 128,
    "poblacio_2024": 118,
    "poblacio_2023": 110,
    "poblacio_2022": 112,
    "poblacio_2021": 117,
    "poblacio_2008": 129,
    "poblacio_1996": 125
  },
  {
    "code": "46035",
    "latitude": 39.292117107557900,
    "longitude": -0.413374100176096,
    "name": "Almussafes",
    "comarca": 27,
    "gentilici": "almussafenc, almussafenca \/ almussafeny, almussafenya",
    "poblacio_2025": 9070,
    "poblacio_2024": 9057,
    "poblacio_2023": 8996,
    "poblacio_2022": 8929,
    "poblacio_2021": 8984,
    "poblacio_2008": 8189,
    "poblacio_1996": 6881
  },
  {
    "code": "46036",
    "latitude": 39.876247059985500,
    "longitude": -1.013983816396890,
    "name": "Alpuente",
    "comarca": 29,
    "gentilici": "alpontí, alpontina",
    "poblacio_2025": 688,
    "poblacio_2024": 700,
    "poblacio_2023": 667,
    "poblacio_2022": 670,
    "poblacio_2021": 659,
    "poblacio_2008": 833,
    "poblacio_1996": 985
  },
  {
    "code": "03017",
    "latitude": 38.772461809165900,
    "longitude": -0.426615278028672,
    "name": "l'Alqueria d'Asnar",
    "comarca": 14,
    "gentilici": "alquerier, alqueriera",
    "poblacio_2025": 519,
    "poblacio_2024": 519,
    "poblacio_2023": 511,
    "poblacio_2022": 489,
    "poblacio_2021": 498,
    "poblacio_2008": 470,
    "poblacio_1996": 407
  },
  {
    "code": "46037",
    "latitude": 38.936627267114000,
    "longitude": -0.153894872925440,
    "name": "l'Alqueria de la Comtessa",
    "comarca": 28,
    "gentilici": "alquerià, alqueriana",
    "poblacio_2025": 1547,
    "poblacio_2024": 1544,
    "poblacio_2023": 1523,
    "poblacio_2022": 1478,
    "poblacio_2021": 1481,
    "poblacio_2008": 1508,
    "poblacio_1996": 1487
  },
  {
    "code": "12901",
    "latitude": 39.896342999147100,
    "longitude": -0.112383539549220,
    "name": "les Alqueries",
    "comarca": 22,
    "gentilici": "alquerier, alqueriera",
    "poblacio_2025": 4605,
    "poblacio_2024": 4563,
    "poblacio_2023": 4539,
    "poblacio_2022": 4511,
    "poblacio_2021": 4539,
    "poblacio_2008": 4142,
    "poblacio_1996": 3508
  },
  {
    "code": "03018",
    "latitude": 38.597947235363100,
    "longitude": -0.055353301922926,
    "name": "Altea",
    "comarca": 20,
    "gentilici": "alteà, alteana",
    "poblacio_2025": 24592,
    "poblacio_2024": 23963,
    "poblacio_2023": 23820,
    "poblacio_2022": 23010,
    "poblacio_2021": 22657,
    "poblacio_2008": 23532,
    "poblacio_1996": 13519
  },
  {
    "code": "12012",
    "latitude": 39.850919941622800,
    "longitude": -0.512108731315766,
    "name": "Altura",
    "comarca": 6,
    "gentilici": "alturà, alturana",
    "poblacio_2025": 3849,
    "poblacio_2024": 3790,
    "poblacio_2023": 3695,
    "poblacio_2022": 3667,
    "poblacio_2021": 3658,
    "poblacio_2008": 3784,
    "poblacio_1996": 3093
  },
  {
    "code": "46017",
    "latitude": 39.151881182455800,
    "longitude": -0.436208938472399,
    "name": "Alzira",
    "comarca": 26,
    "gentilici": "alzirenc, alzirenca \/ alzireny, alzirenya",
    "poblacio_2025": 48236,
    "poblacio_2024": 47335,
    "poblacio_2023": 46421,
    "poblacio_2022": 45451,
    "poblacio_2021": 44865,
    "poblacio_2008": 43892,
    "poblacio_1996": 40556
  },
  {
    "code": "46038",
    "latitude": 39.835978709081300,
    "longitude": -0.813282494179851,
    "name": "Andilla",
    "comarca": 29,
    "gentilici": "andillà, andillana",
    "poblacio_2025": 338,
    "poblacio_2024": 324,
    "poblacio_2023": 311,
    "poblacio_2022": 316,
    "poblacio_2021": 315,
    "poblacio_2008": 346,
    "poblacio_1996": 292
  },
  {
    "code": "46039",
    "latitude": 39.021185280900100,
    "longitude": -0.643717441037372,
    "name": "Anna",
    "comarca": 13,
    "gentilici": "anner, annera",
    "poblacio_2025": 2600,
    "poblacio_2024": 2595,
    "poblacio_2023": 2593,
    "poblacio_2022": 2583,
    "poblacio_2021": 2627,
    "poblacio_2008": 2753,
    "poblacio_1996": 2637
  },
  {
    "code": "46040",
    "latitude": 39.080425795011800,
    "longitude": -0.591698465069856,
    "name": "Antella",
    "comarca": 26,
    "gentilici": "antellà, antellana",
    "poblacio_2025": 1130,
    "poblacio_2024": 1114,
    "poblacio_2023": 1114,
    "poblacio_2022": 1130,
    "poblacio_2021": 1127,
    "poblacio_2008": 1549,
    "poblacio_1996": 1558
  },
  {
    "code": "12013",
    "latitude": 40.071171023017100,
    "longitude": -0.482103587022553,
    "name": "Arañuel",
    "comarca": 5,
    "gentilici": "aranyeler, aranyelera",
    "poblacio_2025": 148,
    "poblacio_2024": 159,
    "poblacio_2023": 165,
    "poblacio_2022": 162,
    "poblacio_2021": 152,
    "poblacio_2008": 205,
    "poblacio_1996": 133
  },
  {
    "code": "46041",
    "latitude": 39.924077674980900,
    "longitude": -1.133513913574270,
    "name": "Aras de los Olmos",
    "comarca": 29,
    "gentilici": "aresà, aresana",
    "poblacio_2025": 401,
    "poblacio_2024": 392,
    "poblacio_2023": 381,
    "poblacio_2022": 380,
    "poblacio_2021": 374,
    "poblacio_2008": 427,
    "poblacio_1996": 420
  },
  {
    "code": "12014",
    "latitude": 40.456178250607300,
    "longitude": -0.131617761471179,
    "name": "Ares del Maestrat",
    "comarca": 4,
    "gentilici": "arenc, arenca",
    "poblacio_2025": 181,
    "poblacio_2024": 177,
    "poblacio_2023": 174,
    "poblacio_2022": 173,
    "poblacio_2021": 175,
    "poblacio_2008": 217,
    "poblacio_1996": 281
  },
  {
    "code": "12015",
    "latitude": 40.054054077478500,
    "longitude": -0.349814655381375,
    "name": "Argelita",
    "comarca": 5,
    "gentilici": "argeletà, argeletana",
    "poblacio_2025": 139,
    "poblacio_2024": 146,
    "poblacio_2023": 156,
    "poblacio_2022": 153,
    "poblacio_2021": 147,
    "poblacio_2008": 105,
    "poblacio_1996": 110
  },
  {
    "code": "12016",
    "latitude": 39.890919753244400,
    "longitude": -0.255896009854668,
    "name": "Artana",
    "comarca": 22,
    "gentilici": "artanenc, artanenca",
    "poblacio_2025": 1993,
    "poblacio_2024": 1971,
    "poblacio_2023": 1980,
    "poblacio_2022": 1979,
    "poblacio_2021": 1970,
    "poblacio_2008": 1987,
    "poblacio_1996": 1909
  },
  {
    "code": "03019",
    "latitude": 38.342930400994500,
    "longitude": -0.766209722261864,
    "name": "Aspe",
    "comarca": 33,
    "gentilici": "asper, aspera \/ aspenc, aspenca",
    "poblacio_2025": 22397,
    "poblacio_2024": 21969,
    "poblacio_2023": 21473,
    "poblacio_2022": 21191,
    "poblacio_2021": 21088,
    "poblacio_2008": 19893,
    "poblacio_1996": 16391
  },
  {
    "code": "46003",
    "latitude": 38.832345978602800,
    "longitude": -0.497726842950054,
    "name": "Atzeneta d'Albaida",
    "comarca": 31,
    "gentilici": "atzenetí, atzenetina",
    "poblacio_2025": 1193,
    "poblacio_2024": 1169,
    "poblacio_2023": 1161,
    "poblacio_2022": 1146,
    "poblacio_2021": 1139,
    "poblacio_2008": 1280,
    "poblacio_1996": 1243
  },
  {
    "code": "12001",
    "latitude": 40.217053914016200,
    "longitude": -0.169751490858360,
    "name": "Atzeneta del Maestrat",
    "comarca": 4,
    "gentilici": "atzenetí, atzenetina",
    "poblacio_2025": 1284,
    "poblacio_2024": 1309,
    "poblacio_2023": 1319,
    "poblacio_2022": 1287,
    "poblacio_2021": 1292,
    "poblacio_2008": 1448,
    "poblacio_1996": 1486
  },
  {
    "code": "03001",
    "latitude": 38.847553276067700,
    "longitude": -0.149670248059826,
    "name": "l'Atzúbia",
    "comarca": 19,
    "gentilici": "atzubià, atzubiana",
    "poblacio_2025": 589,
    "poblacio_2024": 594,
    "poblacio_2023": 608,
    "poblacio_2022": 616,
    "poblacio_2021": 609,
    "poblacio_2008": 686,
    "poblacio_1996": 582
  },
  {
    "code": "12017",
    "latitude": 39.999205793578900,
    "longitude": -0.374095377490410,
    "name": "Ayódar",
    "comarca": 5,
    "gentilici": "aiodà, aiodana \/ aioder, aiodera",
    "poblacio_2025": 176,
    "poblacio_2024": 182,
    "poblacio_2023": 178,
    "poblacio_2022": 156,
    "poblacio_2021": 158,
    "poblacio_2008": 236,
    "poblacio_1996": 221
  },
  {
    "code": "46044",
    "latitude": 39.059628215889800,
    "longitude": -1.056645482039200,
    "name": "Ayora",
    "comarca": 32,
    "gentilici": "aiorí, aiorina",
    "poblacio_2025": 5282,
    "poblacio_2024": 5284,
    "poblacio_2023": 5223,
    "poblacio_2022": 5187,
    "poblacio_2021": 5215,
    "poblacio_2008": 5507,
    "poblacio_1996": 5556
  },
  {
    "code": "12018",
    "latitude": 39.834501910371400,
    "longitude": -0.368635783024612,
    "name": "Azuébar",
    "comarca": 6,
    "gentilici": "assuever, assuevera",
    "poblacio_2025": 359,
    "poblacio_2024": 352,
    "poblacio_2023": 336,
    "poblacio_2022": 318,
    "poblacio_2021": 319,
    "poblacio_2008": 343,
    "poblacio_1996": 375
  },
  {
    "code": "03020",
    "latitude": 38.736677018294200,
    "longitude": -0.343374850369296,
    "name": "Balones",
    "comarca": 14,
    "gentilici": "baloner, balonera",
    "poblacio_2025": 132,
    "poblacio_2024": 131,
    "poblacio_2023": 119,
    "poblacio_2022": 126,
    "poblacio_2021": 134,
    "poblacio_2008": 157,
    "poblacio_1996": 176
  },
  {
    "code": "03021",
    "latitude": 38.721106576352100,
    "longitude": -0.654702135202442,
    "name": "Banyeres de Mariola",
    "comarca": 3,
    "gentilici": "banyerí, banyerina \/ banyerut, banyeruda",
    "poblacio_2025": 7347,
    "poblacio_2024": 7307,
    "poblacio_2023": 7255,
    "poblacio_2022": 7201,
    "poblacio_2021": 7113,
    "poblacio_2008": 7194,
    "poblacio_1996": 7056
  },
  {
    "code": "12020",
    "latitude": 40.016677940645400,
    "longitude": -0.697788106866697,
    "name": "Barracas",
    "comarca": 6,
    "gentilici": "barraquer, barraquera",
    "poblacio_2025": 188,
    "poblacio_2024": 195,
    "poblacio_2023": 198,
    "poblacio_2022": 185,
    "poblacio_2021": 185,
    "poblacio_2008": 179,
    "poblacio_1996": 171
  },
  {
    "code": "46046",
    "latitude": 39.014651968104600,
    "longitude": -0.302105171298026,
    "name": "Barx",
    "comarca": 28,
    "gentilici": "barxer, barxera",
    "poblacio_2025": 1501,
    "poblacio_2024": 1498,
    "poblacio_2023": 1476,
    "poblacio_2022": 1400,
    "poblacio_2021": 1354,
    "poblacio_2008": 1481,
    "poblacio_1996": 1203
  },
  {
    "code": "46045",
    "latitude": 39.022034856048500,
    "longitude": -0.418622993826327,
    "name": "Barxeta",
    "comarca": 15,
    "gentilici": "barxetà, barxetana",
    "poblacio_2025": 1578,
    "poblacio_2024": 1586,
    "poblacio_2023": 1595,
    "poblacio_2022": 1576,
    "poblacio_2021": 1604,
    "poblacio_2008": 1671,
    "poblacio_1996": 1610
  },
  {
    "code": "12022",
    "latitude": 39.909367144900900,
    "longitude": -0.708261645598321,
    "name": "Bejís",
    "comarca": 6,
    "gentilici": "begissà, begissana",
    "poblacio_2025": 400,
    "poblacio_2024": 400,
    "poblacio_2023": 409,
    "poblacio_2022": 393,
    "poblacio_2021": 390,
    "poblacio_2008": 452,
    "poblacio_1996": 368
  },
  {
    "code": "46047",
    "latitude": 38.860395048990700,
    "longitude": -0.474820464078988,
    "name": "Bèlgida",
    "comarca": 31,
    "gentilici": "belgidà, belgidana",
    "poblacio_2025": 651,
    "poblacio_2024": 640,
    "poblacio_2023": 632,
    "poblacio_2022": 639,
    "poblacio_2021": 654,
    "poblacio_2008": 722,
    "poblacio_1996": 677
  },
  {
    "code": "46048",
    "latitude": 38.946065448072500,
    "longitude": -0.162762239233263,
    "name": "Bellreguard",
    "comarca": 28,
    "gentilici": "bellreguardí, bellreguardina",
    "poblacio_2025": 5032,
    "poblacio_2024": 4943,
    "poblacio_2023": 4811,
    "poblacio_2022": 4713,
    "poblacio_2021": 4632,
    "poblacio_2008": 4647,
    "poblacio_1996": 3764
  },
  {
    "code": "46049",
    "latitude": 38.945543119440800,
    "longitude": -0.487610351884088,
    "name": "Bellús",
    "comarca": 31,
    "gentilici": "bellusser, bellussera",
    "poblacio_2025": 317,
    "poblacio_2024": 302,
    "poblacio_2023": 306,
    "poblacio_2022": 301,
    "poblacio_2021": 311,
    "poblacio_2008": 385,
    "poblacio_1996": 383
  },
  {
    "code": "12024",
    "latitude": 39.935361166543500,
    "longitude": -0.577412413312890,
    "name": "Benafer",
    "comarca": 6,
    "gentilici": "benafer, benafera",
    "poblacio_2025": 168,
    "poblacio_2024": 170,
    "poblacio_2023": 164,
    "poblacio_2022": 171,
    "poblacio_2021": 173,
    "poblacio_2008": 179,
    "poblacio_1996": 153
  },
  {
    "code": "12025",
    "latitude": 40.276489252365200,
    "longitude": -0.208655884547970,
    "name": "Benafigos",
    "comarca": 4,
    "gentilici": "benafiguer, benafiguera",
    "poblacio_2025": 121,
    "poblacio_2024": 126,
    "poblacio_2023": 135,
    "poblacio_2022": 136,
    "poblacio_2021": 145,
    "poblacio_2008": 171,
    "poblacio_1996": 238
  },
  {
    "code": "46050",
    "latitude": 39.706714367061400,
    "longitude": -1.101246344772430,
    "name": "Benagéber",
    "comarca": 29,
    "gentilici": "benaixever, benaixevera",
    "poblacio_2025": 176,
    "poblacio_2024": 171,
    "poblacio_2023": 168,
    "poblacio_2022": 170,
    "poblacio_2021": 184,
    "poblacio_2008": 156,
    "poblacio_1996": 156
  },
  {
    "code": "46051",
    "latitude": 39.594322872570800,
    "longitude": -0.588150173176355,
    "name": "Benaguasil",
    "comarca": 12,
    "gentilici": "benaguasiler, benaguasilera",
    "poblacio_2025": 12668,
    "poblacio_2024": 12336,
    "poblacio_2023": 11877,
    "poblacio_2022": 11568,
    "poblacio_2021": 11369,
    "poblacio_2008": 10728,
    "poblacio_1996": 9155
  },
  {
    "code": "03022",
    "latitude": 38.689516454357000,
    "longitude": -0.344112149003741,
    "name": "Benasau",
    "comarca": 14,
    "gentilici": "benasauer, benasauera",
    "poblacio_2025": 174,
    "poblacio_2024": 171,
    "poblacio_2023": 173,
    "poblacio_2022": 171,
    "poblacio_2021": 170,
    "poblacio_2008": 198,
    "poblacio_1996": 210
  },
  {
    "code": "12026",
    "latitude": 40.379955981951900,
    "longitude": -0.144328840685449,
    "name": "Benassal",
    "comarca": 4,
    "gentilici": "benassalenc, benassalenca",
    "poblacio_2025": 1048,
    "poblacio_2024": 1052,
    "poblacio_2023": 1026,
    "poblacio_2022": 1040,
    "poblacio_2021": 1055,
    "poblacio_2008": 1332,
    "poblacio_1996": 1405
  },
  {
    "code": "46052",
    "latitude": 39.740681456483300,
    "longitude": -0.258812893781766,
    "name": "Benavites",
    "comarca": 11,
    "gentilici": "benaviter, benavitera",
    "poblacio_2025": 652,
    "poblacio_2024": 661,
    "poblacio_2023": 674,
    "poblacio_2022": 667,
    "poblacio_2021": 653,
    "poblacio_2008": 629,
    "poblacio_1996": 651
  },
  {
    "code": "03023",
    "latitude": 38.701323806936900,
    "longitude": -0.765770834439611,
    "name": "Beneixama",
    "comarca": 7,
    "gentilici": "beneixamer, beneixamera",
    "poblacio_2025": 1696,
    "poblacio_2024": 1679,
    "poblacio_2023": 1697,
    "poblacio_2022": 1705,
    "poblacio_2021": 1707,
    "poblacio_2008": 1837,
    "poblacio_1996": 1799
  },
  {
    "code": "46053",
    "latitude": 39.057710409877700,
    "longitude": -0.547489943247489,
    "name": "Beneixida",
    "comarca": 26,
    "gentilici": "beneixider, beneixidera",
    "poblacio_2025": 659,
    "poblacio_2024": 649,
    "poblacio_2023": 655,
    "poblacio_2022": 652,
    "poblacio_2021": 639,
    "poblacio_2008": 676,
    "poblacio_1996": 647
  },
  {
    "code": "03024",
    "latitude": 38.077899783121100,
    "longitude": -0.839351237387021,
    "name": "Benejúzar",
    "comarca": 9,
    "gentilici": "benejussenc, benejussenca",
    "poblacio_2025": 5811,
    "poblacio_2024": 5697,
    "poblacio_2023": 5625,
    "poblacio_2022": 5480,
    "poblacio_2021": 5453,
    "poblacio_2008": 5472,
    "poblacio_1996": 5009
  },
  {
    "code": "46054",
    "latitude": 39.422310720072300,
    "longitude": -0.397064156262358,
    "name": "Benetússer",
    "comarca": 18,
    "gentilici": "benetussí, benetussina",
    "poblacio_2025": 16734,
    "poblacio_2024": 16322,
    "poblacio_2023": 15879,
    "poblacio_2022": 15493,
    "poblacio_2021": 15430,
    "poblacio_2008": 14824,
    "poblacio_1996": 13961
  },
  {
    "code": "03025",
    "latitude": 38.141673615412500,
    "longitude": -0.962266730045308,
    "name": "Benferri",
    "comarca": 9,
    "gentilici": "benferrí, benferrina",
    "poblacio_2025": 2099,
    "poblacio_2024": 2053,
    "poblacio_2023": 2023,
    "poblacio_2022": 1955,
    "poblacio_2021": 1958,
    "poblacio_2008": 1746,
    "poblacio_1996": 1011
  },
  {
    "code": "03026",
    "latitude": 38.823224081598600,
    "longitude": -0.002790188032592,
    "name": "Beniarbeig",
    "comarca": 19,
    "gentilici": "beniarbegí, beniarbegina",
    "poblacio_2025": 2499,
    "poblacio_2024": 2384,
    "poblacio_2023": 2353,
    "poblacio_2022": 2267,
    "poblacio_2021": 2227,
    "poblacio_2008": 1889,
    "poblacio_1996": 1208
  },
  {
    "code": "03027",
    "latitude": 38.683407289185400,
    "longitude": -0.216191144662411,
    "name": "Beniardà",
    "comarca": 20,
    "gentilici": "beniarder, beniardera",
    "poblacio_2025": 226,
    "poblacio_2024": 235,
    "poblacio_2023": 252,
    "poblacio_2022": 218,
    "poblacio_2021": 192,
    "poblacio_2008": 258,
    "poblacio_1996": 224
  },
  {
    "code": "46055",
    "latitude": 38.932226013673000,
    "longitude": -0.187488278687193,
    "name": "Beniarjó",
    "comarca": 28,
    "gentilici": "beniarjoter, beniarjotera",
    "poblacio_2025": 1964,
    "poblacio_2024": 1907,
    "poblacio_2023": 1872,
    "poblacio_2022": 1791,
    "poblacio_2021": 1780,
    "poblacio_2008": 1759,
    "poblacio_1996": 1165
  },
  {
    "code": "03028",
    "latitude": 38.820023532042600,
    "longitude": -0.378926202411201,
    "name": "Beniarrés",
    "comarca": 14,
    "gentilici": "beniarresí, beniarresina",
    "poblacio_2025": 1117,
    "poblacio_2024": 1096,
    "poblacio_2023": 1089,
    "poblacio_2022": 1078,
    "poblacio_2021": 1083,
    "poblacio_2008": 1323,
    "poblacio_1996": 1464
  },
  {
    "code": "46056",
    "latitude": 38.846997392211300,
    "longitude": -0.417337494881426,
    "name": "Beniatjar",
    "comarca": 31,
    "gentilici": "beniatjarí, beniatjarina",
    "poblacio_2025": 209,
    "poblacio_2024": 209,
    "poblacio_2023": 217,
    "poblacio_2022": 207,
    "poblacio_2021": 207,
    "poblacio_2008": 249,
    "poblacio_1996": 245
  },
  {
    "code": "12027",
    "latitude": 40.414750845456500,
    "longitude": 0.421881006833207,
    "name": "Benicarló",
    "comarca": 8,
    "gentilici": "benicarlando, benicarlanda",
    "poblacio_2025": 30296,
    "poblacio_2024": 29607,
    "poblacio_2023": 28681,
    "poblacio_2022": 27780,
    "poblacio_2021": 27658,
    "poblacio_2008": 26381,
    "poblacio_1996": 19229
  },
  {
    "code": "12028",
    "latitude": 40.054499134884800,
    "longitude": 0.062069197258883,
    "name": "Benicàssim",
    "comarca": 21,
    "gentilici": "benicassut, benicassuda",
    "poblacio_2025": 20539,
    "poblacio_2024": 20322,
    "poblacio_2023": 19951,
    "poblacio_2022": 19507,
    "poblacio_2021": 18991,
    "poblacio_2008": 17870,
    "poblacio_1996": 9913
  },
  {
    "code": "46057",
    "latitude": 38.918183623986000,
    "longitude": -0.347658277583464,
    "name": "Benicolet",
    "comarca": 31,
    "gentilici": "benicoletà, benicoletana",
    "poblacio_2025": 610,
    "poblacio_2024": 605,
    "poblacio_2023": 599,
    "poblacio_2022": 597,
    "poblacio_2021": 587,
    "poblacio_2008": 627,
    "poblacio_1996": 501
  },
  {
    "code": "46904",
    "latitude": 39.185695326734600,
    "longitude": -0.382252005178011,
    "name": "Benicull de Xúquer",
    "comarca": 27,
    "gentilici": "benicullenc, benicullenca",
    "poblacio_2025": 1179,
    "poblacio_2024": 1144,
    "poblacio_2023": 1134,
    "poblacio_2022": 1102,
    "poblacio_2021": 1095,
    "poblacio_2008": 950,
    "poblacio_1996": 0
  },
  {
    "code": "03030",
    "latitude": 38.793273173180800,
    "longitude": -0.028088545957847,
    "name": "Benidoleig",
    "comarca": 19,
    "gentilici": "benidolejà, benidolejana",
    "poblacio_2025": 1245,
    "poblacio_2024": 1219,
    "poblacio_2023": 1218,
    "poblacio_2022": 1232,
    "poblacio_2021": 1166,
    "poblacio_2008": 1221,
    "poblacio_1996": 783
  },
  {
    "code": "03031",
    "latitude": 38.541740002087700,
    "longitude": -0.128810467714516,
    "name": "Benidorm",
    "comarca": 20,
    "gentilici": "benidormer, benidormera",
    "poblacio_2025": 77327,
    "poblacio_2024": 74663,
    "poblacio_2023": 72342,
    "poblacio_2022": 69738,
    "poblacio_2021": 69118,
    "poblacio_2008": 70280,
    "poblacio_1996": 50040
  },
  {
    "code": "46060",
    "latitude": 39.285337269743700,
    "longitude": -0.425229380449361,
    "name": "Benifaió",
    "comarca": 26,
    "gentilici": "benifaioner, benifaionera",
    "poblacio_2025": 12262,
    "poblacio_2024": 12130,
    "poblacio_2023": 11984,
    "poblacio_2022": 11877,
    "poblacio_2021": 11967,
    "poblacio_2008": 12119,
    "poblacio_1996": 12178
  },
  {
    "code": "46059",
    "latitude": 39.053550202452600,
    "longitude": -0.302560732313159,
    "name": "Benifairó de la Valldigna",
    "comarca": 28,
    "gentilici": "benifaironer, benifaironera",
    "poblacio_2025": 1588,
    "poblacio_2024": 1560,
    "poblacio_2023": 1554,
    "poblacio_2022": 1552,
    "poblacio_2021": 1542,
    "poblacio_2008": 1697,
    "poblacio_1996": 1669
  },
  {
    "code": "46058",
    "latitude": 39.728358502392900,
    "longitude": -0.268904675246296,
    "name": "Benifairó de les Valls",
    "comarca": 11,
    "gentilici": "benifairenc, benifairenca",
    "poblacio_2025": 2359,
    "poblacio_2024": 2318,
    "poblacio_2023": 2320,
    "poblacio_2022": 2314,
    "poblacio_2021": 2268,
    "poblacio_2008": 2079,
    "poblacio_1996": 1978
  },
  {
    "code": "03032",
    "latitude": 38.662839434353800,
    "longitude": -0.399802150378249,
    "name": "Benifallim",
    "comarca": 3,
    "gentilici": "benifallimer, benifallimera",
    "poblacio_2025": 130,
    "poblacio_2024": 116,
    "poblacio_2023": 111,
    "poblacio_2022": 106,
    "poblacio_2021": 103,
    "poblacio_2008": 115,
    "poblacio_1996": 169
  },
  {
    "code": "03033",
    "latitude": 38.673604673723400,
    "longitude": -0.228849096921813,
    "name": "Benifato",
    "comarca": 20,
    "gentilici": "benifater, benifatera",
    "poblacio_2025": 162,
    "poblacio_2024": 144,
    "poblacio_2023": 140,
    "poblacio_2022": 139,
    "poblacio_2021": 135,
    "poblacio_2008": 194,
    "poblacio_1996": 140
  },
  {
    "code": "46061",
    "latitude": 38.928032936985500,
    "longitude": -0.188645320655787,
    "name": "Beniflà",
    "comarca": 28,
    "gentilici": "beniflater, beniflatera",
    "poblacio_2025": 505,
    "poblacio_2024": 502,
    "poblacio_2023": 484,
    "poblacio_2022": 475,
    "poblacio_2021": 463,
    "poblacio_2008": 396,
    "poblacio_1996": 153
  },
  {
    "code": "46062",
    "latitude": 38.944136858214100,
    "longitude": -0.442978913290687,
    "name": "Benigànim",
    "comarca": 31,
    "gentilici": "beniganí, beniganina",
    "poblacio_2025": 5759,
    "poblacio_2024": 5695,
    "poblacio_2023": 5716,
    "poblacio_2022": 5718,
    "poblacio_2021": 5742,
    "poblacio_2008": 6366,
    "poblacio_1996": 5437
  },
  {
    "code": "03029",
    "latitude": 38.754882859693900,
    "longitude": -0.109159401259660,
    "name": "Benigembla",
    "comarca": 19,
    "gentilici": "benigembler, benigemblera",
    "poblacio_2025": 590,
    "poblacio_2024": 559,
    "poblacio_2023": 537,
    "poblacio_2022": 512,
    "poblacio_2021": 483,
    "poblacio_2008": 571,
    "poblacio_1996": 390
  },
  {
    "code": "03034",
    "latitude": 38.077859646257900,
    "longitude": -0.736721166419741,
    "name": "Benijófar",
    "comarca": 9,
    "gentilici": "benijoferer, benijoferera",
    "poblacio_2025": 3679,
    "poblacio_2024": 3471,
    "poblacio_2023": 3473,
    "poblacio_2022": 3427,
    "poblacio_2021": 3323,
    "poblacio_2008": 3900,
    "poblacio_1996": 1592
  },
  {
    "code": "03035",
    "latitude": 38.700431184611500,
    "longitude": -0.386543082278550,
    "name": "Benilloba",
    "comarca": 14,
    "gentilici": "benillober, benillobera",
    "poblacio_2025": 744,
    "poblacio_2024": 747,
    "poblacio_2023": 737,
    "poblacio_2022": 740,
    "poblacio_2021": 737,
    "poblacio_2008": 837,
    "poblacio_1996": 961
  },
  {
    "code": "03036",
    "latitude": 38.753709627017100,
    "longitude": -0.378825169181213,
    "name": "Benillup",
    "comarca": 14,
    "gentilici": "benilluper, benillupera",
    "poblacio_2025": 110,
    "poblacio_2024": 109,
    "poblacio_2023": 105,
    "poblacio_2022": 108,
    "poblacio_2021": 101,
    "poblacio_2008": 102,
    "poblacio_1996": 105
  },
  {
    "code": "03037",
    "latitude": 38.675914487953700,
    "longitude": -0.209865976481352,
    "name": "Benimantell",
    "comarca": 20,
    "gentilici": "benimantellut, benimantelluda",
    "poblacio_2025": 548,
    "poblacio_2024": 548,
    "poblacio_2023": 534,
    "poblacio_2022": 499,
    "poblacio_2021": 501,
    "poblacio_2008": 472,
    "poblacio_1996": 432
  },
  {
    "code": "03038",
    "latitude": 38.775648609391200,
    "longitude": -0.392548305365183,
    "name": "Benimarfull",
    "comarca": 14,
    "gentilici": "benimarfuller, benimarfullera",
    "poblacio_2025": 465,
    "poblacio_2024": 447,
    "poblacio_2023": 422,
    "poblacio_2022": 410,
    "poblacio_2021": 397,
    "poblacio_2008": 440,
    "poblacio_1996": 408
  },
  {
    "code": "03039",
    "latitude": 38.743876884062400,
    "longitude": -0.294865123716806,
    "name": "Benimassot",
    "comarca": 14,
    "gentilici": "benimassoter, benimassotera",
    "poblacio_2025": 85,
    "poblacio_2024": 96,
    "poblacio_2023": 105,
    "poblacio_2022": 93,
    "poblacio_2021": 97,
    "poblacio_2008": 125,
    "poblacio_1996": 122
  },
  {
    "code": "03040",
    "latitude": 38.822455102744700,
    "longitude": -0.041932904398818,
    "name": "Benimeli",
    "comarca": 19,
    "gentilici": "benimelí, benimelina",
    "poblacio_2025": 474,
    "poblacio_2024": 453,
    "poblacio_2023": 455,
    "poblacio_2022": 419,
    "poblacio_2021": 415,
    "poblacio_2008": 427,
    "poblacio_1996": 329
  },
  {
    "code": "46063",
    "latitude": 39.213319718570100,
    "longitude": -0.527115372890743,
    "name": "Benimodo",
    "comarca": 26,
    "gentilici": "benimodí, benimodina",
    "poblacio_2025": 2332,
    "poblacio_2024": 2316,
    "poblacio_2023": 2279,
    "poblacio_2022": 2233,
    "poblacio_2021": 2253,
    "poblacio_2008": 2209,
    "poblacio_1996": 1757
  },
  {
    "code": "46064",
    "latitude": 39.131471278156200,
    "longitude": -0.492848139237971,
    "name": "Benimuslem",
    "comarca": 26,
    "gentilici": "benimusler, benimuslera",
    "poblacio_2025": 674,
    "poblacio_2024": 665,
    "poblacio_2023": 665,
    "poblacio_2022": 662,
    "poblacio_2021": 653,
    "poblacio_2008": 620,
    "poblacio_1996": 552
  },
  {
    "code": "46065",
    "latitude": 39.385133608824100,
    "longitude": -0.410808086306276,
    "name": "Beniparrell",
    "comarca": 18,
    "gentilici": "beniparrellí, beniparrellina",
    "poblacio_2025": 2108,
    "poblacio_2024": 2091,
    "poblacio_2023": 2074,
    "poblacio_2022": 2020,
    "poblacio_2021": 2024,
    "poblacio_2008": 1955,
    "poblacio_1996": 1510
  },
  {
    "code": "46066",
    "latitude": 38.961802686285500,
    "longitude": -0.193658357176302,
    "name": "Benirredrà",
    "comarca": 28,
    "gentilici": "benirredrà, benirredrana",
    "poblacio_2025": 1576,
    "poblacio_2024": 1561,
    "poblacio_2023": 1571,
    "poblacio_2022": 1548,
    "poblacio_2021": 1547,
    "poblacio_2008": 1566,
    "poblacio_1996": 1008
  },
  {
    "code": "03041",
    "latitude": 38.715281987287500,
    "longitude": 0.050408677116619,
    "name": "Benissa",
    "comarca": 19,
    "gentilici": "benisser, benissera",
    "poblacio_2025": 12471,
    "poblacio_2024": 12317,
    "poblacio_2023": 12279,
    "poblacio_2022": 11871,
    "poblacio_2021": 11462,
    "poblacio_2008": 13140,
    "poblacio_1996": 9154
  },
  {
    "code": "46067",
    "latitude": 39.613233063257300,
    "longitude": -0.575048893013801,
    "name": "Benissanó",
    "comarca": 12,
    "gentilici": "benissaner, benissanera",
    "poblacio_2025": 2449,
    "poblacio_2024": 2427,
    "poblacio_2023": 2385,
    "poblacio_2022": 2345,
    "poblacio_2021": 2334,
    "poblacio_2008": 2136,
    "poblacio_1996": 1672
  },
  {
    "code": "46068",
    "latitude": 38.831915804696300,
    "longitude": -0.529978064628018,
    "name": "Benissoda",
    "comarca": 31,
    "gentilici": "benissodà, benissodana",
    "poblacio_2025": 494,
    "poblacio_2024": 485,
    "poblacio_2023": 460,
    "poblacio_2022": 456,
    "poblacio_2021": 441,
    "poblacio_2008": 371,
    "poblacio_1996": 291
  },
  {
    "code": "46069",
    "latitude": 38.913584647015200,
    "longitude": -0.479136057111818,
    "name": "Benissuera",
    "comarca": 31,
    "gentilici": "benissuerà, benissuerana",
    "poblacio_2025": 196,
    "poblacio_2024": 185,
    "poblacio_2023": 185,
    "poblacio_2022": 188,
    "poblacio_2021": 183,
    "poblacio_2008": 192,
    "poblacio_1996": 196
  },
  {
    "code": "03042",
    "latitude": 38.731443903261300,
    "longitude": 0.147515419214958,
    "name": "el Poble Nou de Benitatxell",
    "comarca": 19,
    "gentilici": "pobler, poblera",
    "poblacio_2025": 4911,
    "poblacio_2024": 4851,
    "poblacio_2023": 4858,
    "poblacio_2022": 4687,
    "poblacio_2021": 4447,
    "poblacio_2008": 5216,
    "poblacio_1996": 1989
  },
  {
    "code": "12029",
    "latitude": 40.210369929576200,
    "longitude": 0.026770761775035,
    "name": "Benlloc",
    "comarca": 21,
    "gentilici": "belloquí, belloquina",
    "poblacio_2025": 1143,
    "poblacio_2024": 1115,
    "poblacio_2023": 1108,
    "poblacio_2022": 1092,
    "poblacio_2021": 1075,
    "poblacio_2008": 1156,
    "poblacio_1996": 876
  },
  {
    "code": "46070",
    "latitude": 39.591462117663200,
    "longitude": -0.461614169872130,
    "name": "Bétera",
    "comarca": 12,
    "gentilici": "beterà, beterana",
    "poblacio_2025": 28560,
    "poblacio_2024": 27584,
    "poblacio_2023": 26759,
    "poblacio_2022": 26289,
    "poblacio_2021": 25423,
    "poblacio_2008": 20292,
    "poblacio_1996": 11619
  },
  {
    "code": "12021",
    "latitude": 39.927142540478300,
    "longitude": -0.198248482853386,
    "name": "Betxí",
    "comarca": 22,
    "gentilici": "betxinenc, betxinenca",
    "poblacio_2025": 5659,
    "poblacio_2024": 5592,
    "poblacio_2023": 5580,
    "poblacio_2022": 5587,
    "poblacio_2021": 5605,
    "poblacio_2008": 5860,
    "poblacio_1996": 5284
  },
  {
    "code": "03043",
    "latitude": 38.623467930183100,
    "longitude": -0.761914848140025,
    "name": "Biar",
    "comarca": 7,
    "gentilici": "biarenc, biarenca \/ biarut, biaruda",
    "poblacio_2025": 3677,
    "poblacio_2024": 3634,
    "poblacio_2023": 3607,
    "poblacio_2022": 3612,
    "poblacio_2021": 3628,
    "poblacio_2008": 3694,
    "poblacio_1996": 3568
  },
  {
    "code": "46071",
    "latitude": 39.131912859078200,
    "longitude": -0.787060523057383,
    "name": "Bicorp",
    "comarca": 13,
    "gentilici": "bicorbí, bicorbina",
    "poblacio_2025": 546,
    "poblacio_2024": 560,
    "poblacio_2023": 549,
    "poblacio_2022": 524,
    "poblacio_2021": 527,
    "poblacio_2008": 596,
    "poblacio_1996": 697
  },
  {
    "code": "03044",
    "latitude": 38.061910233904000,
    "longitude": -0.899059338273202,
    "name": "Bigastro",
    "comarca": 9,
    "gentilici": "bigastrenc, bigastrenca",
    "poblacio_2025": 7537,
    "poblacio_2024": 7431,
    "poblacio_2023": 7361,
    "poblacio_2022": 7130,
    "poblacio_2021": 6994,
    "poblacio_2008": 6761,
    "poblacio_1996": 4721
  },
  {
    "code": "46072",
    "latitude": 38.765420805742400,
    "longitude": -0.611316751450338,
    "name": "Bocairent",
    "comarca": 31,
    "gentilici": "bocairentí, bocairentina",
    "poblacio_2025": 4130,
    "poblacio_2024": 4148,
    "poblacio_2023": 4115,
    "poblacio_2022": 4123,
    "poblacio_2021": 4101,
    "poblacio_2008": 4514,
    "poblacio_1996": 4627
  },
  {
    "code": "46073",
    "latitude": 39.061181597534000,
    "longitude": -0.674052030630947,
    "name": "Bolbaite",
    "comarca": 13,
    "gentilici": "bolbaití, bolbaitina",
    "poblacio_2025": 1320,
    "poblacio_2024": 1333,
    "poblacio_2023": 1334,
    "poblacio_2022": 1338,
    "poblacio_2021": 1336,
    "poblacio_2008": 1487,
    "poblacio_1996": 1439
  },
  {
    "code": "03045",
    "latitude": 38.676633030918900,
    "longitude": -0.112234349623392,
    "name": "Bolulla",
    "comarca": 20,
    "gentilici": "boluller, bolullera",
    "poblacio_2025": 490,
    "poblacio_2024": 486,
    "poblacio_2023": 440,
    "poblacio_2022": 413,
    "poblacio_2021": 426,
    "poblacio_2008": 415,
    "poblacio_1996": 306
  },
  {
    "code": "46074",
    "latitude": 39.518729073430600,
    "longitude": -0.364667439246475,
    "name": "Bonrepòs i Mirambell",
    "comarca": 17,
    "gentilici": "bonreposí, bonreposina",
    "poblacio_2025": 4115,
    "poblacio_2024": 4048,
    "poblacio_2023": 3907,
    "poblacio_2022": 3831,
    "poblacio_2021": 3780,
    "poblacio_2008": 3132,
    "poblacio_1996": 2377
  },
  {
    "code": "12032",
    "latitude": 39.888644016201000,
    "longitude": -0.084845351898685,
    "name": "Borriana",
    "comarca": 22,
    "gentilici": "borrianenc, borrianenca",
    "poblacio_2025": 37915,
    "poblacio_2024": 36927,
    "poblacio_2023": 35750,
    "poblacio_2022": 35019,
    "poblacio_2021": 34903,
    "poblacio_2008": 34235,
    "poblacio_1996": 26211
  },
  {
    "code": "12031",
    "latitude": 40.041849326198600,
    "longitude": -0.070525029590386,
    "name": "Borriol",
    "comarca": 21,
    "gentilici": "borriolenc, borriolenca",
    "poblacio_2025": 6018,
    "poblacio_2024": 5945,
    "poblacio_2023": 5865,
    "poblacio_2022": 5749,
    "poblacio_2021": 5552,
    "poblacio_2008": 4874,
    "poblacio_1996": 3129
  },
  {
    "code": "46075",
    "latitude": 38.868192625909800,
    "longitude": -0.515178334638358,
    "name": "Bufali",
    "comarca": 31,
    "gentilici": "bufalità, bufalitana",
    "poblacio_2025": 162,
    "poblacio_2024": 154,
    "poblacio_2023": 156,
    "poblacio_2022": 156,
    "poblacio_2021": 163,
    "poblacio_2008": 191,
    "poblacio_1996": 220
  },
  {
    "code": "46076",
    "latitude": 39.609239685760900,
    "longitude": -0.775833101009765,
    "name": "Bugarra",
    "comarca": 29,
    "gentilici": "bugarrenc, bugarrenca",
    "poblacio_2025": 774,
    "poblacio_2024": 781,
    "poblacio_2023": 783,
    "poblacio_2022": 747,
    "poblacio_2021": 728,
    "poblacio_2008": 871,
    "poblacio_1996": 855
  },
  {
    "code": "46077",
    "latitude": 39.418739309883000,
    "longitude": -0.790596614151768,
    "name": "Buñol",
    "comarca": 16,
    "gentilici": "bunyolenc, bunyolenca",
    "poblacio_2025": 9858,
    "poblacio_2024": 9765,
    "poblacio_2023": 9579,
    "poblacio_2022": 9503,
    "poblacio_2021": 9438,
    "poblacio_2008": 9940,
    "poblacio_1996": 9410
  },
  {
    "code": "46078",
    "latitude": 39.511134533844000,
    "longitude": -0.415763377320245,
    "name": "Burjassot",
    "comarca": 17,
    "gentilici": "burjassoter, burjassotera",
    "poblacio_2025": 41299,
    "poblacio_2024": 40634,
    "poblacio_2023": 39702,
    "poblacio_2022": 38880,
    "poblacio_2021": 38712,
    "poblacio_2008": 37667,
    "poblacio_1996": 34061
  },
  {
    "code": "03046",
    "latitude": 38.483531729719400,
    "longitude": -0.418258521650184,
    "name": "Busot",
    "comarca": 1,
    "gentilici": "busoter, busotera",
    "poblacio_2025": 3782,
    "poblacio_2024": 3629,
    "poblacio_2023": 3534,
    "poblacio_2022": 3343,
    "poblacio_2021": 3207,
    "poblacio_2008": 3021,
    "poblacio_1996": 1373
  },
  {
    "code": "12033",
    "latitude": 40.156890090168000,
    "longitude": 0.043841766477744,
    "name": "Cabanes",
    "comarca": 21,
    "gentilici": "cabanyut, cabanyuda",
    "poblacio_2025": 3475,
    "poblacio_2024": 3313,
    "poblacio_2023": 3222,
    "poblacio_2022": 3079,
    "poblacio_2021": 3027,
    "poblacio_2008": 3088,
    "poblacio_1996": 2364
  },
  {
    "code": "12034",
    "latitude": 40.460899532938800,
    "longitude": 0.354210137735480,
    "name": "Càlig",
    "comarca": 8,
    "gentilici": "calijó, calijona",
    "poblacio_2025": 2042,
    "poblacio_2024": 2048,
    "poblacio_2023": 2013,
    "poblacio_2022": 1990,
    "poblacio_2021": 2002,
    "poblacio_2008": 2170,
    "poblacio_1996": 1774
  },
  {
    "code": "46079",
    "latitude": 39.724092266642100,
    "longitude": -0.973973820549050,
    "name": "Calles",
    "comarca": 29,
    "gentilici": "callesà, callesana",
    "poblacio_2025": 465,
    "poblacio_2024": 447,
    "poblacio_2023": 431,
    "poblacio_2022": 374,
    "poblacio_2021": 368,
    "poblacio_2008": 439,
    "poblacio_1996": 435
  },
  {
    "code": "03048",
    "latitude": 38.650787052432500,
    "longitude": -0.123356175990602,
    "name": "Callosa d'en Sarrià",
    "comarca": 20,
    "gentilici": "callosí, callosina",
    "poblacio_2025": 8182,
    "poblacio_2024": 7959,
    "poblacio_2023": 7708,
    "poblacio_2022": 7653,
    "poblacio_2021": 7589,
    "poblacio_2008": 8224,
    "poblacio_1996": 6322
  },
  {
    "code": "03049",
    "latitude": 38.123334087860300,
    "longitude": -0.879603067365871,
    "name": "Callosa de Segura",
    "comarca": 9,
    "gentilici": "callosí, callosina",
    "poblacio_2025": 19988,
    "poblacio_2024": 19658,
    "poblacio_2023": 19484,
    "poblacio_2022": 19315,
    "poblacio_2021": 19273,
    "poblacio_2008": 17425,
    "poblacio_1996": 15230
  },
  {
    "code": "03047",
    "latitude": 38.647137556025000,
    "longitude": 0.048717436242314,
    "name": "Calp",
    "comarca": 19,
    "gentilici": "calpí, calpina",
    "poblacio_2025": 27616,
    "poblacio_2024": 26821,
    "poblacio_2023": 25854,
    "poblacio_2022": 24096,
    "poblacio_2021": 23530,
    "poblacio_2008": 29228,
    "poblacio_1996": 14216
  },
  {
    "code": "03050",
    "latitude": 38.427891629619100,
    "longitude": -0.401216289635348,
    "name": "el Campello",
    "comarca": 1,
    "gentilici": "campeller, campellera",
    "poblacio_2025": 31419,
    "poblacio_2024": 30600,
    "poblacio_2023": 29993,
    "poblacio_2022": 29409,
    "poblacio_2021": 29013,
    "poblacio_2008": 26043,
    "poblacio_1996": 15200
  },
  {
    "code": "03051",
    "latitude": 38.686756442243600,
    "longitude": -0.777277512701301,
    "name": "el Camp de Mirra",
    "comarca": 7,
    "gentilici": "mirrenc, mirrenca",
    "poblacio_2025": 447,
    "poblacio_2024": 445,
    "poblacio_2023": 442,
    "poblacio_2022": 433,
    "poblacio_2021": 429,
    "poblacio_2008": 426,
    "poblacio_1996": 379
  },
  {
    "code": "46080",
    "latitude": 39.647320341119600,
    "longitude": -1.399902218404890,
    "name": "Camporrobles",
    "comarca": 23,
    "gentilici": "camporrutenc, camporrutenca",
    "poblacio_2025": 1183,
    "poblacio_2024": 1188,
    "poblacio_2023": 1189,
    "poblacio_2022": 1196,
    "poblacio_2021": 1204,
    "poblacio_2008": 1423,
    "poblacio_1996": 1398
  },
  {
    "code": "46081",
    "latitude": 38.961876585773600,
    "longitude": -0.583525240723258,
    "name": "Canals",
    "comarca": 15,
    "gentilici": "canalí, canalina",
    "poblacio_2025": 13746,
    "poblacio_2024": 13415,
    "poblacio_2023": 13162,
    "poblacio_2022": 13187,
    "poblacio_2021": 13257,
    "poblacio_2008": 13851,
    "poblacio_1996": 12886
  },
  {
    "code": "46082",
    "latitude": 39.679668606786100,
    "longitude": -0.223235435413544,
    "name": "Canet d'en Berenguer",
    "comarca": 11,
    "gentilici": "caneter, canetera",
    "poblacio_2025": 8297,
    "poblacio_2024": 7771,
    "poblacio_2023": 7265,
    "poblacio_2022": 6942,
    "poblacio_2021": 6812,
    "poblacio_2008": 5418,
    "poblacio_1996": 1975
  },
  {
    "code": "12036",
    "latitude": 40.551304144478000,
    "longitude": 0.243340960560242,
    "name": "Canet lo Roig",
    "comarca": 8,
    "gentilici": "caneter, canetera",
    "poblacio_2025": 715,
    "poblacio_2024": 699,
    "poblacio_2023": 685,
    "poblacio_2022": 680,
    "poblacio_2021": 687,
    "poblacio_2008": 897,
    "poblacio_1996": 934
  },
  {
    "code": "03052",
    "latitude": 38.673084545008300,
    "longitude": -0.814523373338010,
    "name": "la Canyada",
    "comarca": 7,
    "gentilici": "canyut, canyuda",
    "poblacio_2025": 1213,
    "poblacio_2024": 1225,
    "poblacio_2023": 1210,
    "poblacio_2022": 1191,
    "poblacio_2021": 1191,
    "poblacio_2008": 1217,
    "poblacio_1996": 1088
  },
  {
    "code": "46083",
    "latitude": 39.123446608826600,
    "longitude": -0.445763556934121,
    "name": "Carcaixent",
    "comarca": 26,
    "gentilici": "carcaixentí, carcaixentina",
    "poblacio_2025": 21934,
    "poblacio_2024": 21317,
    "poblacio_2023": 20777,
    "poblacio_2022": 20498,
    "poblacio_2021": 20494,
    "poblacio_2008": 21973,
    "poblacio_1996": 20397
  },
  {
    "code": "46084",
    "latitude": 39.068419152143800,
    "longitude": -0.567003656851359,
    "name": "Càrcer",
    "comarca": 26,
    "gentilici": "carcerí, carcerina",
    "poblacio_2025": 1795,
    "poblacio_2024": 1806,
    "poblacio_2023": 1826,
    "poblacio_2022": 1808,
    "poblacio_2021": 1822,
    "poblacio_2008": 2120,
    "poblacio_1996": 2022
  },
  {
    "code": "46085",
    "latitude": 39.225022917245000,
    "longitude": -0.519703911849909,
    "name": "Carlet",
    "comarca": 26,
    "gentilici": "carletí, carletina",
    "poblacio_2025": 16857,
    "poblacio_2024": 16428,
    "poblacio_2023": 16141,
    "poblacio_2022": 15945,
    "poblacio_2021": 15851,
    "poblacio_2008": 15366,
    "poblacio_1996": 14366
  },
  {
    "code": "46086",
    "latitude": 38.840712345833400,
    "longitude": -0.471423627722351,
    "name": "Carrícola",
    "comarca": 31,
    "gentilici": "carricolí, carricolina",
    "poblacio_2025": 97,
    "poblacio_2024": 99,
    "poblacio_2023": 102,
    "poblacio_2022": 99,
    "poblacio_2021": 102,
    "poblacio_2008": 82,
    "poblacio_1996": 77
  },
  {
    "code": "46087",
    "latitude": 40.040012855281100,
    "longitude": -1.263671417871450,
    "name": "Casas Altas",
    "comarca": 25,
    "gentilici": "casalter, casaltera",
    "poblacio_2025": 118,
    "poblacio_2024": 139,
    "poblacio_2023": 146,
    "poblacio_2022": 132,
    "poblacio_2021": 132,
    "poblacio_2008": 188,
    "poblacio_1996": 165
  },
  {
    "code": "46088",
    "latitude": 40.023724851432300,
    "longitude": -1.261137963361670,
    "name": "Casas Bajas",
    "comarca": 25,
    "gentilici": "casabaixer, casabaixera",
    "poblacio_2025": 158,
    "poblacio_2024": 167,
    "poblacio_2023": 173,
    "poblacio_2022": 171,
    "poblacio_2021": 164,
    "poblacio_2008": 231,
    "poblacio_1996": 316
  },
  {
    "code": "46089",
    "latitude": 39.699400185923300,
    "longitude": -0.707534275076074,
    "name": "Casinos",
    "comarca": 12,
    "gentilici": "casiner, casinera",
    "poblacio_2025": 3153,
    "poblacio_2024": 3113,
    "poblacio_2023": 3091,
    "poblacio_2022": 2994,
    "poblacio_2021": 2881,
    "poblacio_2008": 2590,
    "poblacio_1996": 2292
  },
  {
    "code": "03053",
    "latitude": 38.593858465395100,
    "longitude": -0.671288990904097,
    "name": "Castalla",
    "comarca": 3,
    "gentilici": "castallut, castalluda",
    "poblacio_2025": 11908,
    "poblacio_2024": 11622,
    "poblacio_2023": 11365,
    "poblacio_2022": 11097,
    "poblacio_2021": 10752,
    "poblacio_2008": 10021,
    "poblacio_1996": 7631
  },
  {
    "code": "12037",
    "latitude": 40.660960836743000,
    "longitude": 0.042736360183634,
    "name": "Castell de Cabres",
    "comarca": 8,
    "gentilici": "castellenc, castellenca",
    "poblacio_2025": 21,
    "poblacio_2024": 22,
    "poblacio_2023": 19,
    "poblacio_2022": 20,
    "poblacio_2021": 22,
    "poblacio_2008": 18,
    "poblacio_1996": 24
  },
  {
    "code": "03054",
    "latitude": 38.725101838466400,
    "longitude": -0.193867154888848,
    "name": "Castell de Castells",
    "comarca": 19,
    "gentilici": "castellenc, castellenca",
    "poblacio_2025": 443,
    "poblacio_2024": 444,
    "poblacio_2023": 445,
    "poblacio_2022": 426,
    "poblacio_2021": 425,
    "poblacio_2008": 505,
    "poblacio_1996": 499
  },
  {
    "code": "03075",
    "latitude": 38.675379454484900,
    "longitude": -0.199627526921986,
    "name": "el Castell de Guadalest",
    "comarca": 20,
    "gentilici": "castellenc, castellenca",
    "poblacio_2025": 284,
    "poblacio_2024": 282,
    "poblacio_2023": 274,
    "poblacio_2022": 258,
    "poblacio_2021": 243,
    "poblacio_2008": 217,
    "poblacio_1996": 169
  },
  {
    "code": "12038",
    "latitude": 40.501155860165400,
    "longitude": -0.189519291083460,
    "name": "Castellfort",
    "comarca": 24,
    "gentilici": "castellfortí, castellfortina",
    "poblacio_2025": 178,
    "poblacio_2024": 190,
    "poblacio_2023": 188,
    "poblacio_2022": 188,
    "poblacio_2021": 179,
    "poblacio_2008": 235,
    "poblacio_1996": 245
  },
  {
    "code": "12039",
    "latitude": 39.861559841766900,
    "longitude": -0.457099662202915,
    "name": "Castellnovo",
    "comarca": 6,
    "gentilici": "castellnovenc, castellnovenca",
    "poblacio_2025": 912,
    "poblacio_2024": 884,
    "poblacio_2023": 888,
    "poblacio_2022": 893,
    "poblacio_2021": 914,
    "poblacio_2008": 1080,
    "poblacio_1996": 1037
  },
  {
    "code": "12040",
    "latitude": 39.987641656445900,
    "longitude": -0.041258163803198,
    "name": "Castelló de la Plana",
    "comarca": 21,
    "gentilici": "castellonenc, castellonenca",
    "poblacio_2025": 183711,
    "poblacio_2024": 180379,
    "poblacio_2023": 176238,
    "poblacio_2022": 171857,
    "poblacio_2021": 172589,
    "poblacio_2008": 177924,
    "poblacio_1996": 135729
  },
  {
    "code": "46090",
    "latitude": 38.874301333632700,
    "longitude": -0.382870635534753,
    "name": "Castelló de Rugat",
    "comarca": 31,
    "gentilici": "castellonenc, castellonenca",
    "poblacio_2025": 2345,
    "poblacio_2024": 2352,
    "poblacio_2023": 2322,
    "poblacio_2022": 2315,
    "poblacio_2021": 2316,
    "poblacio_2008": 2405,
    "poblacio_1996": 2069
  },
  {
    "code": "46091",
    "latitude": 38.915342948415400,
    "longitude": -0.263443938969863,
    "name": "Castellonet de la Conquesta",
    "comarca": 28,
    "gentilici": "castellonetí, castellonetina",
    "poblacio_2025": 159,
    "poblacio_2024": 144,
    "poblacio_2023": 149,
    "poblacio_2022": 137,
    "poblacio_2021": 139,
    "poblacio_2008": 164,
    "poblacio_1996": 144
  },
  {
    "code": "46092",
    "latitude": 40.130714866718700,
    "longitude": -1.304352442082290,
    "name": "Castielfabib",
    "comarca": 25,
    "gentilici": "castieler, castielera",
    "poblacio_2025": 284,
    "poblacio_2024": 287,
    "poblacio_2023": 297,
    "poblacio_2022": 291,
    "poblacio_2021": 299,
    "poblacio_2008": 232,
    "poblacio_1996": 561
  },
  {
    "code": "12041",
    "latitude": 40.130252720653900,
    "longitude": -0.380631245666116,
    "name": "Castillo de Villamalefa",
    "comarca": 5,
    "gentilici": "casteller, castellera",
    "poblacio_2025": 110,
    "poblacio_2024": 113,
    "poblacio_2023": 109,
    "poblacio_2022": 112,
    "poblacio_2021": 103,
    "poblacio_2008": 88,
    "poblacio_1996": 137
  },
  {
    "code": "46093",
    "latitude": 39.269658439428300,
    "longitude": -0.592394354739628,
    "name": "Catadau",
    "comarca": 26,
    "gentilici": "catadauí, catadauina",
    "poblacio_2025": 3005,
    "poblacio_2024": 2967,
    "poblacio_2023": 2939,
    "poblacio_2022": 2862,
    "poblacio_2021": 2846,
    "poblacio_2008": 2649,
    "poblacio_1996": 2189
  },
  {
    "code": "46094",
    "latitude": 39.404560480171800,
    "longitude": -0.403330672691847,
    "name": "Catarroja",
    "comarca": 18,
    "gentilici": "catarrogí, catarrogina",
    "poblacio_2025": 30604,
    "poblacio_2024": 30142,
    "poblacio_2023": 29316,
    "poblacio_2022": 28679,
    "poblacio_2021": 28509,
    "poblacio_2008": 26552,
    "poblacio_1996": 20627
  },
  {
    "code": "12042",
    "latitude": 40.470963750119600,
    "longitude": 0.022195374185172,
    "name": "Catí",
    "comarca": 4,
    "gentilici": "catinenc, catinenca",
    "poblacio_2025": 719,
    "poblacio_2024": 760,
    "poblacio_2023": 724,
    "poblacio_2022": 711,
    "poblacio_2021": 714,
    "poblacio_2008": 861,
    "poblacio_1996": 912
  },
  {
    "code": "03055",
    "latitude": 38.161859070977900,
    "longitude": -0.800366891121813,
    "name": "Catral",
    "comarca": 9,
    "gentilici": "catralenc, catralenca",
    "poblacio_2025": 9600,
    "poblacio_2024": 9423,
    "poblacio_2023": 9275,
    "poblacio_2022": 8976,
    "poblacio_2021": 8880,
    "poblacio_2008": 8629,
    "poblacio_1996": 4881
  },
  {
    "code": "46095",
    "latitude": 39.559605745221000,
    "longitude": -1.278045702603570,
    "name": "Caudete de las Fuentes",
    "comarca": 23,
    "gentilici": "caudetenc, caudetenca",
    "poblacio_2025": 725,
    "poblacio_2024": 720,
    "poblacio_2023": 693,
    "poblacio_2022": 701,
    "poblacio_2021": 701,
    "poblacio_2008": 796,
    "poblacio_1996": 845
  },
  {
    "code": "12043",
    "latitude": 39.947657246248400,
    "longitude": -0.569253730700181,
    "name": "Caudiel",
    "comarca": 6,
    "gentilici": "caudielà, caudielana",
    "poblacio_2025": 735,
    "poblacio_2024": 722,
    "poblacio_2023": 716,
    "poblacio_2022": 674,
    "poblacio_2021": 663,
    "poblacio_2008": 724,
    "poblacio_1996": 712
  },
  {
    "code": "46096",
    "latitude": 38.986246403801800,
    "longitude": -0.573870661034405,
    "name": "Cerdà",
    "comarca": 15,
    "gentilici": "cerdaí, cerdaïna",
    "poblacio_2025": 370,
    "poblacio_2024": 367,
    "poblacio_2023": 360,
    "poblacio_2022": 351,
    "poblacio_2021": 345,
    "poblacio_2008": 379,
    "poblacio_1996": 282
  },
  {
    "code": "12044",
    "latitude": 40.455344949277100,
    "longitude": 0.275173418259093,
    "name": "Cervera del Maestrat",
    "comarca": 8,
    "gentilici": "cerverí, cerverina",
    "poblacio_2025": 617,
    "poblacio_2024": 643,
    "poblacio_2023": 656,
    "poblacio_2022": 593,
    "poblacio_2021": 577,
    "poblacio_2008": 748,
    "poblacio_1996": 746
  },
  {
    "code": "46107",
    "latitude": 39.041617953634400,
    "longitude": -0.659438814982065,
    "name": "Chella",
    "comarca": 13,
    "gentilici": "xellí, xellina",
    "poblacio_2025": 2452,
    "poblacio_2024": 2439,
    "poblacio_2023": 2445,
    "poblacio_2022": 2434,
    "poblacio_2021": 2437,
    "poblacio_2008": 2860,
    "poblacio_1996": 2539
  },
  {
    "code": "46106",
    "latitude": 39.748209746755100,
    "longitude": -0.997133604130865,
    "name": "Chelva",
    "comarca": 29,
    "gentilici": "xelvà, xelvana",
    "poblacio_2025": 1863,
    "poblacio_2024": 1677,
    "poblacio_2023": 1645,
    "poblacio_2022": 1597,
    "poblacio_2021": 1583,
    "poblacio_2008": 1803,
    "poblacio_1996": 2211
  },
  {
    "code": "46108",
    "latitude": 39.592575617626300,
    "longitude": -0.974106508095721,
    "name": "Chera",
    "comarca": 23,
    "gentilici": "xerà, xerana",
    "poblacio_2025": 508,
    "poblacio_2024": 491,
    "poblacio_2023": 483,
    "poblacio_2022": 492,
    "poblacio_2021": 490,
    "poblacio_2008": 619,
    "poblacio_1996": 582
  },
  {
    "code": "46109",
    "latitude": 39.494486529044000,
    "longitude": -0.685159054903582,
    "name": "Cheste",
    "comarca": 16,
    "gentilici": "xestà, xestana",
    "poblacio_2025": 8951,
    "poblacio_2024": 9022,
    "poblacio_2023": 8962,
    "poblacio_2022": 8971,
    "poblacio_2021": 8871,
    "poblacio_2008": 8127,
    "poblacio_1996": 6857
  },
  {
    "code": "12053",
    "latitude": 39.782901060215600,
    "longitude": -0.187104824428727,
    "name": "Xilxes",
    "comarca": 22,
    "gentilici": "xilxer, xilxera",
    "poblacio_2025": 3199,
    "poblacio_2024": 3094,
    "poblacio_2023": 2981,
    "poblacio_2022": 2846,
    "poblacio_2021": 2795,
    "poblacio_2008": 2821,
    "poblacio_1996": 2216
  },
  {
    "code": "46111",
    "latitude": 39.472987588468700,
    "longitude": -0.718946509645240,
    "name": "Chiva",
    "comarca": 16,
    "gentilici": "xivà, xivana",
    "poblacio_2025": 17951,
    "poblacio_2024": 17245,
    "poblacio_2023": 16750,
    "poblacio_2022": 16285,
    "poblacio_2021": 15769,
    "poblacio_2008": 13494,
    "poblacio_1996": 8794
  },
  {
    "code": "12055",
    "latitude": 40.245268171378000,
    "longitude": -0.287294252575441,
    "name": "Xodos",
    "comarca": 2,
    "gentilici": "xodenc, xodenca",
    "poblacio_2025": 107,
    "poblacio_2024": 116,
    "poblacio_2023": 117,
    "poblacio_2022": 120,
    "poblacio_2021": 109,
    "poblacio_2008": 122,
    "poblacio_1996": 161
  },
  {
    "code": "12056",
    "latitude": 39.851577833207900,
    "longitude": -0.320636134349363,
    "name": "Chóvar",
    "comarca": 6,
    "gentilici": "xover, xovera",
    "poblacio_2025": 316,
    "poblacio_2024": 312,
    "poblacio_2023": 310,
    "poblacio_2022": 304,
    "poblacio_2021": 302,
    "poblacio_2008": 354,
    "poblacio_1996": 398
  },
  {
    "code": "46112",
    "latitude": 39.656202124859400,
    "longitude": -0.891936295613230,
    "name": "Chulilla",
    "comarca": 29,
    "gentilici": "xulillà, xulillana",
    "poblacio_2025": 710,
    "poblacio_2024": 677,
    "poblacio_2023": 687,
    "poblacio_2022": 692,
    "poblacio_2021": 700,
    "poblacio_2008": 848,
    "poblacio_1996": 744
  },
  {
    "code": "12045",
    "latitude": 40.582705017144500,
    "longitude": -0.215717074281116,
    "name": "Cinctorres",
    "comarca": 24,
    "gentilici": "cinctorrà, cinctorrana",
    "poblacio_2025": 433,
    "poblacio_2024": 442,
    "poblacio_2023": 427,
    "poblacio_2022": 412,
    "poblacio_2021": 404,
    "poblacio_2008": 504,
    "poblacio_1996": 591
  },
  {
    "code": "12046",
    "latitude": 40.055180678151900,
    "longitude": -0.461943384976810,
    "name": "Cirat",
    "comarca": 5,
    "gentilici": "cirater, ciratera",
    "poblacio_2025": 220,
    "poblacio_2024": 214,
    "poblacio_2023": 223,
    "poblacio_2022": 226,
    "poblacio_2021": 211,
    "poblacio_2008": 256,
    "poblacio_1996": 302
  },
  {
    "code": "03056",
    "latitude": 38.742463887062000,
    "longitude": -0.439493236861524,
    "name": "Cocentaina",
    "comarca": 14,
    "gentilici": "contestà, contestana \/ cocentainer, cocentainera",
    "poblacio_2025": 11498,
    "poblacio_2024": 11411,
    "poblacio_2023": 11309,
    "poblacio_2022": 11298,
    "poblacio_2021": 11451,
    "poblacio_2008": 11383,
    "poblacio_1996": 10737
  },
  {
    "code": "46097",
    "latitude": 39.230285582524100,
    "longitude": -1.060740713431180,
    "name": "Cofrentes",
    "comarca": 32,
    "gentilici": "cofrentí, cofrentina",
    "poblacio_2025": 1113,
    "poblacio_2024": 1123,
    "poblacio_2023": 1130,
    "poblacio_2022": 1112,
    "poblacio_2021": 1122,
    "poblacio_2008": 974,
    "poblacio_1996": 1007
  },
  {
    "code": "03057",
    "latitude": 38.683753358255900,
    "longitude": -0.269191374629643,
    "name": "Confrides",
    "comarca": 20,
    "gentilici": "confridenc, confridenca",
    "poblacio_2025": 293,
    "poblacio_2024": 296,
    "poblacio_2023": 297,
    "poblacio_2022": 282,
    "poblacio_2021": 271,
    "poblacio_2008": 279,
    "poblacio_1996": 300
  },
  {
    "code": "46098",
    "latitude": 39.158636001687600,
    "longitude": -0.353622379370073,
    "name": "Corbera",
    "comarca": 27,
    "gentilici": "corberà, corberana",
    "poblacio_2025": 3266,
    "poblacio_2024": 3173,
    "poblacio_2023": 3118,
    "poblacio_2022": 3097,
    "poblacio_2021": 3088,
    "poblacio_2008": 3300,
    "poblacio_1996": 3148
  },
  {
    "code": "12048",
    "latitude": 40.188502485982200,
    "longitude": -0.541731730606538,
    "name": "Cortes de Arenoso",
    "comarca": 5,
    "gentilici": "cortesà, cortesana",
    "poblacio_2025": 308,
    "poblacio_2024": 311,
    "poblacio_2023": 304,
    "poblacio_2022": 293,
    "poblacio_2021": 291,
    "poblacio_2008": 355,
    "poblacio_1996": 411
  },
  {
    "code": "46099",
    "latitude": 39.242532977704400,
    "longitude": -0.939537387015159,
    "name": "Cortes de Pallás",
    "comarca": 32,
    "gentilici": "cortesà, cortesana",
    "poblacio_2025": 727,
    "poblacio_2024": 758,
    "poblacio_2023": 753,
    "poblacio_2022": 733,
    "poblacio_2021": 758,
    "poblacio_2008": 974,
    "poblacio_1996": 602
  },
  {
    "code": "12049",
    "latitude": 40.119623511056000,
    "longitude": -0.174101139242820,
    "name": "Costur",
    "comarca": 2,
    "gentilici": "costurenc, costurenca",
    "poblacio_2025": 511,
    "poblacio_2024": 535,
    "poblacio_2023": 535,
    "poblacio_2022": 528,
    "poblacio_2021": 531,
    "poblacio_2008": 579,
    "poblacio_1996": 466
  },
  {
    "code": "46100",
    "latitude": 39.070640009796400,
    "longitude": -0.575048268694154,
    "name": "Cotes",
    "comarca": 26,
    "gentilici": "coter, cotera",
    "poblacio_2025": 314,
    "poblacio_2024": 311,
    "poblacio_2023": 314,
    "poblacio_2022": 323,
    "poblacio_2021": 326,
    "poblacio_2008": 378,
    "poblacio_1996": 375
  },
  {
    "code": "12050",
    "latitude": 40.311272292178800,
    "longitude": 0.120311670122658,
    "name": "les Coves de Vinromà",
    "comarca": 21,
    "gentilici": "covarxí, covarxina",
    "poblacio_2025": 1888,
    "poblacio_2024": 1865,
    "poblacio_2023": 1831,
    "poblacio_2022": 1791,
    "poblacio_2021": 1792,
    "poblacio_2008": 2093,
    "poblacio_1996": 1857
  },
  {
    "code": "03058",
    "latitude": 38.139748479845500,
    "longitude": -0.886766763888338,
    "name": "Cox",
    "comarca": 9,
    "gentilici": "coixenc, coixenca",
    "poblacio_2025": 7722,
    "poblacio_2024": 7622,
    "poblacio_2023": 7513,
    "poblacio_2022": 7431,
    "poblacio_2021": 7427,
    "poblacio_2008": 6642,
    "poblacio_1996": 5750
  },
  {
    "code": "03059",
    "latitude": 38.248749179535200,
    "longitude": -0.809655339395048,
    "name": "Crevillent",
    "comarca": 10,
    "gentilici": "crevillentí, crevillentina",
    "poblacio_2025": 30921,
    "poblacio_2024": 30585,
    "poblacio_2023": 30191,
    "poblacio_2022": 29881,
    "poblacio_2021": 29717,
    "poblacio_2008": 28432,
    "poblacio_1996": 23781
  },
  {
    "code": "12051",
    "latitude": 40.337400515375800,
    "longitude": -0.165209205256084,
    "name": "Culla",
    "comarca": 4,
    "gentilici": "cullà, cullana \/ cullerà, cullerana",
    "poblacio_2025": 503,
    "poblacio_2024": 493,
    "poblacio_2023": 480,
    "poblacio_2022": 499,
    "poblacio_2021": 510,
    "poblacio_2008": 650,
    "poblacio_1996": 844
  },
  {
    "code": "46105",
    "latitude": 39.163619408227300,
    "longitude": -0.245764997522481,
    "name": "Cullera",
    "comarca": 27,
    "gentilici": "cullerà, cullerana",
    "poblacio_2025": 24702,
    "poblacio_2024": 24181,
    "poblacio_2023": 23753,
    "poblacio_2022": 22937,
    "poblacio_2021": 22708,
    "poblacio_2008": 23777,
    "poblacio_1996": 20595
  },
  {
    "code": "46113",
    "latitude": 38.973861704369100,
    "longitude": -0.143435032012713,
    "name": "Daimús",
    "comarca": 28,
    "gentilici": "daimuser, daimusera",
    "poblacio_2025": 3524,
    "poblacio_2024": 3419,
    "poblacio_2023": 3348,
    "poblacio_2022": 3274,
    "poblacio_2021": 3277,
    "poblacio_2008": 3007,
    "poblacio_1996": 1389
  },
  {
    "code": "03061",
    "latitude": 38.114483732220800,
    "longitude": -0.761595941497144,
    "name": "Daya Nueva",
    "comarca": 9,
    "gentilici": "daianovés, daianovesa",
    "poblacio_2025": 1885,
    "poblacio_2024": 1832,
    "poblacio_2023": 1767,
    "poblacio_2022": 1758,
    "poblacio_2021": 1757,
    "poblacio_2008": 1903,
    "poblacio_1996": 1189
  },
  {
    "code": "03062",
    "latitude": 38.105378769236000,
    "longitude": -0.738032672156508,
    "name": "Daya Vieja",
    "comarca": 9,
    "gentilici": "daiavellenc, daiavellenca",
    "poblacio_2025": 698,
    "poblacio_2024": 657,
    "poblacio_2023": 667,
    "poblacio_2022": 683,
    "poblacio_2021": 707,
    "poblacio_2008": 598,
    "poblacio_1996": 183
  },
  {
    "code": "03063",
    "latitude": 38.839764093450200,
    "longitude": 0.105295316838838,
    "name": "Dénia",
    "comarca": 19,
    "gentilici": "denier, deniera",
    "poblacio_2025": 47261,
    "poblacio_2024": 46942,
    "poblacio_2023": 45622,
    "poblacio_2022": 43899,
    "poblacio_2021": 42953,
    "poblacio_2008": 44035,
    "poblacio_1996": 27469
  },
  {
    "code": "03064",
    "latitude": 38.138051725003300,
    "longitude": -0.770482333151643,
    "name": "Dolores",
    "comarca": 9,
    "gentilici": "dolorenc, dolorenca",
    "poblacio_2025": 8326,
    "poblacio_2024": 8102,
    "poblacio_2023": 7919,
    "poblacio_2022": 7799,
    "poblacio_2021": 7620,
    "poblacio_2008": 7313,
    "poblacio_1996": 6127
  },
  {
    "code": "46114",
    "latitude": 39.659589528843600,
    "longitude": -0.671209084753017,
    "name": "Domeño",
    "comarca": 29,
    "gentilici": "domenyer, domenyera",
    "poblacio_2025": 723,
    "poblacio_2024": 691,
    "poblacio_2023": 684,
    "poblacio_2022": 656,
    "poblacio_2021": 670,
    "poblacio_2008": 744,
    "poblacio_1996": 505
  },
  {
    "code": "46115",
    "latitude": 39.288645173148500,
    "longitude": -0.800116757273869,
    "name": "Dos Aguas",
    "comarca": 16,
    "gentilici": "dosaigüer, dosaigüera",
    "poblacio_2025": 340,
    "poblacio_2024": 338,
    "poblacio_2023": 340,
    "poblacio_2022": 325,
    "poblacio_2021": 312,
    "poblacio_2008": 496,
    "poblacio_1996": 367
  },
  {
    "code": "03065",
    "latitude": 38.263632878806600,
    "longitude": -0.695369919124728,
    "name": "Elx",
    "comarca": 10,
    "gentilici": "il·licità, il·licitana \/ elxà, elxana",
    "poblacio_2025": 245557,
    "poblacio_2024": 243128,
    "poblacio_2023": 238293,
    "poblacio_2022": 235580,
    "poblacio_2021": 234205,
    "poblacio_2008": 228348,
    "poblacio_1996": 191660
  },
  {
    "code": "03066",
    "latitude": 38.472932743584300,
    "longitude": -0.795127199082567,
    "name": "Elda",
    "comarca": 33,
    "gentilici": "elder, eldera \/ eldenc, eldenca",
    "poblacio_2025": 55222,
    "poblacio_2024": 53818,
    "poblacio_2023": 53034,
    "poblacio_2022": 52297,
    "poblacio_2021": 52551,
    "poblacio_2008": 55174,
    "poblacio_1996": 52751
  },
  {
    "code": "46116",
    "latitude": 39.559936764072500,
    "longitude": -0.518025050490472,
    "name": "l'Eliana",
    "comarca": 12,
    "gentilici": "elianer, elianera",
    "poblacio_2025": 19839,
    "poblacio_2024": 19597,
    "poblacio_2023": 19054,
    "poblacio_2022": 18544,
    "poblacio_2021": 18302,
    "poblacio_2008": 16549,
    "poblacio_1996": 11526
  },
  {
    "code": "46117",
    "latitude": 39.553791150501300,
    "longitude": -0.339169635403353,
    "name": "Emperador",
    "comarca": 17,
    "gentilici": "venter, ventera",
    "poblacio_2025": 700,
    "poblacio_2024": 693,
    "poblacio_2023": 717,
    "poblacio_2022": 705,
    "poblacio_2021": 698,
    "poblacio_2008": 559,
    "poblacio_1996": 188
  },
  {
    "code": "46118",
    "latitude": 38.979117647928600,
    "longitude": -0.688435241149344,
    "name": "Enguera",
    "comarca": 13,
    "gentilici": "enguerí, enguerina",
    "poblacio_2025": 4807,
    "poblacio_2024": 4769,
    "poblacio_2023": 4781,
    "poblacio_2022": 4770,
    "poblacio_2021": 4779,
    "poblacio_2008": 5895,
    "poblacio_1996": 4754
  },
  {
    "code": "46119",
    "latitude": 39.044141981663700,
    "longitude": -0.479867025049344,
    "name": "l'Énova",
    "comarca": 26,
    "gentilici": "enover, enovera",
    "poblacio_2025": 952,
    "poblacio_2024": 924,
    "poblacio_2023": 914,
    "poblacio_2022": 908,
    "poblacio_2021": 912,
    "poblacio_2008": 1018,
    "poblacio_1996": 1104
  },
  {
    "code": "12057",
    "latitude": 39.880636385567500,
    "longitude": -0.303460852046346,
    "name": "Eslida",
    "comarca": 22,
    "gentilici": "eslider, eslidera",
    "poblacio_2025": 815,
    "poblacio_2024": 785,
    "poblacio_2023": 758,
    "poblacio_2022": 742,
    "poblacio_2021": 749,
    "poblacio_2008": 908,
    "poblacio_1996": 775
  },
  {
    "code": "12058",
    "latitude": 40.026845326021000,
    "longitude": -0.356279076059502,
    "name": "Espadilla",
    "comarca": 5,
    "gentilici": "espadellà, espadellana",
    "poblacio_2025": 101,
    "poblacio_2024": 89,
    "poblacio_2023": 90,
    "poblacio_2022": 92,
    "poblacio_2021": 84,
    "poblacio_2008": 70,
    "poblacio_1996": 85
  },
  {
    "code": "46120",
    "latitude": 39.712831629091300,
    "longitude": -0.348127931111181,
    "name": "Estivella",
    "comarca": 11,
    "gentilici": "estivellenc, estivellenca",
    "poblacio_2025": 1710,
    "poblacio_2024": 1631,
    "poblacio_2023": 1598,
    "poblacio_2022": 1559,
    "poblacio_2021": 1491,
    "poblacio_2008": 1302,
    "poblacio_1996": 1097
  },
  {
    "code": "46121",
    "latitude": 39.017252052053900,
    "longitude": -0.623619561720026,
    "name": "Estubeny",
    "comarca": 15,
    "gentilici": "estubenyer, estubenyera",
    "poblacio_2025": 110,
    "poblacio_2024": 109,
    "poblacio_2023": 114,
    "poblacio_2022": 109,
    "poblacio_2021": 114,
    "poblacio_2008": 138,
    "poblacio_1996": 141
  },
  {
    "code": "03067",
    "latitude": 38.734981818788400,
    "longitude": -0.267879706756944,
    "name": "Fageca",
    "comarca": 14,
    "gentilici": "fagequí, fagequina",
    "poblacio_2025": 100,
    "poblacio_2024": 100,
    "poblacio_2023": 101,
    "poblacio_2022": 104,
    "poblacio_2021": 105,
    "poblacio_2008": 108,
    "poblacio_1996": 125
  },
  {
    "code": "03068",
    "latitude": 38.731542940977500,
    "longitude": -0.246339300260059,
    "name": "Famorca",
    "comarca": 14,
    "gentilici": "famorquí, famorquina",
    "poblacio_2025": 44,
    "poblacio_2024": 44,
    "poblacio_2023": 45,
    "poblacio_2022": 48,
    "poblacio_2021": 45,
    "poblacio_2008": 48,
    "poblacio_1996": 73
  },
  {
    "code": "12059",
    "latitude": 40.018917915674500,
    "longitude": -0.315982495162732,
    "name": "Fanzara",
    "comarca": 5,
    "gentilici": "fanzarí, fanzarina",
    "poblacio_2025": 295,
    "poblacio_2024": 297,
    "poblacio_2023": 294,
    "poblacio_2022": 283,
    "poblacio_2021": 273,
    "poblacio_2008": 447,
    "poblacio_1996": 282
  },
  {
    "code": "46122",
    "latitude": 39.725611786427000,
    "longitude": -0.264351329022071,
    "name": "Faura",
    "comarca": 11,
    "gentilici": "faurer, faurera",
    "poblacio_2025": 3753,
    "poblacio_2024": 3671,
    "poblacio_2023": 3619,
    "poblacio_2022": 3568,
    "poblacio_2021": 3563,
    "poblacio_2008": 3420,
    "poblacio_1996": 2809
  },
  {
    "code": "46123",
    "latitude": 39.127806563456700,
    "longitude": -0.291469861199672,
    "name": "Favara",
    "comarca": 27,
    "gentilici": "favarer, favarera",
    "poblacio_2025": 2776,
    "poblacio_2024": 2701,
    "poblacio_2023": 2664,
    "poblacio_2022": 2578,
    "poblacio_2021": 2563,
    "poblacio_2008": 2118,
    "poblacio_1996": 1726
  },
  {
    "code": "12060",
    "latitude": 40.117946545646800,
    "longitude": -0.237312473269401,
    "name": "Figueroles",
    "comarca": 2,
    "gentilici": "figueroler, figuerolera",
    "poblacio_2025": 525,
    "poblacio_2024": 518,
    "poblacio_2023": 518,
    "poblacio_2022": 518,
    "poblacio_2021": 531,
    "poblacio_2008": 582,
    "poblacio_1996": 556
  },
  {
    "code": "03069",
    "latitude": 38.547817776472000,
    "longitude": -0.172490183332011,
    "name": "Finestrat",
    "comarca": 20,
    "gentilici": "finestratí, finestratina",
    "poblacio_2025": 9919,
    "poblacio_2024": 9352,
    "poblacio_2023": 8836,
    "poblacio_2022": 7909,
    "poblacio_2021": 7402,
    "poblacio_2008": 5844,
    "poblacio_1996": 1504
  },
  {
    "code": "46126",
    "latitude": 39.537095673137500,
    "longitude": -0.357254330802997,
    "name": "Foios",
    "comarca": 17,
    "gentilici": "foier, foiera",
    "poblacio_2025": 7995,
    "poblacio_2024": 7761,
    "poblacio_2023": 7641,
    "poblacio_2022": 7496,
    "poblacio_2021": 7502,
    "poblacio_2008": 6477,
    "poblacio_1996": 5235
  },
  {
    "code": "03077",
    "latitude": 38.308692759354600,
    "longitude": -0.852657198621460,
    "name": "el Fondó de les Neus",
    "comarca": 33,
    "gentilici": "fondoner, fondonera",
    "poblacio_2025": 2738,
    "poblacio_2024": 2696,
    "poblacio_2023": 2698,
    "poblacio_2022": 2684,
    "poblacio_2021": 2634,
    "poblacio_2008": 2730,
    "poblacio_1996": 1587
  },
  {
    "code": "46127",
    "latitude": 38.916597377601300,
    "longitude": -0.170013135173200,
    "name": "la Font d'en Carròs",
    "comarca": 28,
    "gentilici": "fonter, fontera",
    "poblacio_2025": 4020,
    "poblacio_2024": 3938,
    "poblacio_2023": 3858,
    "poblacio_2022": 3857,
    "poblacio_2021": 3793,
    "poblacio_2008": 4127,
    "poblacio_1996": 3211
  },
  {
    "code": "46128",
    "latitude": 38.805736534502900,
    "longitude": -0.880237525609207,
    "name": "la Font de la Figuera",
    "comarca": 15,
    "gentilici": "fontí, fontina",
    "poblacio_2025": 2022,
    "poblacio_2024": 2043,
    "poblacio_2023": 2031,
    "poblacio_2022": 2024,
    "poblacio_2021": 2025,
    "poblacio_2008": 2240,
    "poblacio_1996": 2129
  },
  {
    "code": "46124",
    "latitude": 38.783004223180000,
    "longitude": -0.785366280806285,
    "name": "Fontanars dels Alforins",
    "comarca": 31,
    "gentilici": "alforiner, alforinera",
    "poblacio_2025": 936,
    "poblacio_2024": 947,
    "poblacio_2023": 951,
    "poblacio_2022": 953,
    "poblacio_2021": 959,
    "poblacio_2008": 1024,
    "poblacio_1996": 970
  },
  {
    "code": "12061",
    "latitude": 40.645423070419500,
    "longitude": -0.200661777772867,
    "name": "el Forcall",
    "comarca": 24,
    "gentilici": "forcallà, forcallana",
    "poblacio_2025": 475,
    "poblacio_2024": 477,
    "poblacio_2023": 473,
    "poblacio_2022": 465,
    "poblacio_2021": 454,
    "poblacio_2008": 540,
    "poblacio_1996": 554
  },
  {
    "code": "03070",
    "latitude": 38.085255723228000,
    "longitude": -0.745078391147559,
    "name": "Formentera del Segura",
    "comarca": 9,
    "gentilici": "formenterer, formenterera",
    "poblacio_2025": 4868,
    "poblacio_2024": 4749,
    "poblacio_2023": 4618,
    "poblacio_2022": 4446,
    "poblacio_2021": 4337,
    "poblacio_2008": 4118,
    "poblacio_1996": 2112
  },
  {
    "code": "46125",
    "latitude": 39.183351999201300,
    "longitude": -0.314929409036381,
    "name": "Fortaleny",
    "comarca": 27,
    "gentilici": "fortalenyer, fortalenyera",
    "poblacio_2025": 1024,
    "poblacio_2024": 1005,
    "poblacio_2023": 1004,
    "poblacio_2022": 1026,
    "poblacio_2021": 1011,
    "poblacio_2008": 1014,
    "poblacio_1996": 997
  },
  {
    "code": "12063",
    "latitude": 40.063140582317700,
    "longitude": -0.609276730857791,
    "name": "Fuente la Reina",
    "comarca": 5,
    "gentilici": "reiner, reinera",
    "poblacio_2025": 55,
    "poblacio_2024": 59,
    "poblacio_2023": 59,
    "poblacio_2022": 58,
    "poblacio_2021": 49,
    "poblacio_2008": 51,
    "poblacio_1996": 32
  },
  {
    "code": "46129",
    "latitude": 39.585672893776400,
    "longitude": -1.364313853410970,
    "name": "Fuenterrobles",
    "comarca": 23,
    "gentilici": "fuenterroblenc, fuenterroblenca",
    "poblacio_2025": 678,
    "poblacio_2024": 695,
    "poblacio_2023": 688,
    "poblacio_2022": 690,
    "poblacio_2021": 694,
    "poblacio_2008": 737,
    "poblacio_1996": 711
  },
  {
    "code": "12064",
    "latitude": 40.020814121547300,
    "longitude": -0.420185021062064,
    "name": "Fuentes de Ayódar",
    "comarca": 5,
    "gentilici": "fonter, fontera",
    "poblacio_2025": 98,
    "poblacio_2024": 95,
    "poblacio_2023": 98,
    "poblacio_2022": 95,
    "poblacio_2021": 93,
    "poblacio_2008": 112,
    "poblacio_1996": 98
  },
  {
    "code": "03072",
    "latitude": 38.812944009871800,
    "longitude": -0.409113066004071,
    "name": "Gaianes",
    "comarca": 14,
    "gentilici": "gaianer, gaianera",
    "poblacio_2025": 577,
    "poblacio_2024": 553,
    "poblacio_2023": 555,
    "poblacio_2022": 548,
    "poblacio_2021": 505,
    "poblacio_2008": 380,
    "poblacio_1996": 314
  },
  {
    "code": "12065",
    "latitude": 39.926522890376600,
    "longitude": -0.495822730042624,
    "name": "Gaibiel",
    "comarca": 6,
    "gentilici": "gaibielà, gaibielana",
    "poblacio_2025": 200,
    "poblacio_2024": 199,
    "poblacio_2023": 197,
    "poblacio_2022": 201,
    "poblacio_2021": 186,
    "poblacio_2008": 213,
    "poblacio_1996": 217
  },
  {
    "code": "46131",
    "latitude": 38.966116825261000,
    "longitude": -0.185187039488706,
    "name": "Gandia",
    "comarca": 28,
    "gentilici": "gandienc, gandienca \/ gandià, gandiana",
    "poblacio_2025": 83135,
    "poblacio_2024": 80095,
    "poblacio_2023": 78108,
    "poblacio_2022": 75911,
    "poblacio_2021": 75970,
    "poblacio_2008": 79958,
    "poblacio_1996": 56555
  },
  {
    "code": "03071",
    "latitude": 38.776077244519800,
    "longitude": 0.082602074832412,
    "name": "Gata de Gorgos",
    "comarca": 19,
    "gentilici": "gater, gatera",
    "poblacio_2025": 6773,
    "poblacio_2024": 6659,
    "poblacio_2023": 6515,
    "poblacio_2022": 6364,
    "poblacio_2021": 6223,
    "poblacio_2008": 6195,
    "poblacio_1996": 5070
  },
  {
    "code": "46902",
    "latitude": 39.772840011619300,
    "longitude": -0.522271942663852,
    "name": "Gátova",
    "comarca": 12,
    "gentilici": "gatovenc, gatovenca",
    "poblacio_2025": 452,
    "poblacio_2024": 429,
    "poblacio_2023": 410,
    "poblacio_2022": 412,
    "poblacio_2021": 419,
    "poblacio_2008": 478,
    "poblacio_1996": 512
  },
  {
    "code": "46130",
    "latitude": 39.090964303749400,
    "longitude": -0.544167851109425,
    "name": "Gavarda",
    "comarca": 26,
    "gentilici": "gavardí, gavardina",
    "poblacio_2025": 1023,
    "poblacio_2024": 1036,
    "poblacio_2023": 1058,
    "poblacio_2022": 1053,
    "poblacio_2021": 1035,
    "poblacio_2008": 1161,
    "poblacio_1996": 1268
  },
  {
    "code": "12067",
    "latitude": 39.836708037448400,
    "longitude": -0.467520169780466,
    "name": "Geldo",
    "comarca": 6,
    "gentilici": "geldí, geldina",
    "poblacio_2025": 665,
    "poblacio_2024": 651,
    "poblacio_2023": 650,
    "poblacio_2022": 643,
    "poblacio_2021": 628,
    "poblacio_2008": 702,
    "poblacio_1996": 700
  },
  {
    "code": "46132",
    "latitude": 38.987658644187600,
    "longitude": -0.468622394372954,
    "name": "el Genovés",
    "comarca": 15,
    "gentilici": "genovesí, genovesina",
    "poblacio_2025": 2822,
    "poblacio_2024": 2823,
    "poblacio_2023": 2778,
    "poblacio_2022": 2780,
    "poblacio_2021": 2785,
    "poblacio_2008": 2816,
    "poblacio_1996": 2314
  },
  {
    "code": "46133",
    "latitude": 39.604207231856500,
    "longitude": -0.835142466737874,
    "name": "Gestalgar",
    "comarca": 29,
    "gentilici": "xestalguí, xestalguina",
    "poblacio_2025": 587,
    "poblacio_2024": 560,
    "poblacio_2023": 569,
    "poblacio_2022": 547,
    "poblacio_2021": 541,
    "poblacio_2008": 763,
    "poblacio_1996": 661
  },
  {
    "code": "46134",
    "latitude": 39.678288463071400,
    "longitude": -0.325251364375448,
    "name": "Gilet",
    "comarca": 11,
    "gentilici": "giletà, giletana",
    "poblacio_2025": 4011,
    "poblacio_2024": 3887,
    "poblacio_2023": 3818,
    "poblacio_2022": 3601,
    "poblacio_2021": 3501,
    "poblacio_2008": 2725,
    "poblacio_1996": 1433
  },
  {
    "code": "46135",
    "latitude": 39.521686603958500,
    "longitude": -0.418028342554342,
    "name": "Godella",
    "comarca": 17,
    "gentilici": "godellenc, godellenca \/ godellà, godellana",
    "poblacio_2025": 13533,
    "poblacio_2024": 13437,
    "poblacio_2023": 13414,
    "poblacio_2022": 13050,
    "poblacio_2021": 13027,
    "poblacio_2008": 12835,
    "poblacio_1996": 10408
  },
  {
    "code": "46136",
    "latitude": 39.423689195674600,
    "longitude": -0.686005738064281,
    "name": "Godelleta",
    "comarca": 16,
    "gentilici": "godelletà, godelletana",
    "poblacio_2025": 4266,
    "poblacio_2024": 4182,
    "poblacio_2023": 4148,
    "poblacio_2022": 3942,
    "poblacio_2021": 3714,
    "poblacio_2008": 3248,
    "poblacio_1996": 2095
  },
  {
    "code": "03073",
    "latitude": 38.718565249249300,
    "longitude": -0.356752332172608,
    "name": "Gorga",
    "comarca": 14,
    "gentilici": "gorguer, gorguera",
    "poblacio_2025": 286,
    "poblacio_2024": 284,
    "poblacio_2023": 284,
    "poblacio_2022": 270,
    "poblacio_2021": 261,
    "poblacio_2008": 235,
    "poblacio_1996": 270
  },
  {
    "code": "46137",
    "latitude": 38.996248991545900,
    "longitude": -0.556413984133580,
    "name": "la Granja de la Costera",
    "comarca": 15,
    "gentilici": "granger, grangera",
    "poblacio_2025": 306,
    "poblacio_2024": 294,
    "poblacio_2023": 288,
    "poblacio_2022": 276,
    "poblacio_2021": 281,
    "poblacio_2008": 342,
    "poblacio_1996": 363
  },
  {
    "code": "03074",
    "latitude": 38.152884778540700,
    "longitude": -0.890347179235812,
    "name": "Granja de Rocamora",
    "comarca": 9,
    "gentilici": "granger, grangera",
    "poblacio_2025": 2728,
    "poblacio_2024": 2739,
    "poblacio_2023": 2686,
    "poblacio_2022": 2626,
    "poblacio_2021": 2609,
    "poblacio_2008": 2323,
    "poblacio_1996": 2076
  },
  {
    "code": "46138",
    "latitude": 38.923520207665700,
    "longitude": -0.489125843605993,
    "name": "Guadasséquies",
    "comarca": 31,
    "gentilici": "guadassequià, guadassequiana",
    "poblacio_2025": 478,
    "poblacio_2024": 468,
    "poblacio_2023": 480,
    "poblacio_2022": 475,
    "poblacio_2021": 459,
    "poblacio_2008": 439,
    "poblacio_1996": 390
  },
  {
    "code": "46139",
    "latitude": 39.186956270740700,
    "longitude": -0.478505839490038,
    "name": "Guadassuar",
    "comarca": 26,
    "gentilici": "guadassuarenc, guadassuarenca",
    "poblacio_2025": 6039,
    "poblacio_2024": 5992,
    "poblacio_2023": 5961,
    "poblacio_2022": 5910,
    "poblacio_2021": 5938,
    "poblacio_2008": 6160,
    "poblacio_1996": 5415
  },
  {
    "code": "46140",
    "latitude": 38.961385945535900,
    "longitude": -0.147661825357079,
    "name": "Guardamar de la Safor",
    "comarca": 28,
    "gentilici": "guardamarenc, guardamarenca",
    "poblacio_2025": 622,
    "poblacio_2024": 607,
    "poblacio_2023": 605,
    "poblacio_2022": 567,
    "poblacio_2021": 547,
    "poblacio_2008": 362,
    "poblacio_1996": 69
  },
  {
    "code": "03076",
    "latitude": 38.086031343120600,
    "longitude": -0.653867236054660,
    "name": "Guardamar del Segura",
    "comarca": 9,
    "gentilici": "guardamarenc, guardamarenca",
    "poblacio_2025": 18564,
    "poblacio_2024": 18111,
    "poblacio_2023": 17328,
    "poblacio_2022": 16138,
    "poblacio_2021": 15983,
    "poblacio_2008": 15951,
    "poblacio_1996": 8227
  },
  {
    "code": "12068",
    "latitude": 40.720378499959500,
    "longitude": -0.003916504685444,
    "name": "Herbers",
    "comarca": 24,
    "gentilici": "herbessenc, herbessenca",
    "poblacio_2025": 68,
    "poblacio_2024": 69,
    "poblacio_2023": 62,
    "poblacio_2022": 63,
    "poblacio_2021": 53,
    "poblacio_2008": 65,
    "poblacio_1996": 115
  },
  {
    "code": "12069",
    "latitude": 39.984083169435000,
    "longitude": -0.501659881491334,
    "name": "Higueras",
    "comarca": 6,
    "gentilici": "figuerenc, figuerenca",
    "poblacio_2025": 54,
    "poblacio_2024": 46,
    "poblacio_2023": 50,
    "poblacio_2022": 46,
    "poblacio_2021": 49,
    "poblacio_2008": 54,
    "poblacio_1996": 46
  },
  {
    "code": "46141",
    "latitude": 39.790167184328000,
    "longitude": -0.861235989531345,
    "name": "Higueruelas",
    "comarca": 29,
    "gentilici": "figuerolà, figuerolana",
    "poblacio_2025": 567,
    "poblacio_2024": 534,
    "poblacio_2023": 522,
    "poblacio_2022": 510,
    "poblacio_2021": 524,
    "poblacio_2008": 520,
    "poblacio_1996": 556
  },
  {
    "code": "03078",
    "latitude": 38.273159901212800,
    "longitude": -0.929483273652247,
    "name": "el Fondó dels Frares",
    "comarca": 33,
    "gentilici": "fondoner, fondonera",
    "poblacio_2025": 1334,
    "poblacio_2024": 1310,
    "poblacio_2023": 1311,
    "poblacio_2022": 1261,
    "poblacio_2021": 1299,
    "poblacio_2008": 1205,
    "poblacio_1996": 550
  },
  {
    "code": "03079",
    "latitude": 38.623880266014300,
    "longitude": -0.574523133443737,
    "name": "Ibi",
    "comarca": 3,
    "gentilici": "iberut, iberuda",
    "poblacio_2025": 24500,
    "poblacio_2024": 24210,
    "poblacio_2023": 23920,
    "poblacio_2022": 23677,
    "poblacio_2021": 23652,
    "poblacio_2008": 24093,
    "poblacio_1996": 21076
  },
  {
    "code": "03080",
    "latitude": 38.061315402121200,
    "longitude": -0.867591662976870,
    "name": "Jacarilla",
    "comarca": 9,
    "gentilici": "xacarellenc, xacarellenca",
    "poblacio_2025": 2176,
    "poblacio_2024": 2122,
    "poblacio_2023": 2108,
    "poblacio_2022": 2039,
    "poblacio_2021": 2030,
    "poblacio_2008": 2088,
    "poblacio_1996": 1504
  },
  {
    "code": "46142",
    "latitude": 39.191284829759100,
    "longitude": -1.077015527397890,
    "name": "Jalance",
    "comarca": 32,
    "gentilici": "xalansí, xalansina",
    "poblacio_2025": 808,
    "poblacio_2024": 803,
    "poblacio_2023": 810,
    "poblacio_2022": 788,
    "poblacio_2021": 795,
    "poblacio_2008": 1052,
    "poblacio_1996": 1117
  },
  {
    "code": "12070",
    "latitude": 40.511716085232400,
    "longitude": 0.251354817977001,
    "name": "la Jana",
    "comarca": 8,
    "gentilici": "janenc, janenca",
    "poblacio_2025": 679,
    "poblacio_2024": 688,
    "poblacio_2023": 678,
    "poblacio_2022": 669,
    "poblacio_2021": 664,
    "poblacio_2008": 830,
    "poblacio_1996": 848
  },
  {
    "code": "46144",
    "latitude": 39.142619059017200,
    "longitude": -1.074574118198700,
    "name": "Jarafuel",
    "comarca": 32,
    "gentilici": "xarafullà, xarafullana",
    "poblacio_2025": 788,
    "poblacio_2024": 757,
    "poblacio_2023": 765,
    "poblacio_2022": 777,
    "poblacio_2021": 772,
    "poblacio_2008": 822,
    "poblacio_1996": 1006
  },
  {
    "code": "03082",
    "latitude": 38.787668674928200,
    "longitude": 0.148669225538844,
    "name": "Xàbia",
    "comarca": 19,
    "gentilici": "xabienc, xabienca",
    "poblacio_2025": 30642,
    "poblacio_2024": 30131,
    "poblacio_2023": 29760,
    "poblacio_2022": 28731,
    "poblacio_2021": 27983,
    "poblacio_2008": 31140,
    "poblacio_1996": 21393
  },
  {
    "code": "12071",
    "latitude": 39.912665224804900,
    "longitude": -0.571693387403386,
    "name": "Jérica",
    "comarca": 6,
    "gentilici": "xericà, xericana",
    "poblacio_2025": 1764,
    "poblacio_2024": 1726,
    "poblacio_2023": 1794,
    "poblacio_2022": 1655,
    "poblacio_2021": 1650,
    "poblacio_2008": 1642,
    "poblacio_1996": 1591
  },
  {
    "code": "03083",
    "latitude": 38.541095160047200,
    "longitude": -0.506424856052956,
    "name": "Xixona",
    "comarca": 1,
    "gentilici": "xixonenc, xixonenca",
    "poblacio_2025": 7669,
    "poblacio_2024": 7307,
    "poblacio_2023": 7032,
    "poblacio_2022": 6860,
    "poblacio_2021": 6861,
    "poblacio_2008": 7575,
    "poblacio_1996": 7608
  },
  {
    "code": "46154",
    "latitude": 38.991990044441000,
    "longitude": -0.571864411285961,
    "name": "Llanera de Ranes",
    "comarca": 15,
    "gentilici": "llanerí, llanerina",
    "poblacio_2025": 1062,
    "poblacio_2024": 1057,
    "poblacio_2023": 1054,
    "poblacio_2022": 1066,
    "poblacio_2021": 1056,
    "poblacio_2008": 1098,
    "poblacio_1996": 1056
  },
  {
    "code": "46155",
    "latitude": 39.146121071902900,
    "longitude": -0.329035652113655,
    "name": "Llaurí",
    "comarca": 27,
    "gentilici": "llauriner, llaurinera",
    "poblacio_2025": 1226,
    "poblacio_2024": 1236,
    "poblacio_2023": 1208,
    "poblacio_2022": 1193,
    "poblacio_2021": 1169,
    "poblacio_2008": 1343,
    "poblacio_1996": 1336
  },
  {
    "code": "03085",
    "latitude": 38.742864177394300,
    "longitude": 0.005723922146143,
    "name": "Llíber",
    "comarca": 19,
    "gentilici": "lliberà, lliberana",
    "poblacio_2025": 882,
    "poblacio_2024": 905,
    "poblacio_2023": 946,
    "poblacio_2022": 967,
    "poblacio_2021": 883,
    "poblacio_2008": 1062,
    "poblacio_1996": 527
  },
  {
    "code": "46147",
    "latitude": 39.629819133195000,
    "longitude": -0.599798742127919,
    "name": "Llíria",
    "comarca": 12,
    "gentilici": "llirià, lliriana",
    "poblacio_2025": 25333,
    "poblacio_2024": 25077,
    "poblacio_2023": 24518,
    "poblacio_2022": 24036,
    "poblacio_2021": 23648,
    "poblacio_2008": 22441,
    "poblacio_1996": 15550
  },
  {
    "code": "46151",
    "latitude": 39.013216477555300,
    "longitude": -0.467248427375909,
    "name": "Llocnou d'en Fenollet",
    "comarca": 15,
    "gentilici": "llocnouí, llocnouina",
    "poblacio_2025": 944,
    "poblacio_2024": 924,
    "poblacio_2023": 908,
    "poblacio_2022": 924,
    "poblacio_2021": 912,
    "poblacio_2008": 869,
    "poblacio_1996": 731
  },
  {
    "code": "46152",
    "latitude": 39.420619418140700,
    "longitude": -0.382053648644048,
    "name": "Llocnou de la Corona",
    "comarca": 18,
    "gentilici": "llocnouí, llocnouina",
    "poblacio_2025": 132,
    "poblacio_2024": 121,
    "poblacio_2023": 124,
    "poblacio_2022": 109,
    "poblacio_2021": 124,
    "poblacio_2008": 105,
    "poblacio_1996": 123
  },
  {
    "code": "46153",
    "latitude": 38.913161468863600,
    "longitude": -0.283424113593340,
    "name": "Llocnou de Sant Jeroni",
    "comarca": 28,
    "gentilici": "llocnouí, llocnouina",
    "poblacio_2025": 594,
    "poblacio_2024": 586,
    "poblacio_2023": 567,
    "poblacio_2022": 577,
    "poblacio_2021": 557,
    "poblacio_2008": 577,
    "poblacio_1996": 555
  },
  {
    "code": "46156",
    "latitude": 39.283351890985700,
    "longitude": -0.572892750513212,
    "name": "Llombai",
    "comarca": 26,
    "gentilici": "llombaí, llombaïna",
    "poblacio_2025": 2791,
    "poblacio_2024": 2767,
    "poblacio_2023": 2687,
    "poblacio_2022": 2648,
    "poblacio_2021": 2651,
    "poblacio_2008": 2739,
    "poblacio_1996": 2220
  },
  {
    "code": "46157",
    "latitude": 39.018151191949300,
    "longitude": -0.533984171183583,
    "name": "la Llosa de Ranes",
    "comarca": 15,
    "gentilici": "lloser, llosera",
    "poblacio_2025": 3765,
    "poblacio_2024": 3736,
    "poblacio_2023": 3681,
    "poblacio_2022": 3652,
    "poblacio_2021": 3687,
    "poblacio_2008": 3928,
    "poblacio_1996": 3640
  },
  {
    "code": "12074",
    "latitude": 39.768453117252500,
    "longitude": -0.205952646014691,
    "name": "la Llosa",
    "comarca": 22,
    "gentilici": "lloser, llosera",
    "poblacio_2025": 1033,
    "poblacio_2024": 1042,
    "poblacio_2023": 1003,
    "poblacio_2022": 969,
    "poblacio_2021": 983,
    "poblacio_2008": 935,
    "poblacio_1996": 937
  },
  {
    "code": "12072",
    "latitude": 40.136919772900600,
    "longitude": -0.281098351652241,
    "name": "Llucena",
    "comarca": 2,
    "gentilici": "llucener, llucenera",
    "poblacio_2025": 1421,
    "poblacio_2024": 1420,
    "poblacio_2023": 1369,
    "poblacio_2022": 1325,
    "poblacio_2021": 1308,
    "poblacio_2008": 1587,
    "poblacio_1996": 1629
  },
  {
    "code": "46150",
    "latitude": 38.942612075395400,
    "longitude": -0.357446180432446,
    "name": "Llutxent",
    "comarca": 31,
    "gentilici": "llutxentí, llutxentina",
    "poblacio_2025": 2314,
    "poblacio_2024": 2335,
    "poblacio_2023": 2324,
    "poblacio_2022": 2318,
    "poblacio_2021": 2315,
    "poblacio_2008": 2588,
    "poblacio_1996": 2377
  },
  {
    "code": "03084",
    "latitude": 38.843680956690500,
    "longitude": -0.310855349618430,
    "name": "l'Orxa",
    "comarca": 14,
    "gentilici": "orxà, orxana",
    "poblacio_2025": 589,
    "poblacio_2024": 581,
    "poblacio_2023": 587,
    "poblacio_2022": 565,
    "poblacio_2021": 584,
    "poblacio_2008": 748,
    "poblacio_1996": 823
  },
  {
    "code": "46148",
    "latitude": 39.489925861120500,
    "longitude": -0.572122938810922,
    "name": "Loriguilla",
    "comarca": 12,
    "gentilici": "loriguillà, loriguillana",
    "poblacio_2025": 2188,
    "poblacio_2024": 2186,
    "poblacio_2023": 2171,
    "poblacio_2022": 2100,
    "poblacio_2021": 2027,
    "poblacio_2008": 1364,
    "poblacio_1996": 1004
  },
  {
    "code": "46149",
    "latitude": 39.695517161034600,
    "longitude": -0.871128822246726,
    "name": "Losa del Obispo",
    "comarca": 29,
    "gentilici": "lloser, llosera",
    "poblacio_2025": 531,
    "poblacio_2024": 523,
    "poblacio_2023": 520,
    "poblacio_2022": 527,
    "poblacio_2021": 531,
    "poblacio_2008": 580,
    "poblacio_1996": 469
  },
  {
    "code": "12073",
    "latitude": 40.087274804362800,
    "longitude": -0.371300860662539,
    "name": "Ludiente",
    "comarca": 5,
    "gentilici": "lludientí, lludientina",
    "poblacio_2025": 162,
    "poblacio_2024": 175,
    "poblacio_2023": 155,
    "poblacio_2022": 140,
    "poblacio_2021": 155,
    "poblacio_2008": 169,
    "poblacio_1996": 235
  },
  {
    "code": "46158",
    "latitude": 39.381709581535600,
    "longitude": -0.788083086144107,
    "name": "Macastre",
    "comarca": 16,
    "gentilici": "macastrer, macastrera",
    "poblacio_2025": 1461,
    "poblacio_2024": 1475,
    "poblacio_2023": 1437,
    "poblacio_2022": 1387,
    "poblacio_2021": 1338,
    "poblacio_2008": 1293,
    "poblacio_1996": 997
  },
  {
    "code": "46159",
    "latitude": 39.494236006106000,
    "longitude": -0.464721208804658,
    "name": "Manises",
    "comarca": 18,
    "gentilici": "maniser, manisera",
    "poblacio_2025": 32609,
    "poblacio_2024": 32273,
    "poblacio_2023": 31573,
    "poblacio_2022": 31170,
    "poblacio_2021": 31287,
    "poblacio_2008": 30478,
    "poblacio_1996": 25170
  },
  {
    "code": "46160",
    "latitude": 39.051096086692300,
    "longitude": -0.493625234686981,
    "name": "Manuel",
    "comarca": 26,
    "gentilici": "manuelí, manuelina",
    "poblacio_2025": 2560,
    "poblacio_2024": 2524,
    "poblacio_2023": 2500,
    "poblacio_2022": 2496,
    "poblacio_2021": 2452,
    "poblacio_2008": 2693,
    "poblacio_1996": 2411
  },
  {
    "code": "46161",
    "latitude": 39.674678990827200,
    "longitude": -0.562079869938624,
    "name": "Marines",
    "comarca": 12,
    "gentilici": "mariner, marinera",
    "poblacio_2025": 1967,
    "poblacio_2024": 1921,
    "poblacio_2023": 1955,
    "poblacio_2022": 1942,
    "poblacio_2021": 1894,
    "poblacio_2008": 1688,
    "poblacio_1996": 1305
  },
  {
    "code": "46162",
    "latitude": 39.141709660837400,
    "longitude": -0.522980982081717,
    "name": "Massalavés",
    "comarca": 26,
    "gentilici": "massalavesí, massalavesina",
    "poblacio_2025": 1905,
    "poblacio_2024": 1811,
    "poblacio_2023": 1739,
    "poblacio_2022": 1696,
    "poblacio_2021": 1632,
    "poblacio_2008": 1635,
    "poblacio_1996": 1480
  },
  {
    "code": "46163",
    "latitude": 39.557564899152900,
    "longitude": -0.325665100840841,
    "name": "Massalfassar",
    "comarca": 17,
    "gentilici": "massalfassí, massalfassina",
    "poblacio_2025": 2716,
    "poblacio_2024": 2653,
    "poblacio_2023": 2609,
    "poblacio_2022": 2587,
    "poblacio_2021": 2574,
    "poblacio_2008": 2026,
    "poblacio_1996": 1364
  },
  {
    "code": "46164",
    "latitude": 39.566911190896700,
    "longitude": -0.330807472552623,
    "name": "Massamagrell",
    "comarca": 17,
    "gentilici": "massamagrellenc, massamagrellenca",
    "poblacio_2025": 17566,
    "poblacio_2024": 17216,
    "poblacio_2023": 16766,
    "poblacio_2022": 16223,
    "poblacio_2021": 16132,
    "poblacio_2008": 14861,
    "poblacio_1996": 12283
  },
  {
    "code": "46165",
    "latitude": 39.411064312059100,
    "longitude": -0.399088959742588,
    "name": "Massanassa",
    "comarca": 18,
    "gentilici": "massanasser, massanassera",
    "poblacio_2025": 10607,
    "poblacio_2024": 10345,
    "poblacio_2023": 10146,
    "poblacio_2022": 9929,
    "poblacio_2021": 9845,
    "poblacio_2008": 8784,
    "poblacio_1996": 7645
  },
  {
    "code": "12075",
    "latitude": 40.616146283572200,
    "longitude": -0.279965199093091,
    "name": "la Mata de Morella",
    "comarca": 24,
    "gentilici": "mater, matera",
    "poblacio_2025": 196,
    "poblacio_2024": 184,
    "poblacio_2023": 179,
    "poblacio_2022": 179,
    "poblacio_2021": 169,
    "poblacio_2008": 195,
    "poblacio_1996": 208
  },
  {
    "code": "12076",
    "latitude": 39.938133221404700,
    "longitude": -0.468847240603937,
    "name": "Matet",
    "comarca": 6,
    "gentilici": "matetà, matetana",
    "poblacio_2025": 94,
    "poblacio_2024": 91,
    "poblacio_2023": 84,
    "poblacio_2022": 78,
    "poblacio_2021": 73,
    "poblacio_2008": 125,
    "poblacio_1996": 151
  },
  {
    "code": "46166",
    "latitude": 39.528893414197000,
    "longitude": -0.348603022595973,
    "name": "Meliana",
    "comarca": 17,
    "gentilici": "melianer, melianera",
    "poblacio_2025": 11055,
    "poblacio_2024": 10990,
    "poblacio_2023": 10918,
    "poblacio_2022": 10881,
    "poblacio_2021": 10926,
    "poblacio_2008": 10198,
    "poblacio_1996": 9120
  },
  {
    "code": "46167",
    "latitude": 39.237761912730100,
    "longitude": -0.773345667514265,
    "name": "Millares",
    "comarca": 13,
    "gentilici": "millarenc, millarenca",
    "poblacio_2025": 321,
    "poblacio_2024": 329,
    "poblacio_2023": 330,
    "poblacio_2022": 339,
    "poblacio_2021": 341,
    "poblacio_2008": 503,
    "poblacio_1996": 693
  },
  {
    "code": "03086",
    "latitude": 38.730951513138500,
    "longitude": -0.362409712844179,
    "name": "Millena",
    "comarca": 14,
    "gentilici": "millener, millenera",
    "poblacio_2025": 265,
    "poblacio_2024": 249,
    "poblacio_2023": 254,
    "poblacio_2022": 243,
    "poblacio_2021": 242,
    "poblacio_2008": 195,
    "poblacio_1996": 157
  },
  {
    "code": "46168",
    "latitude": 38.950949310570300,
    "longitude": -0.139761405227061,
    "name": "Miramar",
    "comarca": 28,
    "gentilici": "miramarí, miramarina",
    "poblacio_2025": 3143,
    "poblacio_2024": 3020,
    "poblacio_2023": 2978,
    "poblacio_2022": 2831,
    "poblacio_2021": 2740,
    "poblacio_2008": 2168,
    "poblacio_1996": 1064
  },
  {
    "code": "46169",
    "latitude": 39.476944796579300,
    "longitude": -0.417453473291656,
    "name": "Mislata",
    "comarca": 18,
    "gentilici": "mislater, mislatera",
    "poblacio_2025": 47079,
    "poblacio_2024": 46153,
    "poblacio_2023": 45644,
    "poblacio_2022": 44282,
    "poblacio_2021": 44320,
    "poblacio_2008": 43740,
    "poblacio_1996": 40302
  },
  {
    "code": "46170",
    "latitude": 38.874288500051300,
    "longitude": -0.751439611982474,
    "name": "Moixent",
    "comarca": 15,
    "gentilici": "moixentí, moixentina",
    "poblacio_2025": 4401,
    "poblacio_2024": 4373,
    "poblacio_2023": 4383,
    "poblacio_2022": 4365,
    "poblacio_2021": 4326,
    "poblacio_2008": 4724,
    "poblacio_1996": 4214
  },
  {
    "code": "46171",
    "latitude": 39.545314729215600,
    "longitude": -0.396041877836523,
    "name": "Montcada",
    "comarca": 17,
    "gentilici": "montcadí, montcadina",
    "poblacio_2025": 22213,
    "poblacio_2024": 21993,
    "poblacio_2023": 22067,
    "poblacio_2022": 21913,
    "poblacio_2021": 21875,
    "poblacio_2008": 21651,
    "poblacio_1996": 18420
  },
  {
    "code": "12077",
    "latitude": 39.808369607121100,
    "longitude": -0.147599648816885,
    "name": "Moncofa",
    "comarca": 22,
    "gentilici": "moncofí, moncofina",
    "poblacio_2025": 8339,
    "poblacio_2024": 8011,
    "poblacio_2023": 7747,
    "poblacio_2022": 7338,
    "poblacio_2021": 6958,
    "poblacio_2008": 5797,
    "poblacio_1996": 3610
  },
  {
    "code": "03088",
    "latitude": 38.380393059141000,
    "longitude": -0.730334640499767,
    "name": "Monforte del Cid",
    "comarca": 33,
    "gentilici": "montfortí, montfortina \/ montforter, montfortera",
    "poblacio_2025": 9283,
    "poblacio_2024": 8967,
    "poblacio_2023": 8777,
    "poblacio_2022": 8619,
    "poblacio_2021": 8500,
    "poblacio_2008": 7006,
    "poblacio_1996": 5082
  },
  {
    "code": "03089",
    "latitude": 38.437132114485400,
    "longitude": -0.838149917987772,
    "name": "Monòver",
    "comarca": 33,
    "gentilici": "monover, monovera",
    "poblacio_2025": 13116,
    "poblacio_2024": 12764,
    "poblacio_2023": 12542,
    "poblacio_2022": 12387,
    "poblacio_2021": 12188,
    "poblacio_2008": 13056,
    "poblacio_1996": 12085
  },
  {
    "code": "12078",
    "latitude": 40.035571520021900,
    "longitude": -0.554573642263696,
    "name": "Montán",
    "comarca": 5,
    "gentilici": "montanter, montantera",
    "poblacio_2025": 429,
    "poblacio_2024": 421,
    "poblacio_2023": 399,
    "poblacio_2022": 375,
    "poblacio_2021": 365,
    "poblacio_2008": 386,
    "poblacio_1996": 346
  },
  {
    "code": "12079",
    "latitude": 40.068335602771800,
    "longitude": -0.523502377595102,
    "name": "Montanejos",
    "comarca": 5,
    "gentilici": "montaneixí, montaneixina",
    "poblacio_2025": 649,
    "poblacio_2024": 643,
    "poblacio_2023": 603,
    "poblacio_2022": 553,
    "poblacio_2021": 544,
    "poblacio_2008": 618,
    "poblacio_1996": 404
  },
  {
    "code": "46173",
    "latitude": 38.887685388542600,
    "longitude": -0.494427997561059,
    "name": "Montaverner",
    "comarca": 31,
    "gentilici": "montaverní, montavernina",
    "poblacio_2025": 1624,
    "poblacio_2024": 1626,
    "poblacio_2023": 1617,
    "poblacio_2022": 1627,
    "poblacio_2021": 1630,
    "poblacio_2008": 1853,
    "poblacio_1996": 1711
  },
  {
    "code": "46174",
    "latitude": 38.947582346412600,
    "longitude": -0.648305502120646,
    "name": "Montesa",
    "comarca": 15,
    "gentilici": "montesí, montesina",
    "poblacio_2025": 1128,
    "poblacio_2024": 1134,
    "poblacio_2023": 1132,
    "poblacio_2022": 1152,
    "poblacio_2021": 1149,
    "poblacio_2008": 1424,
    "poblacio_1996": 1260
  },
  {
    "code": "03903",
    "latitude": 38.027100273001600,
    "longitude": -0.743897559066538,
    "name": "Los Montesinos",
    "comarca": 9,
    "gentilici": "montesiner, montesinera",
    "poblacio_2025": 5786,
    "poblacio_2024": 5682,
    "poblacio_2023": 5477,
    "poblacio_2022": 5217,
    "poblacio_2021": 5123,
    "poblacio_2008": 4736,
    "poblacio_1996": 2436
  },
  {
    "code": "46175",
    "latitude": 38.890714000194000,
    "longitude": -0.339759557705138,
    "name": "Montitxelvo",
    "comarca": 31,
    "gentilici": "montitxelví, montitxelvina",
    "poblacio_2025": 556,
    "poblacio_2024": 577,
    "poblacio_2023": 558,
    "poblacio_2022": 571,
    "poblacio_2021": 588,
    "poblacio_2008": 651,
    "poblacio_1996": 610
  },
  {
    "code": "46176",
    "latitude": 39.339902380870900,
    "longitude": -0.614341659186824,
    "name": "Montroi",
    "comarca": 26,
    "gentilici": "montroià, montroiana",
    "poblacio_2025": 3792,
    "poblacio_2024": 3477,
    "poblacio_2023": 3295,
    "poblacio_2022": 3185,
    "poblacio_2021": 3069,
    "poblacio_2008": 2720,
    "poblacio_1996": 1567
  },
  {
    "code": "46172",
    "latitude": 39.356841044315800,
    "longitude": -0.601880021568175,
    "name": "Montserrat",
    "comarca": 26,
    "gentilici": "montserrater, montserratera",
    "poblacio_2025": 10062,
    "poblacio_2024": 9656,
    "poblacio_2023": 9312,
    "poblacio_2022": 9017,
    "poblacio_2021": 8655,
    "poblacio_2008": 6089,
    "poblacio_1996": 2762
  },
  {
    "code": "12080",
    "latitude": 40.618844981101100,
    "longitude": -0.099135778430454,
    "name": "Morella",
    "comarca": 24,
    "gentilici": "morellà, morellana",
    "poblacio_2025": 2501,
    "poblacio_2024": 2494,
    "poblacio_2023": 2492,
    "poblacio_2022": 2475,
    "poblacio_2021": 2406,
    "poblacio_2008": 2854,
    "poblacio_1996": 2797
  },
  {
    "code": "03091",
    "latitude": 38.761289498035400,
    "longitude": -0.081382766045812,
    "name": "Murla",
    "comarca": 19,
    "gentilici": "murler, murlera",
    "poblacio_2025": 574,
    "poblacio_2024": 585,
    "poblacio_2023": 575,
    "poblacio_2022": 540,
    "poblacio_2021": 549,
    "poblacio_2008": 601,
    "poblacio_1996": 332
  },
  {
    "code": "03092",
    "latitude": 38.780579994919200,
    "longitude": -0.436853318329854,
    "name": "Muro d'Alcoi",
    "comarca": 14,
    "gentilici": "murer, murera",
    "poblacio_2025": 9372,
    "poblacio_2024": 9345,
    "poblacio_2023": 9253,
    "poblacio_2022": 9303,
    "poblacio_2021": 9326,
    "poblacio_2008": 8725,
    "poblacio_1996": 7104
  },
  {
    "code": "46177",
    "latitude": 39.564153386544000,
    "longitude": -0.341414759351914,
    "name": "Museros",
    "comarca": 17,
    "gentilici": "muserenc, muserenca",
    "poblacio_2025": 6871,
    "poblacio_2024": 6739,
    "poblacio_2023": 6741,
    "poblacio_2022": 6663,
    "poblacio_2021": 6618,
    "poblacio_2008": 5072,
    "poblacio_1996": 4083
  },
  {
    "code": "03090",
    "latitude": 38.419213819758600,
    "longitude": -0.446868864957839,
    "name": "Mutxamel",
    "comarca": 1,
    "gentilici": "mutxameler, mutxamelera",
    "poblacio_2025": 28621,
    "poblacio_2024": 27761,
    "poblacio_2023": 27078,
    "poblacio_2022": 26192,
    "poblacio_2021": 25679,
    "poblacio_2008": 21481,
    "poblacio_1996": 12779
  },
  {
    "code": "46178",
    "latitude": 39.654704371504000,
    "longitude": -0.426880351530804,
    "name": "Nàquera",
    "comarca": 12,
    "gentilici": "naquerà, naquerana",
    "poblacio_2025": 8556,
    "poblacio_2024": 8308,
    "poblacio_2023": 8102,
    "poblacio_2022": 7728,
    "poblacio_2021": 7301,
    "poblacio_2008": 5248,
    "poblacio_1996": 2075
  },
  {
    "code": "12081",
    "latitude": 39.876390855175800,
    "longitude": -0.506346482657692,
    "name": "Navajas",
    "comarca": 6,
    "gentilici": "navaixer, navaixera",
    "poblacio_2025": 906,
    "poblacio_2024": 846,
    "poblacio_2023": 840,
    "poblacio_2022": 781,
    "poblacio_2021": 750,
    "poblacio_2008": 733,
    "poblacio_1996": 484
  },
  {
    "code": "46179",
    "latitude": 39.100900921433100,
    "longitude": -0.694050466826484,
    "name": "Navarrés",
    "comarca": 13,
    "gentilici": "navarresí, navarresina",
    "poblacio_2025": 3027,
    "poblacio_2024": 3055,
    "poblacio_2023": 3061,
    "poblacio_2022": 2989,
    "poblacio_2021": 3004,
    "poblacio_2008": 3185,
    "poblacio_1996": 2772
  },
  {
    "code": "03093",
    "latitude": 38.384329035220400,
    "longitude": -0.764472857356109,
    "name": "Novelda",
    "comarca": 33,
    "gentilici": "novelder, noveldera",
    "poblacio_2025": 26606,
    "poblacio_2024": 26213,
    "poblacio_2023": 25771,
    "poblacio_2022": 25592,
    "poblacio_2021": 25611,
    "poblacio_2008": 27008,
    "poblacio_1996": 23188
  },
  {
    "code": "46180",
    "latitude": 38.980101221467100,
    "longitude": -0.547910598087801,
    "name": "Novetlè",
    "comarca": 15,
    "gentilici": "novetlerí, novetlerina",
    "poblacio_2025": 872,
    "poblacio_2024": 849,
    "poblacio_2023": 856,
    "poblacio_2022": 861,
    "poblacio_2021": 853,
    "poblacio_2008": 789,
    "poblacio_1996": 646
  },
  {
    "code": "03094",
    "latitude": 38.614669297916300,
    "longitude": -0.125163888683286,
    "name": "la Nucia",
    "comarca": 20,
    "gentilici": "nucier, nuciera",
    "poblacio_2025": 19121,
    "poblacio_2024": 18783,
    "poblacio_2023": 18970,
    "poblacio_2022": 18624,
    "poblacio_2021": 18108,
    "poblacio_2008": 16958,
    "poblacio_1996": 7010
  },
  {
    "code": "12082",
    "latitude": 39.852707885372300,
    "longitude": -0.157751018242172,
    "name": "Nules",
    "comarca": 22,
    "gentilici": "nuler, nulera",
    "poblacio_2025": 14315,
    "poblacio_2024": 14062,
    "poblacio_2023": 13827,
    "poblacio_2022": 13449,
    "poblacio_2021": 13256,
    "poblacio_2008": 13318,
    "poblacio_1996": 11493
  },
  {
    "code": "46181",
    "latitude": 38.917070742086700,
    "longitude": -0.114885664810309,
    "name": "Oliva",
    "comarca": 28,
    "gentilici": "oliver, olivera",
    "poblacio_2025": 26813,
    "poblacio_2024": 26122,
    "poblacio_2023": 25558,
    "poblacio_2022": 25179,
    "poblacio_2021": 25119,
    "poblacio_2008": 28279,
    "poblacio_1996": 20654
  },
  {
    "code": "46183",
    "latitude": 38.914659177237800,
    "longitude": -0.548840221925873,
    "name": "l'Olleria",
    "comarca": 31,
    "gentilici": "ollerià, olleriana",
    "poblacio_2025": 8818,
    "poblacio_2024": 8648,
    "poblacio_2023": 8421,
    "poblacio_2022": 8355,
    "poblacio_2021": 8404,
    "poblacio_2008": 8514,
    "poblacio_1996": 7010
  },
  {
    "code": "46182",
    "latitude": 39.700372303731400,
    "longitude": -0.530606109499654,
    "name": "Olocau",
    "comarca": 12,
    "gentilici": "olocauí, olocauina",
    "poblacio_2025": 2534,
    "poblacio_2024": 2425,
    "poblacio_2023": 2303,
    "poblacio_2022": 2148,
    "poblacio_2021": 2028,
    "poblacio_2008": 1415,
    "poblacio_1996": 768
  },
  {
    "code": "12083",
    "latitude": 40.637480434943100,
    "longitude": -0.339781737458975,
    "name": "Olocau del Rey",
    "comarca": 24,
    "gentilici": "olocauí, olocauina",
    "poblacio_2025": 135,
    "poblacio_2024": 135,
    "poblacio_2023": 126,
    "poblacio_2022": 119,
    "poblacio_2021": 117,
    "poblacio_2008": 135,
    "poblacio_1996": 158
  },
  {
    "code": "12084",
    "latitude": 39.965326220744700,
    "longitude": -0.262283721511942,
    "name": "Onda",
    "comarca": 22,
    "gentilici": "onder, ondera",
    "poblacio_2025": 26190,
    "poblacio_2024": 25817,
    "poblacio_2023": 25547,
    "poblacio_2022": 25099,
    "poblacio_2021": 24939,
    "poblacio_2008": 25362,
    "poblacio_1996": 18680
  },
  {
    "code": "03095",
    "latitude": 38.825971699930900,
    "longitude": 0.018789643267340,
    "name": "Ondara",
    "comarca": 19,
    "gentilici": "ondarenc, ondarenca",
    "poblacio_2025": 7717,
    "poblacio_2024": 7522,
    "poblacio_2023": 7308,
    "poblacio_2022": 7085,
    "poblacio_2021": 7080,
    "poblacio_2008": 6457,
    "poblacio_1996": 5149
  },
  {
    "code": "03096",
    "latitude": 38.629048152184300,
    "longitude": -0.671751134592346,
    "name": "Onil",
    "comarca": 3,
    "gentilici": "onilenc, onilenca",
    "poblacio_2025": 8114,
    "poblacio_2024": 7959,
    "poblacio_2023": 7763,
    "poblacio_2022": 7580,
    "poblacio_2021": 7569,
    "poblacio_2008": 7709,
    "poblacio_1996": 6786
  },
  {
    "code": "46184",
    "latitude": 38.821326569657100,
    "longitude": -0.604597075946409,
    "name": "Ontinyent",
    "comarca": 31,
    "gentilici": "ontinyentí, ontinyentina",
    "poblacio_2025": 37012,
    "poblacio_2024": 36430,
    "poblacio_2023": 36194,
    "poblacio_2022": 35946,
    "poblacio_2021": 35946,
    "poblacio_2008": 37518,
    "poblacio_1996": 31024
  },
  {
    "code": "03097",
    "latitude": 38.779887506115500,
    "longitude": -0.062992596035341,
    "name": "Orba",
    "comarca": 19,
    "gentilici": "orber, orbera",
    "poblacio_2025": 2399,
    "poblacio_2024": 2387,
    "poblacio_2023": 2379,
    "poblacio_2022": 2348,
    "poblacio_2021": 2233,
    "poblacio_2008": 2566,
    "poblacio_1996": 1576
  },
  {
    "code": "03099",
    "latitude": 38.090545210924400,
    "longitude": -0.939672724371081,
    "name": "Orihuela",
    "comarca": 9,
    "gentilici": "oriolà, oriolana",
    "poblacio_2025": 84560,
    "poblacio_2024": 83720,
    "poblacio_2023": 82449,
    "poblacio_2022": 80784,
    "poblacio_2021": 78940,
    "poblacio_2008": 84626,
    "poblacio_1996": 50724
  },
  {
    "code": "12085",
    "latitude": 40.093141257276200,
    "longitude": 0.136854269688096,
    "name": "Orpesa",
    "comarca": 21,
    "gentilici": "orpesí, orpesina",
    "poblacio_2025": 12640,
    "poblacio_2024": 11785,
    "poblacio_2023": 10958,
    "poblacio_2022": 10184,
    "poblacio_2021": 9755,
    "poblacio_2008": 11245,
    "poblacio_1996": 2578
  },
  {
    "code": "03098",
    "latitude": 38.563204166682800,
    "longitude": -0.263274483000349,
    "name": "Orxeta",
    "comarca": 20,
    "gentilici": "orxetà, orxetana",
    "poblacio_2025": 906,
    "poblacio_2024": 879,
    "poblacio_2023": 840,
    "poblacio_2022": 812,
    "poblacio_2021": 787,
    "poblacio_2008": 830,
    "poblacio_1996": 470
  },
  {
    "code": "46185",
    "latitude": 38.853389636753500,
    "longitude": -0.443136284355939,
    "name": "Otos",
    "comarca": 31,
    "gentilici": "otosí, otosina",
    "poblacio_2025": 442,
    "poblacio_2024": 440,
    "poblacio_2023": 436,
    "poblacio_2022": 428,
    "poblacio_2021": 428,
    "poblacio_2008": 503,
    "poblacio_1996": 534
  },
  {
    "code": "46186",
    "latitude": 39.426416388264900,
    "longitude": -0.419821336356556,
    "name": "Paiporta",
    "comarca": 18,
    "gentilici": "paiportí, paiportina",
    "poblacio_2025": 28136,
    "poblacio_2024": 27748,
    "poblacio_2023": 27184,
    "poblacio_2022": 26567,
    "poblacio_2021": 26401,
    "poblacio_2008": 23245,
    "poblacio_1996": 17259
  },
  {
    "code": "12087",
    "latitude": 40.717689560757000,
    "longitude": -0.179231733672773,
    "name": "Palanques",
    "comarca": 24,
    "gentilici": "palanquí, palanquina",
    "poblacio_2025": 34,
    "poblacio_2024": 34,
    "poblacio_2023": 36,
    "poblacio_2022": 38,
    "poblacio_2021": 36,
    "poblacio_2008": 34,
    "poblacio_1996": 23
  },
  {
    "code": "46187",
    "latitude": 38.924785283331700,
    "longitude": -0.221787917444857,
    "name": "Palma de Gandia",
    "comarca": 28,
    "gentilici": "palmer, palmera",
    "poblacio_2025": 1897,
    "poblacio_2024": 1816,
    "poblacio_2023": 1735,
    "poblacio_2022": 1686,
    "poblacio_2021": 1660,
    "poblacio_2008": 1845,
    "poblacio_1996": 1534
  },
  {
    "code": "46188",
    "latitude": 38.941198356511300,
    "longitude": -0.153842484837868,
    "name": "Palmera",
    "comarca": 28,
    "gentilici": "palmerí, palmerina",
    "poblacio_2025": 1038,
    "poblacio_2024": 1028,
    "poblacio_2023": 1043,
    "poblacio_2022": 1040,
    "poblacio_2021": 1024,
    "poblacio_2008": 926,
    "poblacio_1996": 497
  },
  {
    "code": "46189",
    "latitude": 38.854045581993100,
    "longitude": -0.502558606948238,
    "name": "el Palomar",
    "comarca": 31,
    "gentilici": "palomarenc, palomarenca",
    "poblacio_2025": 593,
    "poblacio_2024": 598,
    "poblacio_2023": 574,
    "poblacio_2022": 566,
    "poblacio_2021": 562,
    "poblacio_2008": 568,
    "poblacio_1996": 496
  },
  {
    "code": "03100",
    "latitude": 38.744618460263900,
    "longitude": -0.064999434761016,
    "name": "Parcent",
    "comarca": 19,
    "gentilici": "parcentí, parcentina",
    "poblacio_2025": 1037,
    "poblacio_2024": 1021,
    "poblacio_2023": 1003,
    "poblacio_2022": 997,
    "poblacio_2021": 983,
    "poblacio_2008": 1066,
    "poblacio_1996": 767
  },
  {
    "code": "46190",
    "latitude": 39.503277327296000,
    "longitude": -0.442152999730647,
    "name": "Paterna",
    "comarca": 17,
    "gentilici": "paterner, paternera",
    "poblacio_2025": 76019,
    "poblacio_2024": 74822,
    "poblacio_2023": 73488,
    "poblacio_2022": 71880,
    "poblacio_2021": 71361,
    "poblacio_2008": 61941,
    "poblacio_1996": 47414
  },
  {
    "code": "12088",
    "latitude": 39.973647538657000,
    "longitude": -0.482104832925239,
    "name": "Pavías",
    "comarca": 6,
    "gentilici": "pavieser, paviesera",
    "poblacio_2025": 72,
    "poblacio_2024": 73,
    "poblacio_2023": 74,
    "poblacio_2022": 74,
    "poblacio_2021": 72,
    "poblacio_2008": 57,
    "poblacio_1996": 62
  },
  {
    "code": "46191",
    "latitude": 39.604888467699500,
    "longitude": -0.726349710285567,
    "name": "Pedralba",
    "comarca": 29,
    "gentilici": "pedralbí, pedralbina",
    "poblacio_2025": 3225,
    "poblacio_2024": 3124,
    "poblacio_2023": 3048,
    "poblacio_2022": 2966,
    "poblacio_2021": 2852,
    "poblacio_2008": 2793,
    "poblacio_1996": 2099
  },
  {
    "code": "03101",
    "latitude": 38.795019860332300,
    "longitude": 0.033056810430810,
    "name": "Pedreguer",
    "comarca": 19,
    "gentilici": "pedreguerí, pedreguerina",
    "poblacio_2025": 8849,
    "poblacio_2024": 8687,
    "poblacio_2023": 8558,
    "poblacio_2022": 8280,
    "poblacio_2021": 8006,
    "poblacio_2008": 7480,
    "poblacio_1996": 5853
  },
  {
    "code": "03102",
    "latitude": 38.841403175541400,
    "longitude": -0.117172110159621,
    "name": "Pego",
    "comarca": 19,
    "gentilici": "pegolí, pegolina",
    "poblacio_2025": 10791,
    "poblacio_2024": 10632,
    "poblacio_2023": 10485,
    "poblacio_2022": 10295,
    "poblacio_2021": 10240,
    "poblacio_2008": 11043,
    "poblacio_1996": 10369
  },
  {
    "code": "03103",
    "latitude": 38.679921053768000,
    "longitude": -0.359875537272600,
    "name": "Penàguila",
    "comarca": 3,
    "gentilici": "penaguilenc, penaguilenca",
    "poblacio_2025": 305,
    "poblacio_2024": 293,
    "poblacio_2023": 313,
    "poblacio_2022": 287,
    "poblacio_2021": 275,
    "poblacio_2008": 323,
    "poblacio_1996": 346
  },
  {
    "code": "12089",
    "latitude": 40.381398392775700,
    "longitude": 0.407182012863610,
    "name": "Peníscola",
    "comarca": 8,
    "gentilici": "peniscolà, peniscolana",
    "poblacio_2025": 8774,
    "poblacio_2024": 8496,
    "poblacio_2023": 8449,
    "poblacio_2022": 8210,
    "poblacio_2021": 7882,
    "poblacio_2008": 7560,
    "poblacio_1996": 3821
  },
  {
    "code": "03104",
    "latitude": 38.481190630225800,
    "longitude": -0.776966476642590,
    "name": "Petrer",
    "comarca": 33,
    "gentilici": "petrerí, petrerina",
    "poblacio_2025": 34022,
    "poblacio_2024": 34076,
    "poblacio_2023": 33914,
    "poblacio_2022": 33978,
    "poblacio_2021": 34009,
    "poblacio_2008": 34109,
    "poblacio_1996": 26505
  },
  {
    "code": "46192",
    "latitude": 39.684752493744300,
    "longitude": -0.311583166102028,
    "name": "Petrés",
    "comarca": 11,
    "gentilici": "petresà, petresana",
    "poblacio_2025": 1124,
    "poblacio_2024": 1142,
    "poblacio_2023": 1096,
    "poblacio_2022": 1057,
    "poblacio_2021": 1012,
    "poblacio_2008": 971,
    "poblacio_1996": 757
  },
  {
    "code": "46193",
    "latitude": 39.434912912240900,
    "longitude": -0.436655467825672,
    "name": "Picanya",
    "comarca": 18,
    "gentilici": "picanyer, picanyera",
    "poblacio_2025": 11901,
    "poblacio_2024": 11876,
    "poblacio_2023": 11760,
    "poblacio_2022": 11665,
    "poblacio_2021": 11692,
    "poblacio_2008": 10861,
    "poblacio_1996": 8582
  },
  {
    "code": "46194",
    "latitude": 39.362203751151800,
    "longitude": -0.459874732915708,
    "name": "Picassent",
    "comarca": 18,
    "gentilici": "picassentí, picassentina",
    "poblacio_2025": 23202,
    "poblacio_2024": 22695,
    "poblacio_2023": 22236,
    "poblacio_2022": 21761,
    "poblacio_2021": 21487,
    "poblacio_2008": 19385,
    "poblacio_1996": 15438
  },
  {
    "code": "03902",
    "latitude": 37.861689720341600,
    "longitude": -0.791195087774737,
    "name": "Pilar de la Horadada",
    "comarca": 9,
    "gentilici": "pilarenc, pilarenca",
    "poblacio_2025": 24316,
    "poblacio_2024": 23844,
    "poblacio_2023": 23428,
    "poblacio_2022": 22949,
    "poblacio_2021": 22597,
    "poblacio_2008": 21424,
    "poblacio_1996": 9528
  },
  {
    "code": "46195",
    "latitude": 38.940590126865000,
    "longitude": -0.132793788943511,
    "name": "Piles",
    "comarca": 28,
    "gentilici": "piler, pilera",
    "poblacio_2025": 3151,
    "poblacio_2024": 3195,
    "poblacio_2023": 3031,
    "poblacio_2022": 2882,
    "poblacio_2021": 2742,
    "poblacio_2008": 2773,
    "poblacio_1996": 1956
  },
  {
    "code": "12090",
    "latitude": 40.021070377622900,
    "longitude": -0.655076978288398,
    "name": "Pina de Montalgrao",
    "comarca": 6,
    "gentilici": "pinenc, pinenca \/ pinetà, pinetana",
    "poblacio_2025": 121,
    "poblacio_2024": 118,
    "poblacio_2023": 119,
    "poblacio_2022": 113,
    "poblacio_2021": 114,
    "poblacio_2008": 151,
    "poblacio_1996": 175
  },
  {
    "code": "46196",
    "latitude": 38.983089872965600,
    "longitude": -0.338453472829071,
    "name": "Pinet",
    "comarca": 31,
    "gentilici": "pinetell, pinetella",
    "poblacio_2025": 156,
    "poblacio_2024": 148,
    "poblacio_2023": 155,
    "poblacio_2022": 155,
    "poblacio_2021": 161,
    "poblacio_2008": 193,
    "poblacio_1996": 235
  },
  {
    "code": "03105",
    "latitude": 38.403580928525400,
    "longitude": -1.041806517236750,
    "name": "el Pinós",
    "comarca": 33,
    "gentilici": "pinoser, pinosera",
    "poblacio_2025": 8523,
    "poblacio_2024": 8407,
    "poblacio_2023": 8281,
    "poblacio_2022": 8084,
    "poblacio_2021": 8142,
    "poblacio_2008": 7623,
    "poblacio_1996": 5970
  },
  {
    "code": "03106",
    "latitude": 38.785083978313200,
    "longitude": -0.343575037456507,
    "name": "Planes",
    "comarca": 14,
    "gentilici": "planer, planera",
    "poblacio_2025": 697,
    "poblacio_2024": 696,
    "poblacio_2023": 699,
    "poblacio_2022": 695,
    "poblacio_2021": 693,
    "poblacio_2008": 839,
    "poblacio_1996": 822
  },
  {
    "code": "12093",
    "latitude": 40.656467619919600,
    "longitude": 0.156718413647451,
    "name": "la Pobla de Benifassà",
    "comarca": 8,
    "gentilici": "poblatà, poblatana",
    "poblacio_2025": 229,
    "poblacio_2024": 240,
    "poblacio_2023": 235,
    "poblacio_2022": 225,
    "poblacio_2021": 213,
    "poblacio_2008": 299,
    "poblacio_1996": 202
  },
  {
    "code": "46199",
    "latitude": 39.578064370299500,
    "longitude": -0.326467829676142,
    "name": "la Pobla de Farnals",
    "comarca": 17,
    "gentilici": "poblà, poblana \/ creuetí, creuetina",
    "poblacio_2025": 9255,
    "poblacio_2024": 9076,
    "poblacio_2023": 8699,
    "poblacio_2022": 8368,
    "poblacio_2021": 8205,
    "poblacio_2008": 7080,
    "poblacio_1996": 4960
  },
  {
    "code": "46202",
    "latitude": 39.592238037167500,
    "longitude": -0.549906762711131,
    "name": "la Pobla de Vallbona",
    "comarca": 12,
    "gentilici": "poblà, poblana",
    "poblacio_2025": 27471,
    "poblacio_2024": 27056,
    "poblacio_2023": 26435,
    "poblacio_2022": 25625,
    "poblacio_2021": 25275,
    "poblacio_2008": 19540,
    "poblacio_1996": 9871
  },
  {
    "code": "46200",
    "latitude": 38.903529772396300,
    "longitude": -0.416909624372219,
    "name": "la Pobla del Duc",
    "comarca": 31,
    "gentilici": "poblà, poblana",
    "poblacio_2025": 2451,
    "poblacio_2024": 2449,
    "poblacio_2023": 2438,
    "poblacio_2022": 2447,
    "poblacio_2021": 2483,
    "poblacio_2008": 2599,
    "poblacio_1996": 2490
  },
  {
    "code": "46203",
    "latitude": 39.086023017573700,
    "longitude": -0.476131545199133,
    "name": "la Pobla Llarga",
    "comarca": 26,
    "gentilici": "poblatà, poblatana",
    "poblacio_2025": 4665,
    "poblacio_2024": 4569,
    "poblacio_2023": 4529,
    "poblacio_2022": 4443,
    "poblacio_2021": 4440,
    "poblacio_2008": 4510,
    "poblacio_1996": 4390
  },
  {
    "code": "12094",
    "latitude": 40.100898110008500,
    "longitude": -0.001111626303171,
    "name": "la Pobla Tornesa",
    "comarca": 21,
    "gentilici": "poblatí, poblatina",
    "poblacio_2025": 1322,
    "poblacio_2024": 1325,
    "poblacio_2023": 1309,
    "poblacio_2022": 1304,
    "poblacio_2021": 1239,
    "poblacio_2008": 980,
    "poblacio_1996": 529
  },
  {
    "code": "03901",
    "latitude": 38.852714785484300,
    "longitude": 0.016410124145599,
    "name": "els Poblets",
    "comarca": 19,
    "gentilici": "pobleter, pobletera",
    "poblacio_2025": 2757,
    "poblacio_2024": 2684,
    "poblacio_2023": 2763,
    "poblacio_2022": 2735,
    "poblacio_2021": 2721,
    "poblacio_2008": 3267,
    "poblacio_1996": 1191
  },
  {
    "code": "46197",
    "latitude": 39.196863273606400,
    "longitude": -0.369980628423050,
    "name": "Polinyà de Xúquer",
    "comarca": 27,
    "gentilici": "polinyaner, polinyanera",
    "poblacio_2025": 2577,
    "poblacio_2024": 2551,
    "poblacio_2023": 2550,
    "poblacio_2022": 2493,
    "poblacio_2021": 2495,
    "poblacio_2008": 2479,
    "poblacio_1996": 3048
  },
  {
    "code": "03107",
    "latitude": 38.615406436688200,
    "longitude": -0.143689843629184,
    "name": "Polop",
    "comarca": 20,
    "gentilici": "polopí, polopina",
    "poblacio_2025": 5828,
    "poblacio_2024": 5650,
    "poblacio_2023": 5339,
    "poblacio_2022": 5186,
    "poblacio_2021": 5069,
    "poblacio_2008": 4112,
    "poblacio_1996": 1995
  },
  {
    "code": "12091",
    "latitude": 40.532052871930000,
    "longitude": -0.262466154161531,
    "name": "Portell de Morella",
    "comarca": 24,
    "gentilici": "portellà, portellana",
    "poblacio_2025": 155,
    "poblacio_2024": 155,
    "poblacio_2023": 166,
    "poblacio_2022": 178,
    "poblacio_2021": 181,
    "poblacio_2008": 258,
    "poblacio_1996": 277
  },
  {
    "code": "46198",
    "latitude": 38.915357594689700,
    "longitude": -0.194064551634914,
    "name": "Potries",
    "comarca": 28,
    "gentilici": "potrier, potriera",
    "poblacio_2025": 1135,
    "poblacio_2024": 1104,
    "poblacio_2023": 1080,
    "poblacio_2022": 1075,
    "poblacio_2021": 1065,
    "poblacio_2008": 953,
    "poblacio_1996": 965
  },
  {
    "code": "46205",
    "latitude": 39.618433356942700,
    "longitude": -0.308931060106307,
    "name": "Puçol",
    "comarca": 17,
    "gentilici": "puçolenc, puçolenca",
    "poblacio_2025": 21659,
    "poblacio_2024": 21298,
    "poblacio_2023": 20731,
    "poblacio_2022": 20191,
    "poblacio_2021": 19975,
    "poblacio_2008": 18482,
    "poblacio_1996": 13662
  },
  {
    "code": "12092",
    "latitude": 40.103949041388200,
    "longitude": -0.592053667120697,
    "name": "Puebla de Arenoso",
    "comarca": 5,
    "gentilici": "poblà, poblana",
    "poblacio_2025": 169,
    "poblacio_2024": 174,
    "poblacio_2023": 169,
    "poblacio_2022": 162,
    "poblacio_2021": 158,
    "poblacio_2008": 211,
    "poblacio_1996": 178
  },
  {
    "code": "46201",
    "latitude": 40.045043837462800,
    "longitude": -1.144906757809100,
    "name": "Puebla de San Miguel",
    "comarca": 25,
    "gentilici": "poblà, poblana",
    "poblacio_2025": 53,
    "poblacio_2024": 51,
    "poblacio_2023": 53,
    "poblacio_2022": 59,
    "poblacio_2021": 60,
    "poblacio_2008": 66,
    "poblacio_1996": 77
  },
  {
    "code": "46204",
    "latitude": 39.590407533415900,
    "longitude": -0.300187537337466,
    "name": "el Puig de Santa Maria",
    "comarca": 17,
    "gentilici": "pugenc, pugenca",
    "poblacio_2025": 9490,
    "poblacio_2024": 9367,
    "poblacio_2023": 8992,
    "poblacio_2022": 8792,
    "poblacio_2021": 8737,
    "poblacio_2008": 8499,
    "poblacio_1996": 6868
  },
  {
    "code": "46101",
    "latitude": 39.740440483762800,
    "longitude": -0.273376267874836,
    "name": "Quart de les Valls",
    "comarca": 11,
    "gentilici": "quarter, quartera",
    "poblacio_2025": 1029,
    "poblacio_2024": 1040,
    "poblacio_2023": 1050,
    "poblacio_2022": 1049,
    "poblacio_2021": 1050,
    "poblacio_2008": 1086,
    "poblacio_1996": 1093
  },
  {
    "code": "46102",
    "latitude": 39.481942903046500,
    "longitude": -0.439053489432208,
    "name": "Quart de Poblet",
    "comarca": 18,
    "gentilici": "quartà, quartana",
    "poblacio_2025": 26967,
    "poblacio_2024": 26304,
    "poblacio_2023": 25590,
    "poblacio_2022": 25167,
    "poblacio_2021": 25035,
    "poblacio_2008": 25441,
    "poblacio_1996": 27112
  },
  {
    "code": "46103",
    "latitude": 39.737497045109300,
    "longitude": -0.263734302456886,
    "name": "Quartell",
    "comarca": 11,
    "gentilici": "quarteller, quartellera",
    "poblacio_2025": 1810,
    "poblacio_2024": 1657,
    "poblacio_2023": 1672,
    "poblacio_2022": 1683,
    "poblacio_2021": 1640,
    "poblacio_2008": 1443,
    "poblacio_1996": 1374
  },
  {
    "code": "46104",
    "latitude": 38.946204206589900,
    "longitude": -0.402197221352249,
    "name": "Quatretonda",
    "comarca": 31,
    "gentilici": "quatretondí, quatretondina",
    "poblacio_2025": 2174,
    "poblacio_2024": 2206,
    "poblacio_2023": 2190,
    "poblacio_2022": 2143,
    "poblacio_2021": 2146,
    "poblacio_2008": 2534,
    "poblacio_1996": 2570
  },
  {
    "code": "03060",
    "latitude": 38.723833501952800,
    "longitude": -0.315978254938786,
    "name": "Quatretondeta",
    "comarca": 14,
    "gentilici": "quatretondetí, quatretondetina",
    "poblacio_2025": 130,
    "poblacio_2024": 134,
    "poblacio_2023": 136,
    "poblacio_2022": 133,
    "poblacio_2021": 117,
    "poblacio_2008": 137,
    "poblacio_1996": 189
  },
  {
    "code": "46206",
    "latitude": 39.118075074932900,
    "longitude": -0.739514548175123,
    "name": "Quesa",
    "comarca": 13,
    "gentilici": "quesí, quesina",
    "poblacio_2025": 691,
    "poblacio_2024": 675,
    "poblacio_2023": 661,
    "poblacio_2022": 647,
    "poblacio_2021": 669,
    "poblacio_2008": 722,
    "poblacio_1996": 780
  },
  {
    "code": "03109",
    "latitude": 38.104313329486000,
    "longitude": -0.849646492323230,
    "name": "Rafal",
    "comarca": 9,
    "gentilici": "rafalenc, rafalenca",
    "poblacio_2025": 4849,
    "poblacio_2024": 4900,
    "poblacio_2023": 4800,
    "poblacio_2022": 4634,
    "poblacio_2021": 4597,
    "poblacio_2008": 4028,
    "poblacio_1996": 3027
  },
  {
    "code": "46207",
    "latitude": 39.588834410547400,
    "longitude": -0.334696507135506,
    "name": "Rafelbunyol",
    "comarca": 17,
    "gentilici": "rafelbunyoler, rafelbunyolera",
    "poblacio_2025": 9974,
    "poblacio_2024": 9710,
    "poblacio_2023": 9467,
    "poblacio_2022": 9381,
    "poblacio_2021": 9351,
    "poblacio_2008": 7647,
    "poblacio_1996": 5260
  },
  {
    "code": "46208",
    "latitude": 38.931817438496100,
    "longitude": -0.168013746857022,
    "name": "Rafelcofer",
    "comarca": 28,
    "gentilici": "coferer, coferera",
    "poblacio_2025": 1409,
    "poblacio_2024": 1374,
    "poblacio_2023": 1372,
    "poblacio_2022": 1386,
    "poblacio_2021": 1365,
    "poblacio_2008": 1510,
    "poblacio_1996": 1390
  },
  {
    "code": "46209",
    "latitude": 39.051507647966400,
    "longitude": -0.455574667330277,
    "name": "Rafelguaraf",
    "comarca": 26,
    "gentilici": "rafelguarafí, rafelguarafina",
    "poblacio_2025": 2395,
    "poblacio_2024": 2350,
    "poblacio_2023": 2351,
    "poblacio_2022": 2360,
    "poblacio_2021": 2358,
    "poblacio_2008": 2489,
    "poblacio_1996": 2478
  },
  {
    "code": "03110",
    "latitude": 38.821170404894400,
    "longitude": -0.052052214588577,
    "name": "el Ràfol d'Almúnia",
    "comarca": 19,
    "gentilici": "rafolenc, rafolenca",
    "poblacio_2025": 734,
    "poblacio_2024": 703,
    "poblacio_2023": 721,
    "poblacio_2022": 731,
    "poblacio_2021": 670,
    "poblacio_2008": 692,
    "poblacio_1996": 368
  },
  {
    "code": "46210",
    "latitude": 38.865046083340100,
    "longitude": -0.398447896741223,
    "name": "el Ràfol de Salem",
    "comarca": 31,
    "gentilici": "rafolí, rafolina",
    "poblacio_2025": 463,
    "poblacio_2024": 464,
    "poblacio_2023": 467,
    "poblacio_2022": 443,
    "poblacio_2021": 449,
    "poblacio_2008": 450,
    "poblacio_1996": 377
  },
  {
    "code": "46212",
    "latitude": 39.335967386162100,
    "longitude": -0.608255788557461,
    "name": "Real",
    "comarca": 26,
    "gentilici": "realer, realera",
    "poblacio_2025": 2497,
    "poblacio_2024": 2435,
    "poblacio_2023": 2410,
    "poblacio_2022": 2287,
    "poblacio_2021": 2250,
    "poblacio_2008": 2283,
    "poblacio_1996": 1843
  },
  {
    "code": "46211",
    "latitude": 38.947920320662400,
    "longitude": -0.192032234612609,
    "name": "el Real de Gandia",
    "comarca": 28,
    "gentilici": "realer, realera",
    "poblacio_2025": 2722,
    "poblacio_2024": 2670,
    "poblacio_2023": 2649,
    "poblacio_2022": 2574,
    "poblacio_2021": 2551,
    "poblacio_2008": 2141,
    "poblacio_1996": 1802
  },
  {
    "code": "03111",
    "latitude": 38.116052008446200,
    "longitude": -0.910225181646692,
    "name": "Redován",
    "comarca": 9,
    "gentilici": "redovaner, redovanera",
    "poblacio_2025": 8283,
    "poblacio_2024": 8285,
    "poblacio_2023": 8183,
    "poblacio_2022": 8123,
    "poblacio_2021": 8058,
    "poblacio_2008": 7261,
    "poblacio_1996": 5268
  },
  {
    "code": "03112",
    "latitude": 38.588512070760900,
    "longitude": -0.309830252403697,
    "name": "Relleu",
    "comarca": 20,
    "gentilici": "relleuer, relleuera",
    "poblacio_2025": 1375,
    "poblacio_2024": 1288,
    "poblacio_2023": 1248,
    "poblacio_2022": 1171,
    "poblacio_2021": 1173,
    "poblacio_2008": 1205,
    "poblacio_1996": 822
  },
  {
    "code": "46213",
    "latitude": 39.488306103892700,
    "longitude": -1.102441529671640,
    "name": "Requena",
    "comarca": 23,
    "gentilici": "requenenc, requenenca",
    "poblacio_2025": 20982,
    "poblacio_2024": 20740,
    "poblacio_2023": 20387,
    "poblacio_2022": 20058,
    "poblacio_2021": 20235,
    "poblacio_2008": 20807,
    "poblacio_1996": 18795
  },
  {
    "code": "46214",
    "latitude": 39.545535781277000,
    "longitude": -0.571124573522982,
    "name": "Riba-roja de Túria",
    "comarca": 12,
    "gentilici": "riba-roger, riba-rogera",
    "poblacio_2025": 24616,
    "poblacio_2024": 24230,
    "poblacio_2023": 23555,
    "poblacio_2022": 23050,
    "poblacio_2021": 22799,
    "poblacio_2008": 19938,
    "poblacio_1996": 11236
  },
  {
    "code": "12095",
    "latitude": 40.022781210870000,
    "longitude": -0.275448885188883,
    "name": "Ribesalbes",
    "comarca": 22,
    "gentilici": "ribesalber, ribesalbera",
    "poblacio_2025": 1191,
    "poblacio_2024": 1163,
    "poblacio_2023": 1135,
    "poblacio_2022": 1159,
    "poblacio_2021": 1156,
    "poblacio_2008": 1363,
    "poblacio_1996": 1310
  },
  {
    "code": "46215",
    "latitude": 39.196202221201400,
    "longitude": -0.334454898927995,
    "name": "Riola",
    "comarca": 27,
    "gentilici": "riolenc, riolenca",
    "poblacio_2025": 1820,
    "poblacio_2024": 1770,
    "poblacio_2023": 1780,
    "poblacio_2022": 1793,
    "poblacio_2021": 1780,
    "poblacio_2008": 1826,
    "poblacio_1996": 1600
  },
  {
    "code": "46216",
    "latitude": 39.546856640687900,
    "longitude": -0.417745880932632,
    "name": "Rocafort",
    "comarca": 17,
    "gentilici": "rocafortà, rocafortana",
    "poblacio_2025": 7751,
    "poblacio_2024": 7753,
    "poblacio_2023": 7570,
    "poblacio_2022": 7603,
    "poblacio_2021": 7445,
    "poblacio_2008": 6584,
    "poblacio_1996": 4799
  },
  {
    "code": "03113",
    "latitude": 38.082068925103000,
    "longitude": -0.722865525890827,
    "name": "Rojales",
    "comarca": 9,
    "gentilici": "rojaler, rojalera",
    "poblacio_2025": 17652,
    "poblacio_2024": 17162,
    "poblacio_2023": 17451,
    "poblacio_2022": 16943,
    "poblacio_2021": 15978,
    "poblacio_2008": 19247,
    "poblacio_1996": 7195
  },
  {
    "code": "03114",
    "latitude": 38.366525953827300,
    "longitude": -0.897776338374648,
    "name": "la Romana",
    "comarca": 33,
    "gentilici": "romaner, romanera",
    "poblacio_2025": 2729,
    "poblacio_2024": 2672,
    "poblacio_2023": 2632,
    "poblacio_2022": 2605,
    "poblacio_2021": 2542,
    "poblacio_2008": 2539,
    "poblacio_1996": 2005
  },
  {
    "code": "12096",
    "latitude": 40.617301253314700,
    "longitude": 0.220154903509517,
    "name": "Rossell",
    "comarca": 8,
    "gentilici": "rossellà, rossellana",
    "poblacio_2025": 910,
    "poblacio_2024": 892,
    "poblacio_2023": 891,
    "poblacio_2022": 886,
    "poblacio_2021": 904,
    "poblacio_2008": 1217,
    "poblacio_1996": 1206
  },
  {
    "code": "46217",
    "latitude": 39.004626942425800,
    "longitude": -0.565259953315990,
    "name": "Rotglà i Corberà",
    "comarca": 15,
    "gentilici": "rotglaní, rotglanina",
    "poblacio_2025": 1171,
    "poblacio_2024": 1158,
    "poblacio_2023": 1165,
    "poblacio_2022": 1163,
    "poblacio_2021": 1146,
    "poblacio_2008": 1223,
    "poblacio_1996": 1018
  },
  {
    "code": "46218",
    "latitude": 38.932352172777000,
    "longitude": -0.258611121600036,
    "name": "Ròtova",
    "comarca": 28,
    "gentilici": "rotoví, rotovina",
    "poblacio_2025": 1283,
    "poblacio_2024": 1271,
    "poblacio_2023": 1292,
    "poblacio_2022": 1265,
    "poblacio_2021": 1271,
    "poblacio_2008": 1341,
    "poblacio_1996": 1345
  },
  {
    "code": "46219",
    "latitude": 38.879462762005500,
    "longitude": -0.361785470043425,
    "name": "Rugat",
    "comarca": 31,
    "gentilici": "rugatí, rugatina",
    "poblacio_2025": 165,
    "poblacio_2024": 171,
    "poblacio_2023": 166,
    "poblacio_2022": 175,
    "poblacio_2021": 180,
    "poblacio_2008": 181,
    "poblacio_1996": 199
  },
  {
    "code": "12097",
    "latitude": 39.851602870915500,
    "longitude": -0.714539169074602,
    "name": "Sacañet",
    "comarca": 6,
    "gentilici": "sacanyetí, sacanyetina",
    "poblacio_2025": 67,
    "poblacio_2024": 77,
    "poblacio_2023": 86,
    "poblacio_2022": 52,
    "poblacio_2021": 57,
    "poblacio_2008": 100,
    "poblacio_1996": 124
  },
  {
    "code": "03115",
    "latitude": 38.811212889272000,
    "longitude": -0.064664361622743,
    "name": "Sagra",
    "comarca": 19,
    "gentilici": "sagratí, sagratina",
    "poblacio_2025": 441,
    "poblacio_2024": 441,
    "poblacio_2023": 442,
    "poblacio_2022": 435,
    "poblacio_2021": 427,
    "poblacio_2008": 434,
    "poblacio_1996": 379
  },
  {
    "code": "46220",
    "latitude": 39.678231109299500,
    "longitude": -0.274858653742519,
    "name": "Sagunt",
    "comarca": 11,
    "gentilici": "saguntí, saguntina",
    "poblacio_2025": 73031,
    "poblacio_2024": 71377,
    "poblacio_2023": 70128,
    "poblacio_2022": 68066,
    "poblacio_2021": 67043,
    "poblacio_2008": 65821,
    "poblacio_1996": 58135
  },
  {
    "code": "46221",
    "latitude": 38.854140568084000,
    "longitude": -0.381327546547676,
    "name": "Salem",
    "comarca": 31,
    "gentilici": "salemer, salemera",
    "poblacio_2025": 407,
    "poblacio_2024": 394,
    "poblacio_2023": 401,
    "poblacio_2022": 411,
    "poblacio_2021": 414,
    "poblacio_2008": 476,
    "poblacio_1996": 471
  },
  {
    "code": "03116",
    "latitude": 38.519609925423100,
    "longitude": -0.913109181864840,
    "name": "Salinas",
    "comarca": 7,
    "gentilici": "saliner, salinera",
    "poblacio_2025": 1828,
    "poblacio_2024": 1775,
    "poblacio_2023": 1733,
    "poblacio_2022": 1678,
    "poblacio_2021": 1642,
    "poblacio_2008": 1588,
    "poblacio_1996": 1174
  },
  {
    "code": "12098",
    "latitude": 40.417489395972800,
    "longitude": 0.175075204144842,
    "name": "la Salzadella",
    "comarca": 8,
    "gentilici": "salzadellà, salzadellana",
    "poblacio_2025": 671,
    "poblacio_2024": 678,
    "poblacio_2023": 660,
    "poblacio_2022": 671,
    "poblacio_2021": 683,
    "poblacio_2008": 855,
    "poblacio_1996": 824
  },
  {
    "code": "46903",
    "latitude": 39.559698945262000,
    "longitude": -0.500222957543479,
    "name": "Sant Antoni de Benaixeve",
    "comarca": 12,
    "gentilici": "#N\/D",
    "poblacio_2025": 11192,
    "poblacio_2024": 10630,
    "poblacio_2023": 10200,
    "poblacio_2022": 9874,
    "poblacio_2021": 9501,
    "poblacio_2008": 5330,
    "poblacio_1996": 0
  },
  {
    "code": "03118",
    "latitude": 38.113171420709900,
    "longitude": -0.717953142502811,
    "name": "San Fulgencio",
    "comarca": 9,
    "gentilici": "santfulgentí, santfulgentina",
    "poblacio_2025": 9769,
    "poblacio_2024": 9433,
    "poblacio_2023": 9443,
    "poblacio_2022": 9091,
    "poblacio_2021": 8447,
    "poblacio_2008": 11594,
    "poblacio_1996": 2888
  },
  {
    "code": "03904",
    "latitude": 38.172457312564000,
    "longitude": -0.839245777957577,
    "name": "San Isidro",
    "comarca": 9,
    "gentilici": "santisidrenc, santisidrenca",
    "poblacio_2025": 2337,
    "poblacio_2024": 2312,
    "poblacio_2023": 2208,
    "poblacio_2022": 2154,
    "poblacio_2021": 2146,
    "poblacio_2008": 1708,
    "poblacio_1996": 1256
  },
  {
    "code": "03120",
    "latitude": 37.978038627548900,
    "longitude": -0.787921580179513,
    "name": "San Miguel de Salinas",
    "comarca": 9,
    "gentilici": "santmiqueler, santmiquelera",
    "poblacio_2025": 7177,
    "poblacio_2024": 6976,
    "poblacio_2023": 6798,
    "poblacio_2022": 6659,
    "poblacio_2021": 6553,
    "poblacio_2008": 8056,
    "poblacio_1996": 3521
  },
  {
    "code": "12101",
    "latitude": 40.606267845489300,
    "longitude": 0.346442089176256,
    "name": "Sant Rafel del Riu",
    "comarca": 8,
    "gentilici": "sant-rafelí, sant-rafelina",
    "poblacio_2025": 532,
    "poblacio_2024": 530,
    "poblacio_2023": 494,
    "poblacio_2022": 484,
    "poblacio_2021": 468,
    "poblacio_2008": 551,
    "poblacio_1996": 492
  },
  {
    "code": "03122",
    "latitude": 38.394468025591600,
    "longitude": -0.518891284146036,
    "name": "Sant Vicent del Raspeig",
    "comarca": 1,
    "gentilici": "santvicenter, santvicentera",
    "poblacio_2025": 60247,
    "poblacio_2024": 60269,
    "poblacio_2023": 59928,
    "poblacio_2022": 59138,
    "poblacio_2021": 58912,
    "poblacio_2008": 51507,
    "poblacio_1996": 34986
  },
  {
    "code": "03117",
    "latitude": 38.819641452060200,
    "longitude": -0.034066482565463,
    "name": "Sanet i els Negrals",
    "comarca": 19,
    "gentilici": "saneter, sanetera",
    "poblacio_2025": 712,
    "poblacio_2024": 722,
    "poblacio_2023": 737,
    "poblacio_2022": 734,
    "poblacio_2021": 702,
    "poblacio_2008": 740,
    "poblacio_1996": 566
  },
  {
    "code": "03119",
    "latitude": 38.398223070672500,
    "longitude": -0.434254776153989,
    "name": "Sant Joan d'Alacant",
    "comarca": 1,
    "gentilici": "santjoaner, santjoanera",
    "poblacio_2025": 26834,
    "poblacio_2024": 25918,
    "poblacio_2023": 25275,
    "poblacio_2022": 24450,
    "poblacio_2021": 24363,
    "poblacio_2008": 21681,
    "poblacio_1996": 16008
  },
  {
    "code": "12902",
    "latitude": 40.060104190145200,
    "longitude": -0.137113731323068,
    "name": "Sant Joan de Moró",
    "comarca": 21,
    "gentilici": "santjoaner, santjoanera",
    "poblacio_2025": 3695,
    "poblacio_2024": 3644,
    "poblacio_2023": 3516,
    "poblacio_2022": 3387,
    "poblacio_2021": 3307,
    "poblacio_2008": 2774,
    "poblacio_1996": 1669
  },
  {
    "code": "46222",
    "latitude": 39.071693821024400,
    "longitude": -0.486107978689155,
    "name": "Sant Joanet",
    "comarca": 26,
    "gentilici": "santjoaner, santjoanera",
    "poblacio_2025": 527,
    "poblacio_2024": 526,
    "poblacio_2023": 544,
    "poblacio_2022": 534,
    "poblacio_2021": 519,
    "poblacio_2008": 448,
    "poblacio_1996": 360
  },
  {
    "code": "12099",
    "latitude": 40.508380436958900,
    "longitude": 0.331452071947146,
    "name": "Sant Jordi",
    "comarca": 8,
    "gentilici": "santjordienc, santjordienca",
    "poblacio_2025": 1554,
    "poblacio_2024": 1381,
    "poblacio_2023": 1249,
    "poblacio_2022": 1171,
    "poblacio_2021": 1063,
    "poblacio_2008": 982,
    "poblacio_1996": 573
  },
  {
    "code": "12100",
    "latitude": 40.464069611263600,
    "longitude": 0.177857449272644,
    "name": "Sant Mateu",
    "comarca": 8,
    "gentilici": "santmateuà, santmateuana",
    "poblacio_2025": 2021,
    "poblacio_2024": 2004,
    "poblacio_2023": 1987,
    "poblacio_2022": 1954,
    "poblacio_2021": 1968,
    "poblacio_2008": 2162,
    "poblacio_1996": 1779
  },
  {
    "code": "12102",
    "latitude": 40.356215643844800,
    "longitude": 0.303393776254795,
    "name": "Santa Magdalena de Polpís",
    "comarca": 8,
    "gentilici": "magdalener, magdalenera",
    "poblacio_2025": 771,
    "poblacio_2024": 768,
    "poblacio_2023": 784,
    "poblacio_2022": 776,
    "poblacio_2021": 755,
    "poblacio_2008": 874,
    "poblacio_1996": 728
  },
  {
    "code": "03121",
    "latitude": 38.194025280727400,
    "longitude": -0.567564145119204,
    "name": "Santa Pola",
    "comarca": 10,
    "gentilici": "santapoler, santapolera",
    "poblacio_2025": 39709,
    "poblacio_2024": 38556,
    "poblacio_2023": 37816,
    "poblacio_2022": 36174,
    "poblacio_2021": 34148,
    "poblacio_2008": 30987,
    "poblacio_1996": 17099
  },
  {
    "code": "03123",
    "latitude": 38.535525746244600,
    "longitude": -0.821876346264883,
    "name": "Sax",
    "comarca": 7,
    "gentilici": "saixenc, saixenca",
    "poblacio_2025": 10346,
    "poblacio_2024": 10172,
    "poblacio_2023": 10072,
    "poblacio_2022": 9988,
    "poblacio_2021": 9935,
    "poblacio_2008": 9908,
    "poblacio_1996": 8605
  },
  {
    "code": "46223",
    "latitude": 39.425848796161300,
    "longitude": -0.384291554263141,
    "name": "Sedaví",
    "comarca": 18,
    "gentilici": "sedavienc, sedavienca",
    "poblacio_2025": 10837,
    "poblacio_2024": 10908,
    "poblacio_2023": 10637,
    "poblacio_2022": 10349,
    "poblacio_2021": 10344,
    "poblacio_2008": 9750,
    "poblacio_1996": 8198
  },
  {
    "code": "46224",
    "latitude": 39.681572047196400,
    "longitude": -0.373719647259437,
    "name": "Segart",
    "comarca": 11,
    "gentilici": "segardí, segardina",
    "poblacio_2025": 180,
    "poblacio_2024": 167,
    "poblacio_2023": 166,
    "poblacio_2022": 174,
    "poblacio_2021": 177,
    "poblacio_2008": 140,
    "poblacio_1996": 181
  },
  {
    "code": "12104",
    "latitude": 39.849936718053000,
    "longitude": -0.487744809713570,
    "name": "Segorbe",
    "comarca": 6,
    "gentilici": "sogorbí, sogorbina",
    "poblacio_2025": 9805,
    "poblacio_2024": 9640,
    "poblacio_2023": 9425,
    "poblacio_2022": 9146,
    "poblacio_2021": 9139,
    "poblacio_2008": 9131,
    "poblacio_1996": 7657
  },
  {
    "code": "03124",
    "latitude": 38.608617201954700,
    "longitude": -0.272616591390710,
    "name": "Sella",
    "comarca": 20,
    "gentilici": "sellard, sellarda",
    "poblacio_2025": 621,
    "poblacio_2024": 604,
    "poblacio_2023": 607,
    "poblacio_2022": 592,
    "poblacio_2021": 578,
    "poblacio_2008": 646,
    "poblacio_1996": 587
  },
  {
    "code": "46225",
    "latitude": 39.031807021733200,
    "longitude": -0.588074756280440,
    "name": "Sellent",
    "comarca": 26,
    "gentilici": "sellentí, sellentina",
    "poblacio_2025": 383,
    "poblacio_2024": 383,
    "poblacio_2023": 381,
    "poblacio_2022": 380,
    "poblacio_2021": 377,
    "poblacio_2008": 437,
    "poblacio_1996": 496
  },
  {
    "code": "46226",
    "latitude": 38.919444250060800,
    "longitude": -0.480385878810207,
    "name": "Sempere",
    "comarca": 31,
    "gentilici": "semperenc, semperenca",
    "poblacio_2025": 33,
    "poblacio_2024": 29,
    "poblacio_2023": 31,
    "poblacio_2022": 26,
    "poblacio_2021": 26,
    "poblacio_2008": 38,
    "poblacio_1996": 38
  },
  {
    "code": "03125",
    "latitude": 38.728027705591600,
    "longitude": 0.041288511413975,
    "name": "Senija",
    "comarca": 19,
    "gentilici": "senijol, senijola",
    "poblacio_2025": 698,
    "poblacio_2024": 696,
    "poblacio_2023": 670,
    "poblacio_2022": 623,
    "poblacio_2021": 605,
    "poblacio_2008": 645,
    "poblacio_1996": 474
  },
  {
    "code": "46227",
    "latitude": 39.063968832054200,
    "longitude": -0.510763984413019,
    "name": "Senyera",
    "comarca": 26,
    "gentilici": "senyerut, senyeruda",
    "poblacio_2025": 1114,
    "poblacio_2024": 1124,
    "poblacio_2023": 1122,
    "poblacio_2022": 1108,
    "poblacio_2021": 1132,
    "poblacio_2008": 1197,
    "poblacio_1996": 885
  },
  {
    "code": "46228",
    "latitude": 39.685994837346600,
    "longitude": -0.427140418671001,
    "name": "Serra",
    "comarca": 12,
    "gentilici": "serrà, serrana",
    "poblacio_2025": 3767,
    "poblacio_2024": 3725,
    "poblacio_2023": 3608,
    "poblacio_2022": 3405,
    "poblacio_2021": 3326,
    "poblacio_2008": 2990,
    "poblacio_1996": 1794
  },
  {
    "code": "12103",
    "latitude": 40.312998052529300,
    "longitude": 0.030918321016438,
    "name": "la Serratella",
    "comarca": 4,
    "gentilici": "serratellà, serratellana",
    "poblacio_2025": 113,
    "poblacio_2024": 113,
    "poblacio_2023": 110,
    "poblacio_2022": 103,
    "poblacio_2021": 92,
    "poblacio_2008": 88,
    "poblacio_1996": 109
  },
  {
    "code": "12105",
    "latitude": 40.269255576415500,
    "longitude": -0.019920721144707,
    "name": "la Serra d'en Galceran",
    "comarca": 21,
    "gentilici": "serratí, serratina",
    "poblacio_2025": 1039,
    "poblacio_2024": 1043,
    "poblacio_2023": 1045,
    "poblacio_2022": 997,
    "poblacio_2021": 992,
    "poblacio_2008": 1037,
    "poblacio_1996": 1090
  },
  {
    "code": "46229",
    "latitude": 39.474002561794000,
    "longitude": -0.917127627447787,
    "name": "Siete Aguas",
    "comarca": 16,
    "gentilici": "setaigüer, setaigüera",
    "poblacio_2025": 1289,
    "poblacio_2024": 1279,
    "poblacio_2023": 1229,
    "poblacio_2022": 1180,
    "poblacio_2021": 1183,
    "poblacio_2008": 1424,
    "poblacio_1996": 1074
  },
  {
    "code": "46230",
    "latitude": 39.362250900737400,
    "longitude": -0.410459078792574,
    "name": "Silla",
    "comarca": 18,
    "gentilici": "siller, sillera",
    "poblacio_2025": 20482,
    "poblacio_2024": 20117,
    "poblacio_2023": 19683,
    "poblacio_2022": 19298,
    "poblacio_2021": 19211,
    "poblacio_2008": 18985,
    "poblacio_1996": 16165
  },
  {
    "code": "46231",
    "latitude": 39.043526701062200,
    "longitude": -0.311328663846265,
    "name": "Simat de la Valldigna",
    "comarca": 28,
    "gentilici": "simater, simatera",
    "poblacio_2025": 3311,
    "poblacio_2024": 3289,
    "poblacio_2023": 3251,
    "poblacio_2022": 3271,
    "poblacio_2021": 3286,
    "poblacio_2008": 3589,
    "poblacio_1996": 3114
  },
  {
    "code": "46232",
    "latitude": 39.732608847339000,
    "longitude": -1.229413012389460,
    "name": "Sinarcas",
    "comarca": 23,
    "gentilici": "sinarquenc, sinarquenca",
    "poblacio_2025": 1176,
    "poblacio_2024": 1153,
    "poblacio_2023": 1113,
    "poblacio_2022": 1135,
    "poblacio_2021": 1109,
    "poblacio_2008": 1193,
    "poblacio_1996": 1253
  },
  {
    "code": "46233",
    "latitude": 39.277597199221700,
    "longitude": -0.381423790404147,
    "name": "Sollana",
    "comarca": 27,
    "gentilici": "sollaner, sollanera",
    "poblacio_2025": 5089,
    "poblacio_2024": 5035,
    "poblacio_2023": 4959,
    "poblacio_2022": 4915,
    "poblacio_2021": 4911,
    "poblacio_2008": 4889,
    "poblacio_1996": 4425
  },
  {
    "code": "12106",
    "latitude": 39.814007308774200,
    "longitude": -0.428271793671481,
    "name": "Soneja",
    "comarca": 6,
    "gentilici": "soneixí, soneixina",
    "poblacio_2025": 1521,
    "poblacio_2024": 1513,
    "poblacio_2023": 1508,
    "poblacio_2022": 1520,
    "poblacio_2021": 1479,
    "poblacio_2008": 1476,
    "poblacio_1996": 1416
  },
  {
    "code": "46234",
    "latitude": 39.621603840620700,
    "longitude": -0.909602388467224,
    "name": "Sot de Chera",
    "comarca": 29,
    "gentilici": "soter, sotera",
    "poblacio_2025": 427,
    "poblacio_2024": 432,
    "poblacio_2023": 423,
    "poblacio_2022": 384,
    "poblacio_2021": 387,
    "poblacio_2008": 441,
    "poblacio_1996": 283
  },
  {
    "code": "12107",
    "latitude": 39.805830795654100,
    "longitude": -0.410263020623564,
    "name": "Sot de Ferrer",
    "comarca": 6,
    "gentilici": "soter, sotera",
    "poblacio_2025": 492,
    "poblacio_2024": 498,
    "poblacio_2023": 474,
    "poblacio_2022": 447,
    "poblacio_2021": 428,
    "poblacio_2008": 471,
    "poblacio_1996": 412
  },
  {
    "code": "46235",
    "latitude": 39.198902684884800,
    "longitude": -0.310306352349287,
    "name": "Sueca",
    "comarca": 27,
    "gentilici": "suecà, suecana",
    "poblacio_2025": 29194,
    "poblacio_2024": 28480,
    "poblacio_2023": 28086,
    "poblacio_2022": 27738,
    "poblacio_2021": 27617,
    "poblacio_2008": 28713,
    "poblacio_1996": 24869
  },
  {
    "code": "12108",
    "latitude": 39.952087726032400,
    "longitude": -0.332589430265700,
    "name": "Suera",
    "comarca": 22,
    "gentilici": "suerenc, suerenca",
    "poblacio_2025": 593,
    "poblacio_2024": 573,
    "poblacio_2023": 572,
    "poblacio_2022": 565,
    "poblacio_2021": 554,
    "poblacio_2008": 643,
    "poblacio_1996": 568
  },
  {
    "code": "46236",
    "latitude": 39.097368623568800,
    "longitude": -0.630470870674244,
    "name": "Sumacàrcer",
    "comarca": 26,
    "gentilici": "sumacarcerí, sumacarcerina",
    "poblacio_2025": 1013,
    "poblacio_2024": 1042,
    "poblacio_2023": 1062,
    "poblacio_2022": 1054,
    "poblacio_2021": 1072,
    "poblacio_2008": 1295,
    "poblacio_1996": 1382
  },
  {
    "code": "12109",
    "latitude": 39.948046962245600,
    "longitude": -0.307797870130856,
    "name": "Tales",
    "comarca": 22,
    "gentilici": "taler, talera",
    "poblacio_2025": 827,
    "poblacio_2024": 834,
    "poblacio_2023": 852,
    "poblacio_2022": 853,
    "poblacio_2021": 843,
    "poblacio_2008": 879,
    "poblacio_1996": 770
  },
  {
    "code": "03127",
    "latitude": 38.694592692161200,
    "longitude": -0.103553068102091,
    "name": "Tàrbena",
    "comarca": 20,
    "gentilici": "tarbener, tarbenera",
    "poblacio_2025": 662,
    "poblacio_2024": 634,
    "poblacio_2023": 630,
    "poblacio_2022": 624,
    "poblacio_2021": 642,
    "poblacio_2008": 772,
    "poblacio_1996": 721
  },
  {
    "code": "46237",
    "latitude": 39.507302488777400,
    "longitude": -0.363468365577783,
    "name": "Tavernes Blanques",
    "comarca": 17,
    "gentilici": "taverner, tavernera",
    "poblacio_2025": 9824,
    "poblacio_2024": 9635,
    "poblacio_2023": 9456,
    "poblacio_2022": 9222,
    "poblacio_2021": 9205,
    "poblacio_2008": 9353,
    "poblacio_1996": 8299
  },
  {
    "code": "46238",
    "latitude": 39.072785341978100,
    "longitude": -0.266378094319034,
    "name": "Tavernes de la Valldigna",
    "comarca": 28,
    "gentilici": "valler, vallera",
    "poblacio_2025": 17866,
    "poblacio_2024": 17631,
    "poblacio_2023": 17443,
    "poblacio_2022": 17222,
    "poblacio_2021": 17162,
    "poblacio_2008": 18364,
    "poblacio_1996": 16412
  },
  {
    "code": "12110",
    "latitude": 39.900351804205300,
    "longitude": -0.658892646261308,
    "name": "Teresa",
    "comarca": 6,
    "gentilici": "teresà, teresana",
    "poblacio_2025": 254,
    "poblacio_2024": 231,
    "poblacio_2023": 250,
    "poblacio_2022": 253,
    "poblacio_2021": 245,
    "poblacio_2008": 303,
    "poblacio_1996": 382
  },
  {
    "code": "46239",
    "latitude": 39.106292923598300,
    "longitude": -1.051404603580890,
    "name": "Teresa de Cofrentes",
    "comarca": 32,
    "gentilici": "teresà, teresana",
    "poblacio_2025": 620,
    "poblacio_2024": 605,
    "poblacio_2023": 611,
    "poblacio_2022": 615,
    "poblacio_2021": 618,
    "poblacio_2008": 724,
    "poblacio_1996": 751
  },
  {
    "code": "46240",
    "latitude": 38.894466174021700,
    "longitude": -0.320690995375680,
    "name": "Terrateig",
    "comarca": 31,
    "gentilici": "terrategí, terrategina",
    "poblacio_2025": 290,
    "poblacio_2024": 290,
    "poblacio_2023": 291,
    "poblacio_2022": 287,
    "poblacio_2021": 276,
    "poblacio_2008": 339,
    "poblacio_1996": 195
  },
  {
    "code": "03128",
    "latitude": 38.728507604535200,
    "longitude": 0.105077814001675,
    "name": "Teulada",
    "comarca": 19,
    "gentilici": "teulader, teuladera",
    "poblacio_2025": 12912,
    "poblacio_2024": 12834,
    "poblacio_2023": 12515,
    "poblacio_2022": 11944,
    "poblacio_2021": 11466,
    "poblacio_2008": 14236,
    "poblacio_1996": 8430
  },
  {
    "code": "03129",
    "latitude": 38.531667521420100,
    "longitude": -0.580736832668572,
    "name": "Tibi",
    "comarca": 3,
    "gentilici": "tiber, tibera",
    "poblacio_2025": 1757,
    "poblacio_2024": 1803,
    "poblacio_2023": 1808,
    "poblacio_2022": 1731,
    "poblacio_2021": 1691,
    "poblacio_2008": 1677,
    "poblacio_1996": 1147
  },
  {
    "code": "12111",
    "latitude": 40.423853042651000,
    "longitude": 0.078790623230901,
    "name": "Tírig",
    "comarca": 4,
    "gentilici": "tirijà, tirijana",
    "poblacio_2025": 417,
    "poblacio_2024": 432,
    "poblacio_2023": 430,
    "poblacio_2022": 417,
    "poblacio_2021": 419,
    "poblacio_2008": 562,
    "poblacio_1996": 575
  },
  {
    "code": "46241",
    "latitude": 39.865620218826200,
    "longitude": -1.081660724567570,
    "name": "Titaguas",
    "comarca": 29,
    "gentilici": "titaigüenc, titaigüenca",
    "poblacio_2025": 517,
    "poblacio_2024": 494,
    "poblacio_2023": 505,
    "poblacio_2022": 485,
    "poblacio_2021": 470,
    "poblacio_2008": 534,
    "poblacio_1996": 556
  },
  {
    "code": "12112",
    "latitude": 40.646560684348500,
    "longitude": -0.246953612035234,
    "name": "la Todolella",
    "comarca": 24,
    "gentilici": "todolellà, todolellana",
    "poblacio_2025": 136,
    "poblacio_2024": 147,
    "poblacio_2023": 144,
    "poblacio_2022": 156,
    "poblacio_2021": 145,
    "poblacio_2008": 143,
    "poblacio_1996": 138
  },
  {
    "code": "12113",
    "latitude": 40.042377128087700,
    "longitude": -0.365830939530594,
    "name": "Toga",
    "comarca": 5,
    "gentilici": "togà, togana",
    "poblacio_2025": 106,
    "poblacio_2024": 108,
    "poblacio_2023": 112,
    "poblacio_2022": 104,
    "poblacio_2021": 101,
    "poblacio_2008": 118,
    "poblacio_1996": 110
  },
  {
    "code": "03130",
    "latitude": 38.756901442444800,
    "longitude": -0.274701792005676,
    "name": "Tollos",
    "comarca": 14,
    "gentilici": "toller, tollera",
    "poblacio_2025": 32,
    "poblacio_2024": 38,
    "poblacio_2023": 40,
    "poblacio_2022": 30,
    "poblacio_2021": 37,
    "poblacio_2008": 65,
    "poblacio_1996": 47
  },
  {
    "code": "12114",
    "latitude": 39.919634308925000,
    "longitude": -0.685295877762168,
    "name": "Torás",
    "comarca": 6,
    "gentilici": "toraser, torasera",
    "poblacio_2025": 271,
    "poblacio_2024": 268,
    "poblacio_2023": 256,
    "poblacio_2022": 249,
    "poblacio_2021": 247,
    "poblacio_2008": 250,
    "poblacio_1996": 278
  },
  {
    "code": "03131",
    "latitude": 38.800872254673800,
    "longitude": -0.073339373568062,
    "name": "Tormos",
    "comarca": 19,
    "gentilici": "tormer, tormera",
    "poblacio_2025": 323,
    "poblacio_2024": 328,
    "poblacio_2023": 339,
    "poblacio_2022": 332,
    "poblacio_2021": 327,
    "poblacio_2008": 375,
    "poblacio_1996": 305
  },
  {
    "code": "12115",
    "latitude": 39.982689232367200,
    "longitude": -0.748337058795649,
    "name": "el Toro",
    "comarca": 6,
    "gentilici": "torà, torana",
    "poblacio_2025": 256,
    "poblacio_2024": 262,
    "poblacio_2023": 248,
    "poblacio_2022": 238,
    "poblacio_2021": 239,
    "poblacio_2008": 309,
    "poblacio_1996": 364
  },
  {
    "code": "12116",
    "latitude": 39.988875055363600,
    "longitude": -0.438517672124007,
    "name": "Torralba del Pinar",
    "comarca": 5,
    "gentilici": "torralbí, torralbina",
    "poblacio_2025": 57,
    "poblacio_2024": 59,
    "poblacio_2023": 69,
    "poblacio_2022": 60,
    "poblacio_2021": 63,
    "poblacio_2008": 68,
    "poblacio_1996": 71
  },
  {
    "code": "12119",
    "latitude": 40.327055087965600,
    "longitude": -0.080012143418509,
    "name": "la Torre d'en Besora",
    "comarca": 4,
    "gentilici": "torretí, torretina",
    "poblacio_2025": 164,
    "poblacio_2024": 163,
    "poblacio_2023": 164,
    "poblacio_2022": 165,
    "poblacio_2021": 167,
    "poblacio_2008": 184,
    "poblacio_1996": 227
  },
  {
    "code": "12120",
    "latitude": 40.262829417023500,
    "longitude": 0.070076708294795,
    "name": "la Torre d'en Doménec",
    "comarca": 21,
    "gentilici": "torretí, torretina",
    "poblacio_2025": 177,
    "poblacio_2024": 182,
    "poblacio_2023": 175,
    "poblacio_2022": 167,
    "poblacio_2021": 157,
    "poblacio_2008": 243,
    "poblacio_1996": 260
  },
  {
    "code": "46242",
    "latitude": 40.098003062085000,
    "longitude": -1.258760262245120,
    "name": "Torrebaja",
    "comarca": 25,
    "gentilici": "torrebaixer, torrebaixera",
    "poblacio_2025": 398,
    "poblacio_2024": 391,
    "poblacio_2023": 404,
    "poblacio_2022": 408,
    "poblacio_2021": 403,
    "poblacio_2008": 433,
    "poblacio_1996": 457
  },
  {
    "code": "12117",
    "latitude": 40.218553293547800,
    "longitude": 0.194801015300062,
    "name": "Torreblanca",
    "comarca": 21,
    "gentilici": "torreblanquí, torreblanquina",
    "poblacio_2025": 5744,
    "poblacio_2024": 5674,
    "poblacio_2023": 5630,
    "poblacio_2022": 5682,
    "poblacio_2021": 5606,
    "poblacio_2008": 6192,
    "poblacio_1996": 4583
  },
  {
    "code": "12118",
    "latitude": 40.049349395591800,
    "longitude": -0.397805984343853,
    "name": "Torrechiva",
    "comarca": 5,
    "gentilici": "torre-xiver, torre-xivera",
    "poblacio_2025": 106,
    "poblacio_2024": 127,
    "poblacio_2023": 114,
    "poblacio_2022": 89,
    "poblacio_2021": 93,
    "poblacio_2008": 98,
    "poblacio_1996": 63
  },
  {
    "code": "46243",
    "latitude": 38.988639650241300,
    "longitude": -0.571527768943195,
    "name": "Torrella",
    "comarca": 15,
    "gentilici": "torrellà, torrellana",
    "poblacio_2025": 151,
    "poblacio_2024": 150,
    "poblacio_2023": 143,
    "poblacio_2022": 134,
    "poblacio_2021": 135,
    "poblacio_2008": 150,
    "poblacio_1996": 204
  },
  {
    "code": "03132",
    "latitude": 38.610065173243300,
    "longitude": -0.420293095775141,
    "name": "la Torre de les Maçanes",
    "comarca": 1,
    "gentilici": "torrudà, torrudana",
    "poblacio_2025": 749,
    "poblacio_2024": 744,
    "poblacio_2023": 714,
    "poblacio_2022": 683,
    "poblacio_2021": 681,
    "poblacio_2008": 758,
    "poblacio_1996": 749
  },
  {
    "code": "46244",
    "latitude": 39.433554003178300,
    "longitude": -0.472381198912484,
    "name": "Torrent",
    "comarca": 18,
    "gentilici": "torrentí, torrentina",
    "poblacio_2025": 90928,
    "poblacio_2024": 89401,
    "poblacio_2023": 87295,
    "poblacio_2022": 85142,
    "poblacio_2021": 84025,
    "poblacio_2008": 76927,
    "poblacio_1996": 60999
  },
  {
    "code": "46245",
    "latitude": 39.743014439880900,
    "longitude": -0.356416904083382,
    "name": "Torres Torres",
    "comarca": 11,
    "gentilici": "torrestorrer, torrestorrera",
    "poblacio_2025": 808,
    "poblacio_2024": 750,
    "poblacio_2023": 745,
    "poblacio_2022": 703,
    "poblacio_2021": 672,
    "poblacio_2008": 550,
    "poblacio_1996": 417
  },
  {
    "code": "03133",
    "latitude": 37.984568886813800,
    "longitude": -0.672387918235293,
    "name": "Torrevieja",
    "comarca": 9,
    "gentilici": "torrevellenc, torrevellenca",
    "poblacio_2025": 98533,
    "poblacio_2024": 94803,
    "poblacio_2023": 89290,
    "poblacio_2022": 83547,
    "poblacio_2021": 82842,
    "poblacio_2008": 101381,
    "poblacio_1996": 35998
  },
  {
    "code": "46246",
    "latitude": 39.139324564384200,
    "longitude": -0.586220716026873,
    "name": "Tous",
    "comarca": 26,
    "gentilici": "touer, touera \/ touenc, touenca",
    "poblacio_2025": 1354,
    "poblacio_2024": 1357,
    "poblacio_2023": 1352,
    "poblacio_2022": 1312,
    "poblacio_2021": 1284,
    "poblacio_2008": 1172,
    "poblacio_1996": 1205
  },
  {
    "code": "12121",
    "latitude": 40.524066680996300,
    "longitude": 0.290305682965384,
    "name": "Traiguera",
    "comarca": 8,
    "gentilici": "traiguerí, traiguerina",
    "poblacio_2025": 1302,
    "poblacio_2024": 1300,
    "poblacio_2023": 1336,
    "poblacio_2022": 1323,
    "poblacio_2021": 1358,
    "poblacio_2008": 1704,
    "poblacio_1996": 1597
  },
  {
    "code": "46247",
    "latitude": 39.763689775788200,
    "longitude": -1.040169943934400,
    "name": "Tuéjar",
    "comarca": 29,
    "gentilici": "toixà, toixana",
    "poblacio_2025": 1278,
    "poblacio_2024": 1233,
    "poblacio_2023": 1201,
    "poblacio_2022": 1168,
    "poblacio_2021": 1164,
    "poblacio_2008": 1271,
    "poblacio_1996": 1342
  },
  {
    "code": "46248",
    "latitude": 39.389301526940800,
    "longitude": -0.709983488283036,
    "name": "Torís",
    "comarca": 26,
    "gentilici": "torisà, torisana",
    "poblacio_2025": 7717,
    "poblacio_2024": 7544,
    "poblacio_2023": 7259,
    "poblacio_2022": 7019,
    "poblacio_2021": 6910,
    "poblacio_2008": 6317,
    "poblacio_1996": 4471
  },
  {
    "code": "12122",
    "latitude": 40.157666434763000,
    "longitude": -0.164187028696360,
    "name": "les Useres",
    "comarca": 2,
    "gentilici": "userà, userana",
    "poblacio_2025": 954,
    "poblacio_2024": 961,
    "poblacio_2023": 985,
    "poblacio_2022": 949,
    "poblacio_2021": 968,
    "poblacio_2008": 1008,
    "poblacio_1996": 1094
  },
  {
    "code": "46249",
    "latitude": 39.567997619736500,
    "longitude": -1.205157738653940,
    "name": "Utiel",
    "comarca": 23,
    "gentilici": "utielà, utielana",
    "poblacio_2025": 11663,
    "poblacio_2024": 11703,
    "poblacio_2023": 11632,
    "poblacio_2022": 11482,
    "poblacio_2021": 11478,
    "poblacio_2008": 12294,
    "poblacio_1996": 11782
  },
  {
    "code": "46250",
    "latitude": 39.469646776894100,
    "longitude": -0.355027782330957,
    "name": "València",
    "comarca": 30,
    "gentilici": "valencià, valenciana",
    "poblacio_2025": 840792,
    "poblacio_2024": 825948,
    "poblacio_2023": 807693,
    "poblacio_2022": 792492,
    "poblacio_2021": 789744,
    "poblacio_2008": 807200,
    "poblacio_1996": 746683
  },
  {
    "code": "12124",
    "latitude": 40.175546140105000,
    "longitude": -0.036312790708658,
    "name": "la Vall d'Alba",
    "comarca": 21,
    "gentilici": "valldalbenc, valldalbenca",
    "poblacio_2025": 3218,
    "poblacio_2024": 3103,
    "poblacio_2023": 3054,
    "poblacio_2022": 2959,
    "poblacio_2021": 2943,
    "poblacio_2008": 2906,
    "poblacio_1996": 1853
  },
  {
    "code": "03134",
    "latitude": 38.794777819231300,
    "longitude": -0.252186258087154,
    "name": "la Vall d'Alcalà",
    "comarca": 19,
    "gentilici": "alcalaner, alcalanera",
    "poblacio_2025": 159,
    "poblacio_2024": 175,
    "poblacio_2023": 174,
    "poblacio_2022": 164,
    "poblacio_2021": 163,
    "poblacio_2008": 186,
    "poblacio_1996": 186
  },
  {
    "code": "12125",
    "latitude": 39.903715970443100,
    "longitude": -0.456283337940622,
    "name": "Vall de Almonacid",
    "comarca": 6,
    "gentilici": "valler, vallera",
    "poblacio_2025": 284,
    "poblacio_2024": 281,
    "poblacio_2023": 286,
    "poblacio_2022": 287,
    "poblacio_2021": 286,
    "poblacio_2008": 275,
    "poblacio_1996": 288
  },
  {
    "code": "03135",
    "latitude": 38.804582053699300,
    "longitude": -0.159655281106893,
    "name": "la Vall d'Ebo",
    "comarca": 19,
    "gentilici": "ebolí, ebolina",
    "poblacio_2025": 231,
    "poblacio_2024": 230,
    "poblacio_2023": 230,
    "poblacio_2022": 219,
    "poblacio_2021": 204,
    "poblacio_2008": 299,
    "poblacio_1996": 343
  },
  {
    "code": "12126",
    "latitude": 39.825233696214600,
    "longitude": -0.230827057753329,
    "name": "la Vall d'Uixó",
    "comarca": 22,
    "gentilici": "valler, vallera",
    "poblacio_2025": 32242,
    "poblacio_2024": 31884,
    "poblacio_2023": 31611,
    "poblacio_2022": 31388,
    "poblacio_2021": 31549,
    "poblacio_2008": 32617,
    "poblacio_1996": 28283
  },
  {
    "code": "03136",
    "latitude": 38.821072930622000,
    "longitude": -0.262233252595464,
    "name": "la Vall de Gallinera",
    "comarca": 19,
    "gentilici": "valler, vallera",
    "poblacio_2025": 583,
    "poblacio_2024": 584,
    "poblacio_2023": 581,
    "poblacio_2022": 579,
    "poblacio_2021": 557,
    "poblacio_2008": 671,
    "poblacio_1996": 682
  },
  {
    "code": "03137",
    "latitude": 38.779674704339200,
    "longitude": -0.103017637021752,
    "name": "la Vall de Laguar",
    "comarca": 19,
    "gentilici": "guarer, guarera",
    "poblacio_2025": 905,
    "poblacio_2024": 903,
    "poblacio_2023": 873,
    "poblacio_2022": 890,
    "poblacio_2021": 843,
    "poblacio_2008": 997,
    "poblacio_1996": 918
  },
  {
    "code": "46251",
    "latitude": 38.896217110488500,
    "longitude": -0.690334676253849,
    "name": "Vallada",
    "comarca": 15,
    "gentilici": "valladí, valladina",
    "poblacio_2025": 3091,
    "poblacio_2024": 3079,
    "poblacio_2023": 3063,
    "poblacio_2022": 3065,
    "poblacio_2021": 3092,
    "poblacio_2008": 3466,
    "poblacio_1996": 3089
  },
  {
    "code": "46252",
    "latitude": 40.063064182888800,
    "longitude": -1.339176280579430,
    "name": "Vallanca",
    "comarca": 25,
    "gentilici": "vallanquer, vallanquera",
    "poblacio_2025": 128,
    "poblacio_2024": 131,
    "poblacio_2023": 144,
    "poblacio_2022": 128,
    "poblacio_2021": 136,
    "poblacio_2008": 170,
    "poblacio_1996": 240
  },
  {
    "code": "12123",
    "latitude": 40.029955626145500,
    "longitude": -0.336443268156823,
    "name": "Vallat",
    "comarca": 5,
    "gentilici": "vallatí, vallatina",
    "poblacio_2025": 66,
    "poblacio_2024": 71,
    "poblacio_2023": 66,
    "poblacio_2022": 54,
    "poblacio_2021": 57,
    "poblacio_2008": 79,
    "poblacio_1996": 43
  },
  {
    "code": "46253",
    "latitude": 38.985089023360400,
    "longitude": -0.556747843727814,
    "name": "Vallés",
    "comarca": 15,
    "gentilici": "vallesí, vallesina",
    "poblacio_2025": 161,
    "poblacio_2024": 148,
    "poblacio_2023": 151,
    "poblacio_2022": 151,
    "poblacio_2021": 152,
    "poblacio_2008": 131,
    "poblacio_1996": 103
  },
  {
    "code": "12127",
    "latitude": 40.602964593848100,
    "longitude": 0.046533047986166,
    "name": "Vallibona",
    "comarca": 24,
    "gentilici": "vallibonenc, vallibonenca",
    "poblacio_2025": 63,
    "poblacio_2024": 64,
    "poblacio_2023": 62,
    "poblacio_2022": 61,
    "poblacio_2021": 67,
    "poblacio_2008": 98,
    "poblacio_1996": 108
  },
  {
    "code": "46254",
    "latitude": 39.483469036656700,
    "longitude": -1.356673681807430,
    "name": "Venta del Moro",
    "comarca": 23,
    "gentilici": "ventamorí, ventamorina",
    "poblacio_2025": 1143,
    "poblacio_2024": 1158,
    "poblacio_2023": 1164,
    "poblacio_2022": 1180,
    "poblacio_2021": 1194,
    "poblacio_2008": 1401,
    "poblacio_1996": 1636
  },
  {
    "code": "03138",
    "latitude": 38.862284699919900,
    "longitude": -0.004080181100299,
    "name": "el Verger",
    "comarca": 19,
    "gentilici": "vergerí, vergerina",
    "poblacio_2025": 5508,
    "poblacio_2024": 5272,
    "poblacio_2023": 5101,
    "poblacio_2022": 4986,
    "poblacio_2021": 4841,
    "poblacio_2008": 4847,
    "poblacio_1996": 3627
  },
  {
    "code": "12135",
    "latitude": 39.944437748222000,
    "longitude": -0.098178988939260,
    "name": "Vila-real",
    "comarca": 22,
    "gentilici": "vila-realenc, vila-realenca",
    "poblacio_2025": 53623,
    "poblacio_2024": 52505,
    "poblacio_2023": 51852,
    "poblacio_2022": 51369,
    "poblacio_2021": 51130,
    "poblacio_2008": 50626,
    "poblacio_1996": 39550
  },
  {
    "code": "12128",
    "latitude": 40.112652674132700,
    "longitude": -0.051947406240855,
    "name": "Vilafamés",
    "comarca": 21,
    "gentilici": "vilafamesí, vilafamesina",
    "poblacio_2025": 1962,
    "poblacio_2024": 1938,
    "poblacio_2023": 1915,
    "poblacio_2022": 1864,
    "poblacio_2021": 1840,
    "poblacio_2008": 1992,
    "poblacio_1996": 1422
  },
  {
    "code": "12129",
    "latitude": 40.425637563648800,
    "longitude": -0.256180850783091,
    "name": "Vilafranca",
    "comarca": 24,
    "gentilici": "vilafranquí, vilafranquina",
    "poblacio_2025": 2115,
    "poblacio_2024": 2139,
    "poblacio_2023": 2148,
    "poblacio_2022": 2154,
    "poblacio_2021": 2201,
    "poblacio_2008": 2520,
    "poblacio_1996": 2740
  },
  {
    "code": "46255",
    "latitude": 38.885896776777500,
    "longitude": -0.207295204780890,
    "name": "Vilallonga",
    "comarca": 28,
    "gentilici": "vilallonguer, vilallonguera",
    "poblacio_2025": 4865,
    "poblacio_2024": 4713,
    "poblacio_2023": 4667,
    "poblacio_2022": 4555,
    "poblacio_2021": 4453,
    "poblacio_2008": 4316,
    "poblacio_1996": 3649
  },
  {
    "code": "46256",
    "latitude": 39.567836695651900,
    "longitude": -0.623933935227761,
    "name": "Vilamarxant",
    "comarca": 12,
    "gentilici": "vilamarxanter, vilamarxantera",
    "poblacio_2025": 11403,
    "poblacio_2024": 11041,
    "poblacio_2023": 10772,
    "poblacio_2022": 10348,
    "poblacio_2021": 10097,
    "poblacio_2008": 8257,
    "poblacio_1996": 5592
  },
  {
    "code": "12132",
    "latitude": 40.231190900657600,
    "longitude": 0.072766241972280,
    "name": "Vilanova d'Alcolea",
    "comarca": 21,
    "gentilici": "vilanoví, vilanovina",
    "poblacio_2025": 584,
    "poblacio_2024": 585,
    "poblacio_2023": 575,
    "poblacio_2022": 571,
    "poblacio_2021": 578,
    "poblacio_2008": 703,
    "poblacio_1996": 669
  },
  {
    "code": "12134",
    "latitude": 40.358034862961900,
    "longitude": -0.066079368785720,
    "name": "Vilar de Canes",
    "comarca": 4,
    "gentilici": "vilarenc, vilarenca",
    "poblacio_2025": 156,
    "poblacio_2024": 156,
    "poblacio_2023": 159,
    "poblacio_2022": 170,
    "poblacio_2021": 174,
    "poblacio_2008": 176,
    "poblacio_1996": 188
  },
  {
    "code": "12136",
    "latitude": 39.857914893778400,
    "longitude": -0.184120347220212,
    "name": "la Vilavella",
    "comarca": 22,
    "gentilici": "vilaveller, vilavellera",
    "poblacio_2025": 3054,
    "poblacio_2024": 3073,
    "poblacio_2023": 3074,
    "poblacio_2022": 3084,
    "poblacio_2021": 3111,
    "poblacio_2008": 3418,
    "poblacio_1996": 3413
  },
  {
    "code": "12130",
    "latitude": 40.20323174,
    "longitude": -0.4185474803,
    "name": "Villahermosa del Río",
    "comarca": 5,
    "gentilici": "vilafermoser, vilafermosera",
    "poblacio_2025": 473,
    "poblacio_2024": 490,
    "poblacio_2023": 488,
    "poblacio_2022": 463,
    "poblacio_2021": 476,
    "poblacio_2008": 451,
    "poblacio_1996": 474
  },
  {
    "code": "03139",
    "latitude": 38.508953001899500,
    "longitude": -0.229286762072063,
    "name": "la Vila Joiosa",
    "comarca": 20,
    "gentilici": "viler, vilera",
    "poblacio_2025": 37449,
    "poblacio_2024": 36891,
    "poblacio_2023": 36093,
    "poblacio_2022": 34828,
    "poblacio_2021": 34684,
    "poblacio_2008": 32534,
    "poblacio_1996": 22866
  },
  {
    "code": "12131",
    "latitude": 39.964472664177700,
    "longitude": -0.395204756628110,
    "name": "Villamalur",
    "comarca": 5,
    "gentilici": "vilamalurenc, vilamalurenca",
    "poblacio_2025": 99,
    "poblacio_2024": 97,
    "poblacio_2023": 95,
    "poblacio_2022": 85,
    "poblacio_2021": 92,
    "poblacio_2008": 90,
    "poblacio_1996": 161
  },
  {
    "code": "46257",
    "latitude": 39.076558660041100,
    "longitude": -0.512812732369595,
    "name": "Castelló",
    "comarca": 26,
    "gentilici": "castellonenc, castellonenca",
    "poblacio_2025": 6972,
    "poblacio_2024": 6897,
    "poblacio_2023": 6891,
    "poblacio_2022": 6932,
    "poblacio_2021": 6996,
    "poblacio_2008": 7666,
    "poblacio_1996": 7089
  },
  {
    "code": "12133",
    "latitude": 40.059407907473900,
    "longitude": -0.647676369075050,
    "name": "Villanueva de Viver",
    "comarca": 5,
    "gentilici": "vilanovenc, vilanovenca",
    "poblacio_2025": 94,
    "poblacio_2024": 98,
    "poblacio_2023": 110,
    "poblacio_2022": 89,
    "poblacio_2021": 82,
    "poblacio_2008": 74,
    "poblacio_1996": 95
  },
  {
    "code": "46258",
    "latitude": 39.731910745753600,
    "longitude": -0.827813300311257,
    "name": "Villar del Arzobispo",
    "comarca": 29,
    "gentilici": "vilarenc, vilarenca",
    "poblacio_2025": 3862,
    "poblacio_2024": 3775,
    "poblacio_2023": 3700,
    "poblacio_2022": 3581,
    "poblacio_2021": 3578,
    "poblacio_2008": 3863,
    "poblacio_1996": 3460
  },
  {
    "code": "46259",
    "latitude": 39.536019387299800,
    "longitude": -1.440010710670890,
    "name": "Villargordo del Cabriel",
    "comarca": 23,
    "gentilici": "villagordenc, villagordenca",
    "poblacio_2025": 588,
    "poblacio_2024": 594,
    "poblacio_2023": 577,
    "poblacio_2022": 602,
    "poblacio_2021": 585,
    "poblacio_2008": 700,
    "poblacio_1996": 739
  },
  {
    "code": "03140",
    "latitude": 38.635582647115400,
    "longitude": -0.865136203948478,
    "name": "Villena",
    "comarca": 7,
    "gentilici": "villener, villenera",
    "poblacio_2025": 34712,
    "poblacio_2024": 34385,
    "poblacio_2023": 34144,
    "poblacio_2022": 33969,
    "poblacio_2021": 34025,
    "poblacio_2008": 34928,
    "poblacio_1996": 31555
  },
  {
    "code": "12137",
    "latitude": 40.676041354283500,
    "longitude": -0.201075264040624,
    "name": "Villores",
    "comarca": 24,
    "gentilici": "villorà, villorana \/ villorí, villorina",
    "poblacio_2025": 51,
    "poblacio_2024": 53,
    "poblacio_2023": 54,
    "poblacio_2022": 53,
    "poblacio_2021": 46,
    "poblacio_2008": 53,
    "poblacio_1996": 72
  },
  {
    "code": "46260",
    "latitude": 39.536004799115800,
    "longitude": -0.370726841449488,
    "name": "Vinalesa",
    "comarca": 17,
    "gentilici": "vinalesí, vinalesina",
    "poblacio_2025": 3572,
    "poblacio_2024": 3531,
    "poblacio_2023": 3495,
    "poblacio_2022": 3525,
    "poblacio_2021": 3451,
    "poblacio_2008": 2970,
    "poblacio_1996": 2265
  },
  {
    "code": "12138",
    "latitude": 40.489631840519500,
    "longitude": 0.491010326879693,
    "name": "Vinaròs",
    "comarca": 8,
    "gentilici": "vinarossenc, vinarossenca",
    "poblacio_2025": 30529,
    "poblacio_2024": 30278,
    "poblacio_2023": 29686,
    "poblacio_2022": 29120,
    "poblacio_2021": 28862,
    "poblacio_2008": 27912,
    "poblacio_1996": 20940
  },
  {
    "code": "12139",
    "latitude": 40.293439273506500,
    "longitude": -0.292462587305589,
    "name": "Vistabella del Maestrat",
    "comarca": 4,
    "gentilici": "vistabellà, vistabellana",
    "poblacio_2025": 354,
    "poblacio_2024": 361,
    "poblacio_2023": 369,
    "poblacio_2022": 334,
    "poblacio_2021": 337,
    "poblacio_2008": 426,
    "poblacio_1996": 475
  },
  {
    "code": "12140",
    "latitude": 39.921857612958100,
    "longitude": -0.595591700156049,
    "name": "Viver",
    "comarca": 6,
    "gentilici": "viverenc, viverenca",
    "poblacio_2025": 1729,
    "poblacio_2024": 1680,
    "poblacio_2023": 1683,
    "poblacio_2022": 1691,
    "poblacio_2021": 1661,
    "poblacio_2008": 1703,
    "poblacio_1996": 1202
  },
  {
    "code": "03081",
    "latitude": 38.738452316972100,
    "longitude": -0.010680786357365,
    "name": "Xaló",
    "comarca": 19,
    "gentilici": "xaloner, xalonera",
    "poblacio_2025": 3104,
    "poblacio_2024": 3042,
    "poblacio_2023": 2964,
    "poblacio_2022": 2931,
    "poblacio_2021": 2892,
    "poblacio_2008": 3189,
    "poblacio_1996": 2011
  },
  {
    "code": "46145",
    "latitude": 38.988652711293200,
    "longitude": -0.526170074025732,
    "name": "Xàtiva",
    "comarca": 15,
    "gentilici": "xativí, xativina",
    "poblacio_2025": 31008,
    "poblacio_2024": 30378,
    "poblacio_2023": 30072,
    "poblacio_2022": 29637,
    "poblacio_2021": 29459,
    "poblacio_2008": 29363,
    "poblacio_1996": 24760
  },
  {
    "code": "46143",
    "latitude": 39.032875827002500,
    "longitude": -0.215606925260523,
    "name": "Xeraco",
    "comarca": 28,
    "gentilici": "xeraquer, xeraquera",
    "poblacio_2025": 6149,
    "poblacio_2024": 6044,
    "poblacio_2023": 5923,
    "poblacio_2022": 5819,
    "poblacio_2021": 5771,
    "poblacio_2008": 6259,
    "poblacio_1996": 4573
  },
  {
    "code": "46146",
    "latitude": 39.010460876382000,
    "longitude": -0.218163768677484,
    "name": "Xeresa",
    "comarca": 28,
    "gentilici": "xeresà, xeresana",
    "poblacio_2025": 2418,
    "poblacio_2024": 2341,
    "poblacio_2023": 2263,
    "poblacio_2022": 2244,
    "poblacio_2021": 2256,
    "poblacio_2008": 2220,
    "poblacio_1996": 1880
  },
  {
    "code": "12052",
    "latitude": 40.517792296774500,
    "longitude": 0.158871482182270,
    "name": "Xert",
    "comarca": 8,
    "gentilici": "xertolí, xertolina",
    "poblacio_2025": 702,
    "poblacio_2024": 686,
    "poblacio_2023": 686,
    "poblacio_2022": 679,
    "poblacio_2021": 686,
    "poblacio_2008": 927,
    "poblacio_1996": 938
  },
  {
    "code": "46110",
    "latitude": 39.464877867008600,
    "longitude": -0.430089996360887,
    "name": "Xirivella",
    "comarca": 18,
    "gentilici": "xiriveller, xirivellera",
    "poblacio_2025": 32093,
    "poblacio_2024": 31745,
    "poblacio_2023": 30749,
    "poblacio_2022": 30326,
    "poblacio_2021": 30208,
    "poblacio_2008": 30633,
    "poblacio_1996": 26478
  },
  {
    "code": "46261",
    "latitude": 39.383657099805500,
    "longitude": -0.809747738461656,
    "name": "Yátova",
    "comarca": 16,
    "gentilici": "iatovenc, iatovenca",
    "poblacio_2025": 2325,
    "poblacio_2024": 2242,
    "poblacio_2023": 2205,
    "poblacio_2022": 2169,
    "poblacio_2021": 2112,
    "poblacio_2008": 2166,
    "poblacio_1996": 2002
  },
  {
    "code": "46262",
    "latitude": 39.890804259458900,
    "longitude": -0.961529624892601,
    "name": "La Yesa",
    "comarca": 29,
    "gentilici": "iessà, iessana",
    "poblacio_2025": 246,
    "poblacio_2024": 235,
    "poblacio_2023": 235,
    "poblacio_2022": 227,
    "poblacio_2021": 230,
    "poblacio_2008": 259,
    "poblacio_1996": 303
  },
  {
    "code": "46263",
    "latitude": 39.091078314849800,
    "longitude": -1.075226553330220,
    "name": "Zarra",
    "comarca": 32,
    "gentilici": "sarrí, sarrina",
    "poblacio_2025": 374,
    "poblacio_2024": 386,
    "poblacio_2023": 364,
    "poblacio_2022": 370,
    "poblacio_2021": 364,
    "poblacio_2008": 547,
    "poblacio_1996": 438
  },
  {
    "code": "12141",
    "latitude": 40.728720824724200,
    "longitude": -0.166150498770426,
    "name": "Sorita",
    "comarca": 24,
    "gentilici": "sorità, soritana",
    "poblacio_2025": 118,
    "poblacio_2024": 111,
    "poblacio_2023": 117,
    "poblacio_2022": 107,
    "poblacio_2021": 116,
    "poblacio_2008": 152,
    "poblacio_1996": 146
  },
  {
    "code": "12142",
    "latitude": 40.132009220029200,
    "longitude": -0.419045103243744,
    "name": "Zucaina",
    "comarca": 5,
    "gentilici": "sucainer, sucainera",
    "poblacio_2025": 171,
    "poblacio_2024": 174,
    "poblacio_2023": 176,
    "poblacio_2022": 174,
    "poblacio_2021": 175,
    "poblacio_2008": 170,
    "poblacio_1996": 223
  }

];

export const townsWithImage = towns.filter((c) =>
  townCodesWithImage.includes(c.code.toLowerCase())
);


/*
export const smallTownLimit = 5000;
export const bigEnoughTownsWithImage = townsWithImage.filter(
  (town) => areas[town.code] > smallTownLimit
);
*/

export function getTownName(language: string, town: Town) {
  return town.name;
}

export function getTownComarca(language: string, town: Town) {
  return town.comarca;
}

export function getTownGentilici(language: string, town: Town) {
  return town.gentilici;
}

export function getTownPoblacio2025(language: string, town: Town) {
  return town.poblacio_2025;
}

export function getTownPoblacio2024(language: string, town: Town) {
  return town.poblacio_2024;
}

export function getTownPoblacio2023(language: string, town: Town) {
  return town.poblacio_2023;
}

export function getTownPoblacio2022(language: string, town: Town) {
  return town.poblacio_2022;
}

export function getTownPoblacio2021(language: string, town: Town) {
  return town.poblacio_2021;
}

export function getTownPoblacio2008(language: string, town: Town) {
  return town.poblacio_2008;
}

export function getTownPoblacio1996(language: string, town: Town) {
  return town.poblacio_1996;
}

export function sanitizeTownName(townName: string): string {
  return townName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[- '()]/g, "")
    .toLowerCase();
}
